(function (win) {
    'use strict';
    var msg = null;

    var staticPrefix = '/';
    var isStaticPage = function () {
        var url = document.location.pathname;
        var regExp = /(\/\w+\/)?static/;
        if (regExp.test(url)) {
            staticPrefix = url.match(regExp)[1] || '/';
            return true;
        } else {
            return false;
        }
    };

    function testForRequiredElements() {
        var required = {
            selectors: [
                '.content_inside',
                '.withdraw',
                'button.withdraw',
                'input.amount',
                '#lightbox',
                '.modalOverlay',
                '.payment_options_details',

                //TEMPLATES:
                '#confirmation',
                '#withdraw-canceled'
            ],
            keys: [
                'lightbox_confirm_title'
            ]
        };
        if (app.config.use_withdraw_split) {
            required.selectors.push('#orderSplit');
        }
        if (app.config.ptRequestId) {
            required.selectors.push('#casino_confirmation');
        }
        _.each(required.selectors, function (selector) {
            if ($(selector).length < 1) {
                console.warn('Element "' + selector + '" is Missing!')
            }
        });
    }

    var models = {
        user_payment_method: Backbone.Model.extend({
            defaults: {
                name: '',
                displayPaymentOptionName: '',
                paymentOptionName: '',
                card_type: '',
                uiOrder: ''
            },
            idAttribute: 'userPaymentOptionId'
        }),
        withdraw_req_item: Backbone.Model.extend({
            defaults: {
                "requestedAmount": '',
                "requestedCurrency": '',
                "creationDate": '',
                "state": '',
                "status": '',
                "orders": []
            },
            idAttribute: 'wd_requestId'
        })
    };
    var CONSTANTS = (function () {
        return {
            MAX_INT_AMOUNT_LEN : 8,
            WORKFLOW_TYPE_WD : 'WITHDRAW',
            DEVICE_TYPE        : {
                MOBILE  : 'mobile',
                DESKTOP : 'desktop'
            },
            HASH: {
                PM: '#/pm/',
                DETAILS: '#/details/',
                WITHDRAWALS: '#/withdrawals'
            },
            MESSAGES_MODE: {
                NONE: 'NONE',
                PLAYTECH: 'PLAYTECH',
                SAFECHARGE: 'SAFECHARGE'
            },
            PM_NAME: {
                CITADEL         : 'apmgw_Citadel',
                FASTER_PAYMENTS : 'apmgw_Faster_Payments',
                FBT             : 'apmgw_Fast_Bank_Transfer',
                FFBT            : 'apmgw_Faster_Bank_Transfer',
                MVP_NUVEI_CARD  : 'ppp_MVP',
                NPP             : 'apmgw_NPP',
                NUVEI_CARD      : 'nuvei_card',
                PAY_WITH_MY_BANK: 'apmgw_Online_Banking',
                PIX             : 'apmgw_PIX',
                PIX_BANK_TRANSFER: 'apmgw_PIX_BankTransfer',
                PIX_PAYOUTS     : 'apmgw_PIX_payouts',
                PLAY_PLUS       : 'apmgw_PlayPlus',
                PAY_WITH_CRYPTO : 'apmgw_PayWithCrypto'
            },
            USE_EXTRA_DETAILS_VIEW_PER_PM: {
                apmgw_PayWithCrypto: 1,
                apmgw_OKTO_CASH: 1,
                apmgw_OKTO_WALLET: 1,
                ppp_ManualWithdrawal: 1,
            },
            RTL_LOCALES: {
                'iw_IL': 1,
                'ar_AA': 1,
                'ar_QA': 1, // Quatar
                'ar_KW': 1, // Kuwait
                'ar_AE': 1, // United Arab Emirates
                'ar_SA': 1, // Saudi Arabia
                'ar_BH': 1, // Bahrain
                'ar_LB': 1, // Lebanon
                'ar_JO': 1, // Jordan
                'ar_EG': 1, // Egypt
                'ar_MA': 1, // Morocco
                'ar_OM': 1, // Oman
                'ar_TN': 1, // Tunisia
                'ar_DZ': 1, // Algeria
            },
            SRV_RESPONSE: {
                STATUS_FAIL: 'FAIL',
                STATUS_OK: 'OK',
                MSG_SESSION_EXPIRED: 'session_expired',
                PROP_CUSTOM_FEES: 'customFees'
            },
            FEE: {
                TYPE_ADDING: 'ADDING'
                // ,TYPE_DEDUCTION     : 'DEDUCTION'
                , VALUE_TYPE_FIXED: 'FIXED'
                // ,VALUE_TYPE_PERCENT : 'PERCENT'
            },
            MODAL_MESSAGE_TYPE: {
                SUCCESS: 'success',
                ERROR: 'error',
                FBT: 'fbt',
                ORDER_SPLIT: 'order_split',
                CONFIRM: 'confirm',
                CASINO_CONFIRM: 'casino_confirm',
                VALIDATION_BOX: 'validation_box'
            },
            VISIBILITY_MODE: {
                DISABLED: 'DISABLED',
                REQUIRED: 'REQUIRED',
                OPTIONAL: 'OPTIONAL',
                HIDDEN: 'HIDDEN'
            },
            METHOD_REGISTRATION_TYPE: {
                PRE_WITHDRAW: "PRE_WITHDRAW",
                ON_WITHDRAW: "ON_WITHDRAW"
            },
            ACCEPTED_CC_BY_PM: {
                ENTROPAY: {'entropay': 1},
                APMGW_ASTROPAYPREPAID: {'astropay_card': 1},
                NUVEI_CARD: {'nuvei_card': 1},
                BANCONTACT_CC_CARD: {'bancontact': 1}
            }
            ,PADDED_FIELDS: {
                expressConnect_transitNumber : {len : 5, pad_str : '0'},
                expressConnect_institutionNumber : {len : 3, pad_str : '0'}
            },
            CARD_LOGO_CLASSES: 'noneLogo master_cardLogo paydotcomLogo entropay_master_cardLogo entropay_visaLogo visaLogo diners_club_internationalLogo amexLogo jcbLogo discover_cardLogo maestroLogo switchLogo soloLogo laserLogo israeli_cardLogo mirLogo  dankortLogo dankort_visaLogo astropay_cardLogo nuvei_cardLogo bancontactLogo carte_bancaireLogo eftposLogo',
            VALIDATE_FIELD_ALTERNATIVE_MESSAGE_KEYS : [
                'minMsgKey', 'maxMsgKey', 'eCheckMsgKey',
                'restricted_cardTypeMsgKey', 'restricted_cardProductMsgKey', 'restricted_issuerCountryMsgKey', 'restricted_userCountryMsgKey',
                'restrictedCCMsgKey', 'restrictedCCCurrencyMsgKey', 'allowedCCMsgKey', 'restrictedCCCountryMsg',
                'invalidCpfMsgKey', 'invalidPhoneMsgKey', 'invalidEmailMsgKey', 'invalidChaveMsgKey', 'digitsOnlyMsgKey', 'restricted_bothBrandsMsgKey'
            ],
            PM_EXTRA_DATA_URL: {
                apmgw_VIP_Preferred: {url: "/ppp/getAccountDetails.do"},
                apmgw_PlayPlus: {url: "/ppp/getAccountDetails.do", params: {checkBalance: "false"}}
            },
            STATIC_PMS: {
                'ppp_MVP': 1,
                'ppp_in_casino': 1,
                'ppp_wt_salesforce': 1
            }
        };
    })();

    var isValidDate = function (year, month) {
        if (parseInt(month, 10) === 0) {
            return false;
        }
        var fullYear = parseInt(year, 10) + 2000;
        var expDate = new Date(fullYear, parseInt(month, 10), 1, 0, 0, 0);
        expDate.setMilliseconds(-1);
        return expDate.getTime() > _.now();
    };

    var _g = {};
    _g.defaultValidationFields = ['amount', 'pm-placeholder'];
    _g.validationFields = $.extend([], _g.defaultValidationFields);
    _g.pmFields = {};
    var validationsMap;
    var sendPostMessage = function (message, url) {
        console.log('Opened in iframe ', app.openedInIFrame);
        if (url) {
            console.log('postMessage', message, url);
            parent.postMessage(message, url);
        } else {
            console.log('postMessage', message, 'NOT SEND TO an empty url');
        }
    };

    var t = function (key, argsArray) {
        var locale = msg;
        var transKey = key;
        var obj = {};
        _.each(argsArray, function (v, i) {
            obj['{' + i + '}'] = v;
        });
        if (typeof  key === 'string') {
            if (key.indexOf("wd.error.") === 0) {
                locale = msg.errors;
                transKey = key.substring(9);
            } else if (key.indexOf("ptadapter.ims.error.") === 0) {
                locale = msg.errors;
                transKey = 'ims_err_' + key.substring(20);
            }
        }
        if (_.has(locale, transKey)) {
            transKey = locale[transKey];
        } else if (key && key.indexOf(".") > -1) {
            var tmp_transKey = locale;
            _.each(key.split("."), function (k, i) {
                if (k && _.has(tmp_transKey, k)) {
                    tmp_transKey = tmp_transKey[k];
                }
            });
            if (typeof  tmp_transKey === 'string') {
                transKey = tmp_transKey;
            }
        }
        transKey = transKey.replace(/(\{\d\})/g, function (text) {
	        return obj[text] != undefined ? obj[text] : '';
        });
        return transKey;
    };

    var validationFieldsMutator = (function () {
        function add(fldName, isOptional) {
            if (fldName && _g.validationFields && _g.validationFields.indexOf(fldName) === -1) {
                _g.validationFields.push(fldName);
                isOptional && (app._isOptionalField[fldName] = 1);
            }
            return _g.validationFields;
        }

        function remove(fldName, isOptional) {
            if (fldName && _g.validationFields && _g.validationFields.indexOf(fldName) > -1) {
                _.remove(_g.validationFields, function (f) {
                    return f === fldName;
                });
                isOptional && (app._isOptionalField[fldName] = 0);
                if (app._validationResult[fldName]){
                    delete app._validationResult[fldName]
                }
            }
            return _g.validationFields;
        }

        return {
            add: add,
            remove: remove
        };
    })();
    var validateField = function (fieldName, value, showResult) {
        var isValidField = true;
        if (_.isUndefined(value)) {
            console.log('Undefined FIELD = ', fieldName);
            if (showResult && fieldName && app.config.popupValidation) {
                onValidationResult(null, false, [fieldName], (msg.validation['undefined_field'] || 'Field is not defined'), 'undefined_field');
            }
            isValidField = false;
        } else if (_.has(validationsMap, fieldName)) {
            var value_trimmed = (value || '').trim();
            var suffix = app._isOptionalField[fieldName] ? '_opt' : '';
            if (suffix && !value_trimmed) {
                if (showResult) {
                    onValidationResult(null, true, [fieldName], null, null);
                }
                isValidField = true;
            } else {
                var checks = validationsMap[fieldName].checks;
                var partialCheck = _.every(checks, function (param, validatorKey) {
                    var params, isValid = true;
                    if (_.has(utils.checks, validatorKey)) {
                        params = app.util.normalizeValidationParamsObject(param, validatorKey);
                        isValid = utils.checks[validatorKey](value, params);
                    }
                    if (showResult) {
                        if (fieldName === "cc_exp_month" || fieldName === "cc_exp_year") {
                            onValidationResult(null, isValid, ["cc_exp_month", "cc_exp_year"], (params && params.message || ''), validatorKey);
                        } else {
                            onValidationResult(null, isValid, [fieldName], (params && params.message || ''), validatorKey);
                        }
                        if (!isValid) {
                            pubsub.publish('app.event.fieldBlurFail', [fieldName + suffix, validatorKey]);
                        }
                    }
                    return isValid;
                });
                isValidField = (isValidField && partialCheck);
            }
        }
        return isValidField;
    };
    var showValidationStatus = function (validationFieldsArr) {
        _.each(validationFieldsArr, function (fieldName) {
            var $input = $('input.' + fieldName);
            var alt_selectors = ['.' + fieldName + ' select', 'select.' + fieldName];
            _.each(alt_selectors, function (selector) {
                if (!$input.length) {
                    $input = $(selector);
                }
            });
            validateField(fieldName, $input.val(), true);
        });
    };
    var continuousValidation = function () {
        var asyncCheckCompleted = app.util.asyncCheck.isComplete();
        var isFormValid = asyncCheckCompleted;
        if (asyncCheckCompleted) {
            _.each(_g.validationFields, function (fieldName) {
                if (app._doNotSubmitFields[fieldName]) {
                    return;
                }
                var $input = $('input.' + fieldName);
                var alt_selectors = ['.' + fieldName + ' select', 'select.' + fieldName];
                _.each(alt_selectors, function (selector) {
                    if (!$input.length) {
                        $input = $(selector);
                    }
                });
                var partialCheck = validateField(fieldName, $input.val(), false);
                isFormValid = (isFormValid && partialCheck);
            });
        }
        if (isFormValid) {
            showValidationStatus(_g.validationFields);
        }
        return isFormValid;
    };
    var onValidationResult = function (activeElm, passed, fields, message, validatorKey) {
        _.each(fields || [], function (field) {
            if (passed && app._validationResult[field]) {
                delete app._validationResult[field];
            } else if (!passed) {
                app._validationResult[field] = {message: message, validatorKey: validatorKey};
            }
            if (app.config.popupValidation) {
                if (!app.config._hasError && !passed) {
                    app.config._hasError = 1;
                    var fieldName = $('input.' + field).attr('placeholder');
                    var payload = {
                        text: message,
                        field: fieldName || field
                    };
                    var tpl = app.util.getLightboxContentTemplate('validation_box');
                    app.showModalCustomMessage(tpl, 'validation_box', t("validation_error"), payload, function () {
                        app.config._hasError = 0;
                        // console.log("IN showModalCustomMessage ");
                    });
                }
            } else {
                var indicator = $('#' + field + '_validation');
                var parentRow = indicator.length ? indicator.closest('.row') : $('.' + field + '.form-control').closest('.row');      //activeElm.parent();

                if (passed) {
                    if (parentRow.length) {
                        parentRow.addClass('valid');
                        parentRow.removeClass('invalid');
                    }
                    indicator.empty();
                    indicator.removeClass('invalid_field');
                    indicator.addClass('valid_field');
                } else {
                    if (parentRow.length) {
                        parentRow.addClass('invalid');
                        parentRow.removeClass('valid');
                    }
                    indicator.removeClass('valid_field');
                    indicator.addClass('invalid_field');
                    indicator.empty().append('<label data-for="' + field + '" class="error">' + message + '</label>');
                }
                recalcUserDetailsArea();
            }
        });
    };
    win.showModalMessage = function (data, type) {
        var lightBoxElm = $("#lightbox");
        lightBoxElm.removeClass();
        if (type) {
            lightBoxElm.addClass(type);
        }
        if (type === CONSTANTS.MODAL_MESSAGE_TYPE.ERROR) {
            //$('.lightbox-header h2').text(app.msg['lightbox_title_fail']);
            //$('.lightbox-content').html(data.details || data.message);
        } else {
            $('.lightbox-header h2', lightBoxElm).html(data.message);
            $('.lightbox-content', lightBoxElm).html(data.details);
        }

        $(".content_inside").unblock();
        $.unblockUI();
        app.modalLink.trigger('click');
        pubsub.publish('lightbox.opened', [{type: type}]);
    };

    win.app = {
        CONSTANTS: CONSTANTS,
        _flag: {
            errorCode1082: false,
            withdrawalAllowed: false,
            shouldPreselectSamePmAfterWdCancelation: false,
            skipUpoMessage: {}
        },
        util: {
            injectDefaultCss : function() {
                var DisplayNoneSelector = ".hidden" +
                    ", .apple_pay_wrapp.hidden" +
                    ", body.has_ppoints.wd_open_amount .form-control.amount" +
                    ", body.has_ppoints.wd_open_amount #c_symbol";
                var cssObj = {
                    ".hidden, .apple_pay_wrapp.hidden, body.has_ppoints.wd_open_amount .form-control.amount, body.has_ppoints.wd_open_amount #c_symbol": {
                        display: 'none'
                    },
                    ".overall": {
                        width: "100%",
                        height: "100%"
                    },
                    ".sfc_paywithmybank_widget_iframe": {
                        "max-width": "100%"
                    },
                    "._invisible": {
                        visibility: "hidden"
                    },
                    "#whole_screen_overlay": {
                        position: "fixed",
                        width: "100%",
                        height: "100%",
                        top: '0',
                        left: '0',
                        "background-color": "rgba(10, 10, 10, 0.2)",
                        "z-index": "4"
                    }
                };
                var nuveiCardCcCardNumBgCss = convertNuveiCardLogoForCcCardNumber();
                if (nuveiCardCcCardNumBgCss) {
                    cssObj['input.nuvei_cardLogo#cc_card_number'] = {'background-image': nuveiCardCcCardNumBgCss};
                }
                cssObj[DisplayNoneSelector] = {
                    display: 'none'
                };
                $.injectCSS(cssObj);

                function convertNuveiCardLogoForCcCardNumber() {
                    if (app.config.pmSettings.nuvei_card.logoName) {
                        var $input = $('<input type="hidden" class="nuvei_cardLogo"/>');
                        $('body').append($input);
                        var backGrImg = $input.css('background-image').replace('mvp.svg', app.config.pmSettings.nuvei_card.logoName + '.svg');
                        $input.remove();
                        return backGrImg;
                    }
                }
            },
            loadMainLayout : function () {
                var htmlElm = $('html');
                var bodyElm = $('body');
                var themeLayout = $('#theme-layout');
                var layoutStates = {'0': 'onlyPM', '1': 'onlyList', '2': 'bothListPM'};
                if (themeLayout.length) {
                    bodyElm.empty().append(_.template(themeLayout.text())(app));
                }
                if (!bodyElm.find('#lightbox').length) {
                    bodyElm.append($(app.config.modalsConfig.mainTemplate));
                }
                if (!bodyElm.find('.pm-placeholder').length) {
                    bodyElm.append($('<input type="hidden" class="pm-placeholder"/>'));
                }

                var htmlClasses = 'wd ' + app.config.merchantLocale;
                if (app.config.zoomFactor && (htmlElm.attr('class') || '').indexOf('zoom-factor-') !== -1) {
                    htmlClasses += ' zoom-factor-' + app.config.zoomFactor;
                }
                var bodyClasses = layoutStates[app.config.layout] || '';
                bodyClasses += app.config.wd_open_amount ? ' wd_open_amount' : ' wd_fixed_amount';
                bodyClasses += CONSTANTS.RTL_LOCALES[app.config.merchantLocale] ? ' rtl' : '';

                htmlElm.addClass(htmlClasses);
                bodyElm.addClass(bodyClasses).removeClass('display_none');
            },
            applySuggestPointsPlugin : function () {
                app.suggestPointsPlugin = 0;
                if (app.config.wd_open_amount) {
                    var $suggestElm = $('.suggested-amounts-holder');
                    if ($suggestElm.length) {
                        if (!app.suggestPointsPlugin || app.suggestPointsPlugin.element !== $suggestElm[0]) {
                            var suggestMode = $suggestElm.data('mode') || 'Points';
                            var suggestPointsParams = $.extend(true, {
                                data: [],
                                currency: app.config.wd_currency,
                                onChange: function (oldVal, newValue) {
                                    var itemAmountElement = $('input.amount');
                                    var currentValue = itemAmountElement.val();
                                    if (parseFloat(currentValue) - newValue !== 0) {
                                        newValue = newValue || '';
                                        app.util.setAmountValue(newValue, ['setValue', 'blur'], 'suggestPoints');
                                        app.config.wd_amount = newValue;
                                        app.util.handleFee(app.current_pm_feeObj);
                                    }
                                }
                            }, app.pluginOpts['suggest' + suggestMode]);
                            app.suggestPointsPlugin = $suggestElm['suggest' + suggestMode](
                                suggestPointsParams
                            ).data('plugin_suggest' + suggestMode);
                        }
                    }
                }
                return app.suggestPointsPlugin;
            },
            toggleSPointsClass : function (hasSuggestedAmounts, hasPricePoints) {
                var classes = {
                    toAdd: '',
                    toRemove: '', // prevent remove all classes
                };
                classes[(hasPricePoints ? 'toAdd' : 'toRemove')] += ' has_ppoints';
                classes[((app.suggestPointsPlugin && hasSuggestedAmounts) ? 'toAdd' : 'toRemove')] += ' has_spoints';
                app.bodyElm.removeClass(classes.toRemove).addClass(classes.toAdd);
                app.recalcUserDetailsArea();
            },
            normalizeValidationParamsObject : function (param, validatorKey) {
                var params = $.extend(true, {}, param);
                params.formatter = app.formatter;
                params.roundingScale = app.config.roundingScale;
                params.message = msg.validation[params.msgKey] || params.msgKey || '';
                params.currencyIso = (app.lastSelectedCurrency || app.config.wd_currency);
                params.currency = app.util.remapCurrency(params.currencyIso);
                params.country = app.config.country;
                _.each(CONSTANTS.VALIDATE_FIELD_ALTERNATIVE_MESSAGE_KEYS, function (key) {
                    if (params.hasOwnProperty(key)) {
                        params[key.replace('Key', '')] = msg.validation[params[key]] || params[key] || '';
                    }
                });
                if (params.useCurrentState) {
                    var limits = app._currentPMLimits.amountLimits || $.extend(true, {}, app.defaultLimits);
                    params.min = limits.minValue;
                    params.max = limits.maxValue;
                    params.currency = params.currency || limits.currencyIso;
                    if (app.current_pm_feeObj
                        && app.current_pm_feeObj.feeType !== CONSTANTS.FEE.TYPE_ADDING
                        && app.current_pm_feeObj.feeValueType === CONSTANTS.FEE.VALUE_TYPE_FIXED
                    ) {
                        params.min = Math.max(limits.minValue, (app.current_pm_feeObj.feeValue || 0) + 0.01);
                    }
                }
                if (validatorKey === 'testCVV2') {
                    params.alt_message = msg.validation[params.unknownCCMsgKey];
                    params.cc_type = app.util.getCurrentCardType();
                } else if ('isCardAcceptable' === validatorKey || 'isValidCardNumber' === validatorKey || 'isCurrencySupportedByTheCard' === validatorKey) {
                    var cc_card = app.util.getCurrentCardType(true);
                    params.cc_brand = cc_card.is_dual_brand ? app.lastCardDetected : cc_card.master_brand;
                    params.cardInfo = cc_card;
                    params.cc_brand_label = (msg[params.cc_brand] || "This");
                    params.invalidCardIssuers = app.config.invalidCardIssuers;
                    params.cardSupportedCurrencies = app.config.cardSupportedCurrencies;
                    params.allowedCardCountries = app.config.allowedCardCountries;
                    if (CONSTANTS.ACCEPTED_CC_BY_PM[app.current_pm_name.toUpperCase()]) {
                        params.slave_cc_brand = cc_card.slave_brand || cc_card.master_brand;
                        params.slave_cc_brand_label = (msg[params.slave_cc_brand] || "This");
                        params.validCardIssuers = CONSTANTS.ACCEPTED_CC_BY_PM[app.current_pm_name.toUpperCase()];
                    }
                    params.isAstropayPrePaid = ("apmgw_AstropayPrePaid" === app.current_pm_name);
                }
                return params;
            },
            getCurrentCardType : function (returnFullData) {
                var cc_type = 'none';
                var retObj = {master_brand : 'none'};
                var $cardNumberElm = $('input.cc_card_number');
                var cardNumber = $cardNumberElm.length ? $cardNumberElm.val().replace(/ /g, '') : '';
                if (cardNumber) {
                    var cardInfo = app.util.asyncCheck.getCardInfo(cardNumber);
                    retObj = cardInfo ? _extractCardInfo(cardInfo) : _checkCardType(cardNumber);
                    cc_type = retObj.master_brand;
                } else if (app._upoList[app.lastSelectedMethodId] && app._upoList[app.lastSelectedMethodId].card_type) {
                    retObj  = _extractCardInfo(app._upoList[app.lastSelectedMethodId]);
                    cc_type = app._upoList[app.lastSelectedMethodId].card_type;
                }
                if (retObj.is_dual_brand && (retObj.master_brand === app.lastCardDetected || retObj.slave_brand === app.lastCardDetected)) {
                    cc_type = app.lastCardDetected;
                }

                return returnFullData ? retObj : cc_type;

                function _extractCardInfo(_cardInfo) {
                    _cardInfo = _cardInfo || {};
                    var cardBrand = _cardInfo.cardBrand || _cardInfo.card_type,
                        server_class = cardBrand;

                    if (_cardInfo.isDualBrand) {
                        if (cardBrand === app.lastCardDetected) {
                            server_class = cardBrand + '_' + _cardInfo.cardBrand2
                        }
                        else if (_cardInfo.cardBrand2 === app.lastCardDetected) {
                            server_class = _cardInfo.cardBrand2 + '_' + cardBrand;
                        }
                    }

                    return {
                        full_class      : server_class + (_cardInfo.isDualBrand ? "_dual" : ""),
                        server_class    : server_class,
                        master_brand    : cardBrand,
                        slave_brand     : _cardInfo.cardBrand2 || cardBrand,
                        is_dual_brand	: _cardInfo.isDualBrand
                    };
                }
            },
            normalizePluginOpts : function (opts) {
                if (opts && opts.cssCreator) {
                    if (!opts.cssCreator.language) {
                        opts.cssCreator.language = app.config.merchantLocale.substr(0, 2);
                    }
                    if (app.config.pmSettings.nuvei_card.logoName) {
                        if (opts.cssCreator.pmLogos && !opts.cssCreator.pmLogos.nuvei_card) {
                            opts.cssCreator.pmLogos.nuvei_card = app.config.pmSettings.nuvei_card.logoName;
                        } else if (!opts.cssCreator.pmLogos) {
                            opts.cssCreator.pmLogos = {nuvei_card: app.config.pmSettings.nuvei_card.logoName};
                        }
                    }
                }
                return opts;
            },
            postMessageListener: (function () {
                var _hasPostMsgListener;
                return function () {
                    if (_hasPostMsgListener) {
                        return;
                    }
                    _hasPostMsgListener = true;
                    window.addEventListener('message', function (e) {
                        var data = e.data;
                        try {
                            data = JSON.parse(e.data);
                        } catch (er) {
                        }
                        if (!data || data.action === 'analytics') {
                            return;
                        }
                        var isFromFriendlyOrigin = (app.config.friendlyOrigins[e.origin] || e.origin === document.location.origin);
                        var isFromLegitParent = (e.origin === document.location.origin || e.origin === app.config.parentUrl || app.config.parentUrl === '*');
                        if (app.config.useAmountListener && data.amountValue && isFromLegitParent) {
                            app.util.setAmountValue(data.amountValue, ['setValue', 'blur'], 'postMessageListener');
                        } else if (data.closeLightbox === 'lbx_scc_terms') {
                            /* when scc_terms are in separate lbx */
                            $('#lightbox.lbx_scc_terms .modal_close').trigger('click');
                            /* when scc_terms are inside the confirmation lbx */
                            $('#lightbox #confirmation_footer').empty();
                        } else if (data.action === 'close_pm_redirect_iframe'
                            && data.closeLightbox && data.closeLightbox.startsWith('lbx_')
                            && isFromFriendlyOrigin
                        ) {
                            $('#lightbox.pm_redirect.' + data.closeLightbox + ' .modal_close').trigger('click');
                        } else if (data.sender === "bank_capturing"
                            && data.status === "FAIL" && data.errorCode === "CANCELLED_FROM_USER"
                            && isFromFriendlyOrigin
                        ) {
                            pubsub.publish('safecharge.wd_transaction.complete', [data]);
                        } else if (data.action === 'appReturnLinkUsed' && isFromLegitParent) {
                            app.util.onAppReturnLinkUsed();
                        } else if (data.iframeName && data.sender === "pwmb_frame") {
                            utils.pwmb.onMessage(data, e.origin);
                        }
                    });
                }
            })(),
            onAppReturnLinkUsed: function () {
                if (app.config.appReturnLink
                    && app.config.nativeAppFlow === '1'
                    && app.util.shouldOpenInExternalBrowser(app.submittedMethod && app.submittedMethod.id)
                ) {
                    if (app._preWdParamId) {
                        var url = "/ppp/withdrawal/registrationStatus?ssid=" + app.config.ssid + "&paramId=" + app._preWdParamId;
                        $.ajax({
                            type: "GET",
                            url: url,
                            contentType: 'application/json',
                            dataType: 'json',
                            timeout: 5000
                        }).done(function (resp) {
                            var upo_id = resp && resp.upo && resp.upo.userPaymentOptionId;
                            upo_id && (app._upoList[upo_id] = resp.upo);
                            pubsub.publish('safecharge.wd_transaction.complete', [resp]); // app.util.handleTrxCompleteStatus_OK(resp)
                        }).fail(function (er) {
                            $.unblockUI();
                            app.showModalErrorMessage('wd.error.session_expired');
                        });
                        app._preWdParamId = false;
                    } else {
                        $(".content_inside").unblock();
                        $.unblockUI();
                        app.util.clearFormAmountState();
                        app.submittedMethod = false;
                        app.stores.user_payment_methods.fetch({reset: true});
                        app.stores.withdraw_requests.fetch({reset: true});
                    }
                }
            },
            clearFormAmountState: function () {
                var $amount_validation = $('#amount_validation');
                $amount_validation.empty().removeClass('invalid_field, valid_field');
                $amount_validation.closest('.row').removeClass('invalid, valid');
                $('.cSelect[data-id="amount_select"]').remove();
                if($('input.amount').not("[type=hidden]").length) {
                    app.util.setAmountValue("", ['setValue'], 'clearFormAmountState');
                }
                app.suggestPointsPlugin && app.suggestPointsPlugin.setData([]);
                var isValid = app.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
            },
            closeLightbox: function () {
                $('body').removeClass('overflowed');
                $('#lightbox').hide().removeClass();
                $('.modalOverlay').fadeOut();
                $('.content_inside').unblock();
                app.onNotificationEnd();
            },
            getWithdrawalAllowedUrl: function (pmName) {
                var url = "/ppp/withdrawal/checkWithdrawalAllowed.do?paymentOptionName=" + pmName + "&domain=";
                // <MOCK> mock some data and work offline
                if (isStaticPage()) {
                    url = staticPrefix + "static/withdrawal/checkWithdrawalAllowedDo?paymentOptionName=" + pmName + "&domain=";
                } // </MOCK>
                url += document.location.origin;
                url += _.reduce(
                    ['wd_amount', 'wd_currency', 'merchant_id', 'merchant_site_id', 'ptRequestId', 'ssid'],
                    function (str, item) {
                        return [str, '&', item, '=', app.config[item]].join('');
                    },
                    '');
                return url;
            },
            filterCitadelFields: function (pmFieldsObj, countryISO) {
                countryISO = countryISO || app.config.country || '';
                var citadelRestrictedFiels = {
                    'DEFAULT': ['citadel_account_numberCA', 'citadel_account_numberAU', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_branch_codeAU', 'citadel_ibanMX'],// 1.2.3.4.5
                    'CA': ['citadel_iban', 'citadel_swift_code', 'citadel_account_numberAU', 'citadel_branch_codeAU', 'citadel_ibanMX'], 										// 1.4.5.6.8.9
                    'AU': ['citadel_iban', 'citadel_swift_code', 'citadel_account_numberCA', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_ibanMX'],					// 1.4.5.7.10
                    'MX': ['citadel_iban', 'citadel_swift_code', 'citadel_bank_city', 'citadel_account_numberCA', 'citadel_account_numberAU', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_branch_codeAU']	// 1.5.11
                };
                var restrictedFields = citadelRestrictedFiels[countryISO] || citadelRestrictedFiels['DEFAULT'];
                var result = {};
                _.each(pmFieldsObj, function (obj, key) {
                    if (_.indexOf(restrictedFields, key) < 0) {
                        result[key] = obj;
                    }
                });
                return result;
            },
            changeVisibilityMode: function (dataObj, state) {
                var result = {};
                _.each(dataObj, function (obj, key) {
                    result[key] = obj;
                    if (_.has(obj, 'visibilityMode')) {
                        result[key].visibilityMode = state;
                    }
                });
                return result;
            },
            remapCurrency: function (currency) {
                var currencyMap = {
                    'eur': '€', 'usd': '$', 'gbp': '£', 'yen': '¥', 'ils': '₪', 'inr': '₹', 'rub': '₽', 'try': '₺',
                    'cny': '¥', 'krw': '₩', 'zar': 'R', 'brl': 'R$'
                };
                return currencyMap[currency.toLowerCase()] || currency.toUpperCase();
            },
            simpleDecimalFormatter  : function (amount, currency, precision, toFixed) {
                precision = (precision !== undefined) ? precision : app.config.roundingScale;
                var thousandsSeparator = app.config.thousandsSeparator || '';
                var useFloatingFraction = (toFixed !== undefined) ? !toFixed : true;
                return utils.formatAmount(amount, precision, thousandsSeparator, useFloatingFraction);
            },
            simpleCurrencyFormatter : function (amount, currency, precision, toFixed) {
                var currencyIsoSeparator = app.config.currencyIsoSeparator || '';
                var cSymbol = currency ? app.util.remapCurrency(currency) : '';
                if (cSymbol && cSymbol === currency) {
                    cSymbol += currencyIsoSeparator;
                }
                return cSymbol + app.util.simpleDecimalFormatter(amount, currency, precision, toFixed);
            },
            getFormatter            : function (useIntlFormatter) {
                if (useIntlFormatter) {
                    var formatterOptions = $.extend(true, {simpleCurrencyFormatter : app.util.simpleCurrencyFormatter}, app.pluginOpts.IntlFormatter);
                    return utils.getIntlFormatter(app.config.merchantLocale, app.config.wd_currency, formatterOptions);
                } else {
                    return {
                        formatDecimal             : app.util.simpleDecimalFormatter,
                        formatCurrency            : app.util.simpleCurrencyFormatter,
                        getCurrencySymbol         : function (currency) {
                            return app.util.simpleCurrencyFormatter(0, currency, 0, true).replace('0', '').trim();
                        },
                        isRightPositionedCurrency : function (currency) {
                            return app.util.simpleCurrencyFormatter(0, currency, 0, true).startsWith('0');
                        }
                    };
                }
            },
            dateFormatter : function(date, separator) {
                if(isNaN(parseInt(date))) {
                    return date;
                }
                date = new Date(parseInt(date));
                separator  = separator || '-';
                return date.getFullYear() + separator + (date.getMonth() + 1) + separator + date.getDate();
            },
            prepareCancelWdrLbxData: function (data) {
                var wdrRequestData = app.stores.withdraw_requests._byId[data.id] && app.stores.withdraw_requests._byId[data.id].attributes;
                if(!wdrRequestData) {
                    return {};
                }
                var payload = {
                    poName:   '',
                    upoName:  '',
                    amount:   wdrRequestData.requestedAmount,
                    currency: wdrRequestData.requestedCurrency,
                    date:     app.util.dateFormatter(wdrRequestData.creationDate)
                }
                if(wdrRequestData.params &&  wdrRequestData.params.length) {
                    if(wdrRequestData.params.poDisplayName) {
                        payload.poName = wdrRequestData.params.poDisplayName;
                    }
                    if(wdrRequestData.params.upoName) {
                        payload.upoName = wdrRequestData.params.upoName;
                    }
                } else if (wdrRequestData.orders && wdrRequestData.orders[0]) {
                    if(app.locale[wdrRequestData.orders[0].poName]) {
                        payload.poName = app.locale[wdrRequestData.orders[0].poName];
                        payload.upoName = wdrRequestData.orders[0].upoName;
                    }
                }

                return payload;
            },
            // Proper but currently UNUSED method
            getCustomLimitsAndFees: function (cb) {
                var url = "/ppp/getCustomLimistAndFees.do";
                var data = {
                    msid: app.config.merchant_site_id,
                    ssid: app.config.ssid,
                    type: 0,
                    paymentMethod: app.current_pm_name
                };

                $.ajax({
                    url: url,
                    data: data,
                    dataType: "json",
                    success: cb,
                    error: cb
                });
            },
            setLabelOpenAmountRangeHeader: function (amountLimits, currency) {
                var newHeader = '';
                if (_.isEmpty(amountLimits)) {
                    newHeader = '&nbsp;';
                } else if (!app.config.wd_open_amount) {
                    newHeader = msg['withdraw_funds_details']
                        .replace('({0}', '')
                        .replace('{1})', '')
                        .replace(' - ', '');
                } else {
                    var minAmount = app.formatter.formatCurrency(amountLimits['minValue'], currency, app.config.roundingScale);
                    var maxAmount = app.formatter.formatCurrency(amountLimits['maxValue'], currency, app.config.roundingScale);
                    newHeader = msg['withdraw_funds_details']
                        .replace(' - ', '&nbsp;-&nbsp;')
                        .replace('{0}', minAmount)
                        .replace('{1}', maxAmount);
                }
                $('.withdraw-limit-text').html(newHeader);
            },
            setAmountValue: function (val, eventsArr, source) {
                var events = eventsArr || ['setValue', 'change', 'blur'];
                var amountElm =  $('input.amount');
                amountElm.val(val);
                _.each(events, function(ev) {
                    amountElm.trigger(ev);
                });

                if(app.util.maskedItemAmountPlugin && _.isFunction(app.util.maskedItemAmountPlugin.setValue) && source !== 'maskedAmount') {
                    app.util.maskedItemAmountPlugin.setValue(val);
                }
            },
            updatePMLimits: function (limits, pm_name, currency, sAmounts, pPoints) {
                var newObj = {};
                var minAmount = !_.isEmpty(limits) && limits["minAmount"];
                var minValue = !_.isEmpty(limits) && limits["minValue"];
                var hasMinAmount = (minAmount === 0 || minAmount || minValue === 0 || minValue);
                if (hasMinAmount
                    && (limits["maxAmount"] || limits["maxValue"])
                    && pm_name === app.current_pm_name
                    && currency === app.lastSelectedCurrency) {
                    var defaultAmount = limits["defaultAmount"] || app.config.wd_amount;
                    //TODO: handle case when ( limits.currency || limits.currencyIso !== app.lastSelectedCurrency )
                    newObj['amountLimits'] = {
                        currencyIso: currency,
                        maxValue: limits["maxAmount"] || limits["maxValue"],
                        minValue: limits["minAmount"] || limits["minValue"] || 0,
                        defaultAmount: defaultAmount
                    };

                    //// None PT
                    if (limits['pricePoints']) {
                        var pricePoints = [];
                        var ppOnlyArray = _.filter(limits['pricePoints'], {'type': "PRICE_POINT"});
                        var collection = ppOnlyArray.length ? ppOnlyArray : limits['pricePoints'];
                        var newObjKey = ppOnlyArray.length ? 'pricePoints' : 'suggestedAmounts';
                        _.each(collection, function (item) {
                            pricePoints.push({
                                currencyIso: currency,
                                pointValue: item.value,
                                active: (item.value === defaultAmount)
                            });
                        });
                        if (pricePoints.length > 0) {
                            newObj[newObjKey] = pricePoints;
                            //if(newObjKey === 'pricePoints'){ //// Create proper suggestedAmounts:
                            //	newObj['suggestedAmounts'] = pricePoints.slice(0,6); // _.slice(pricePoints, 0, 6);
                            //}
                        }
                    }
                    //// PT - limits ~= amountLimits;
                    else if (pPoints && pPoints.length > 0) {
                        newObj.pricePoints = pPoints;
                    } else if (sAmounts && sAmounts.length > 0) {
                        newObj.suggestedAmounts = sAmounts;
                    }
                } else {
                    // Use Default Limits
                    newObj['amountLimits'] = $.extend(true, {}, app.defaultLimits);
                }
                if (app.config.alignAmountLimitsWithWdrBalance && app.config.withdrawable_balance !== '') {
                    var wdrBalance = parseFloat(app.config.withdrawable_balance);
                    if (!isNaN(wdrBalance) && wdrBalance < newObj.amountLimits.maxValue && wdrBalance >= newObj.amountLimits.minValue) {
                        newObj.amountLimits.maxValue = wdrBalance;
                    }
                }
                app._currentPMLimits = newObj;
                return app._currentPMLimits;
            },
            setMinMaxLimits: function (amountLimits, hasPricePoints) {
                if (amountLimits && !_.isEmpty(amountLimits)) {
                    var itemAmountElm = $('input.form-control.amount');
                    itemAmountElm = itemAmountElm.length ? itemAmountElm : $('input.amount');
                    itemAmountElm.attr('min', amountLimits['minValue']);
                    itemAmountElm.attr('max', amountLimits['maxValue']);
                    var maxIntLen = Math.min((parseInt(amountLimits['maxValue']) + '').length, CONSTANTS.MAX_INT_AMOUNT_LEN);

                    if (itemAmountElm.attr('type') !== 'number') {
                        var numberMaskOpts = {
                            type: app.config.roundingScale === 0 ? 'int' : 'float',
                            beforePoint: maxIntLen,
                            afterPoint: app.config.roundingScale,
                            decimalMark: '.'
                        };
                        var plugin = $.data(itemAmountElm[0], 'plugin_numberMask');
                        if (plugin) {
                            plugin.setNumberMask(numberMaskOpts);
                        } else {
                            itemAmountElm.numberMask(numberMaskOpts);
                        }
                    }

                    if(app.util.maskedItemAmountPlugin && !hasPricePoints) {
                        app.util.maskedItemAmountPlugin.createMask({
                            maxLength: maxIntLen
                        });
                        $('#masked_item_amount_1').prop('min', amountLimits['minValue'])
                                                  .prop('max', amountLimits['maxValue']);

                        app.bodyElm.addClass('use_masked_amount');
                    }

                    if (validationsMap
                        && validationsMap.amount
                        && validationsMap.amount.checks
                        && validationsMap.amount.checks.inRange) {
                        validationsMap.amount.checks.inRange.min = amountLimits.minValue;
                        validationsMap.amount.checks.inRange.max = amountLimits.maxValue;
                    }
                }
            },
            getFeeRenderingData: function (feeObj, raw_amount, currency) {
                if (!_.isEmpty(feeObj) && raw_amount) {
                    var amount = parseFloat(raw_amount);
                    var fee_value = parseFloat(feeObj.feeValue);
                    var fee_amount = 0, net_amount = 0, total_amount = 0, isInRange = 1;

                    if (amount > 0) {
                        if (feeObj.feeValueType === CONSTANTS.FEE.VALUE_TYPE_FIXED) {
                            fee_amount = parseFloat(fee_value);
                        } else {
                            fee_amount = Math.round((amount * fee_value)) / 100;
                        }

                        if (feeObj.feeMinValue && (parseFloat(feeObj.feeMinValue) > fee_amount)) {
                            fee_amount = parseFloat(feeObj.feeMinValue);
                            isInRange = 0;
                        } else if (feeObj.feeMaxValue && (fee_amount > parseFloat(feeObj.feeMaxValue))) {
                            fee_amount = parseFloat(feeObj.feeMaxValue);
                            isInRange = 0;
                        }

                        if (feeObj.noFeeAmount && (amount >= parseFloat(feeObj.noFeeAmount))) {
                            fee_amount = 0;
                            isInRange = 0;
                        }

                        if (feeObj.feeType === CONSTANTS.FEE.TYPE_ADDING) {
                            net_amount = amount;
                            total_amount = amount + fee_amount;
                        } else {
                            net_amount = amount - fee_amount;
                            total_amount = amount;
                        }
                    }
                    // ??? // net_amount = (net_amount >= 0) ? net_amount : 0;
                    var roundingScale = app.config.roundingScale;
                    var fee_value_roundingScale = (feeObj.feeValueType !== CONSTANTS.FEE.VALUE_TYPE_FIXED && isInRange) ? 2 : roundingScale;
                    return {
                        feeType      : feeObj.feeType,
                        feeValueType : feeObj.feeValueType,
                        fee          : fee_value.toFixed(fee_value_roundingScale),
                        amount       : (amount || 0).toFixed(roundingScale),
                        fee_amount   : fee_amount.toFixed(roundingScale),
                        net_amount   : net_amount.toFixed(roundingScale),
                        total_amount : total_amount.toFixed(roundingScale),
                        is_in_range  : isInRange,
                        currency     : currency ? app.util.remapCurrency(currency) : '',
                        currencyIso  : currency || '',
                        raw          : {
                            amount         : amount || 0,
                            fee_amount     : fee_amount,
                            net_amount     : net_amount,
                            total_amount   : total_amount,
                            no_fee_amount  : feeObj.noFeeAmount,
                            fee_min_amount : feeObj.feeMinValue && parseFloat(feeObj.feeMinValue),
                            fee_max_amount : feeObj.feeMaxValue && parseFloat(feeObj.feeMaxValue)
                        }
                    };
                }
                return false;
            },
            handleFee: function (feeObj) {
                var $feeWrapper = $('#fee-wrapper');
                if (_.isEmpty(feeObj)) { // CLEAR STATE
                    //$('#feeValue').remove();
                    app.current_pm_feeObj = feeObj;
                    $feeWrapper.empty();
                    return;
                }
                var amount = parseFloat($('input.amount').val());
                var tpl = {
                    old  : '<div><% if(feeValueType !== "FIXED" && is_in_range){%><strong><%-fee%> % <%-t("fee")%></strong> <%}else{%> ' +
                        '<strong><%-t("fee")%></strong> (<%- currency %>) <span><%- fee_amount %></span><%}%></div>' +
                        '<div> <% if(feeType === "ADDING"){ %>' +
                        '<strong><%-t("total_amount")%>:</strong> (<%- currency %>) <span><%- total_amount %></span>' +
                        '<%} else {%>' +
                        '<strong><%-t("net_amount")%>:</strong> (<%- currency %>) <span><%- net_amount %></span><%}%></div>'
                    ,
                    intl : '<div><% if(feeValueType !== "FIXED" && is_in_range){%><strong><%-fee%> % <%-t("fee")%></strong> <%}else{%> ' +
                        '<strong><%-t("fee")%></strong> <span><%- c.formatCurrency(raw.fee_amount, currencyIso)%></span><%}%></div>' +
                        '<div> <% if(feeType === "ADDING"){ %>' +
                        '<strong><%-t("total_amount")%></strong> <span><%- c.formatCurrency(raw.total_amount, currencyIso)%></span>' +
                        '<%} else {%>' +
                        '<strong><%-t("net_amount")%></strong> <span><%- c.formatCurrency(raw.net_amount, currencyIso)%></span><%}%></div>'
                };
                var $customFeeTemplate = $('#fees');
                var fee_tpl_txt = ($customFeeTemplate.length ? $customFeeTemplate.text() : (app.config.useIntlFormatter ? tpl.intl : tpl.old));
                var payload = app.util.getFeeRenderingData(feeObj, amount, app.lastSelectedCurrency);
                var html = payload ? _.template(fee_tpl_txt)(payload) : '';
                $feeWrapper.html(html);
            },
            updateFeeObj: function (response) {
                if (response && response[CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES]) {
                    app.current_pm_feeObj = response[CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES];
                } else {
                    app.current_pm_feeObj = {};
                }
                return app.current_pm_feeObj;
            },
            applyFixedAmountRestrictions: function () {
                if (!app.config.wd_open_amount) {
                    $('input.amount').attr('type', 'hidden');
                    app.util.setAmountValue(app.config.wd_amount, ['setValue'], 'applyFixedAmountRestrictions');

                    $('.amount-container .fixed-amount-container').remove();
                    var currencyLabel = app.util.remapCurrency(app.lastSelectedCurrency);
                    var formattedAmount = app.config.useIntlFormatter ? app.formatter.formatCurrency(app.config.wd_amount, app.lastSelectedCurrency) : '<span class="fixed-amount-currency">' + currencyLabel + '</span>' + app.config.wd_amount + '</div>';
                    var $fixedAmountElm = $('<div class="fixed-amount-container"><div class="fixed-amount-label">' + app.locale.total_amount +
                        '</div><div class="fixed-amount-value">' + formattedAmount + '</div></div>');
                    $('.amount-container').append($fixedAmountElm);
                }
            },
            applyLimitsAndFees: function (data, feeObj) {
                $('.cSelect[data-id="amount_select"]').remove();
                var $amount_elm = $('input.amount');
                var hasPricePoints = data.pricePoints && data.pricePoints.length;

                app.util.setMinMaxLimits(data.amountLimits, hasPricePoints); // fix
                app.util.setLabelOpenAmountRangeHeader(data.amountLimits, app.lastSelectedCurrency);
                if (hasPricePoints) {
                    _setPricePoints(data.pricePoints, true);
                    _updateSuggestPoints(data.suggestedAmounts);
                } else {
                    if (!app.config.ptRequestId && data.amountLimits && data.amountLimits.defaultAmount) {
                        app.util.setAmountValue(data.amountLimits.defaultAmount, ['setValue', 'blur'], 'applyLimitsAndFees');
                    }
                    var amount_val = $amount_elm.val();
                    if (amount_val !== "") {
                        validateField("amount", amount_val, true);
                    }
                    _updateSuggestPoints(data.suggestedAmounts);
                }
                app.util.toggleSPointsClass(data.suggestedAmounts && data.suggestedAmounts.length, data.pricePoints && data.pricePoints.length);
                app.util.handleFee(feeObj);

                /***************  applyLimitsAndFees helpers Start  *************/
                function _setPricePoints(pricePoints, showValidation) {
                    if (app.config.wd_open_amount && pricePoints && pricePoints.length) {
                        var $cSelect = $('<select data-plugin="cSelect" id="amount_select" class="open_amount_input" name="amount_select"/>');
                        _.each(pricePoints, function (item) {
                            var opt_txt = item['pointText'] !== undefined ? item['pointText'] : (app.config.useIntlFormatter ? app.formatter.formatCurrency(item['pointValue']) : item['pointValue']);
                            $('<option/>', {value: item['pointValue'], text: opt_txt}).appendTo($cSelect);
                        });
                        $amount_elm.parent().append($cSelect);
                        $cSelect.on('change setValue', function (e) {
                            /* update amount field properly */
                            if ($amount_elm.val() !== this.value) {
                                app.util.setAmountValue(this.value, [e.type], 'setPricePoints');
                                app.config.wd_amount = this.value;
                                app.util.handleFee(feeObj);
                            }
                        });
                        var activePricePointIdx = (_.findIndex(pricePoints, 'active') >= 0) ? _.findIndex(pricePoints, 'active') : 0;
                        var suggestedValue = pricePoints[activePricePointIdx]['pointValue'];
                        $cSelect.val(suggestedValue).trigger('setValue');
                        app.applycSelectPlugin();
                    }
                }
                function _updateSuggestPoints (suggestedAmounts) {
                    if (app.suggestPointsPlugin) {
                        var plainValues = _.map(suggestedAmounts, function (item) {
                            return item['pointValue'] || 0;
                        }) || [];
                        app.suggestPointsPlugin.setData(plainValues, app.config.wd_currency);
                        app.suggestPointsPlugin.setValue(parseFloat($amount_elm.val()));
                    }
                }
                /***************  applyLimitsAndFees helpers End  *************/
            },
            getLightboxContentTemplate: function (templateName) {
                var msg_tpl_text = {
                    error_fatal: '<%= t( message ) %>',
                    error_session_expired: '<%= t( message ) %>',
                    error: '<%= t( message ) %> <div class="actions"><button class="modal_close btn"><%- t("lightbox_button_ok") %></button></div>',
                    error_fatal_html: '<div><%_.each(message, function(v){%><%= v %><%});%></div>',
                    // Do we need this?
                    warning: '<% if (_.isArray(message.blockers) && !_.isEmpty(message.blockers)) { %>' +
                        '<div id="lb_blocked_method_messages_list">' +
                        '<% _.each(message.blockers, function(val, key) { %>' +
                        '<p><%= t(val) %></p>' +
                        '<% }); %>' +
                        '</div>' +
                        '<% } else { %>' +
                        '<p><%= t(message.messageKey)%><p>' +
                        '<% } %>' +
                        '<% if(message && message.closeable){ %>' +
                        '<button class="modal_close btn"><%= t("lightbox_button_ok") %></button>' +
                        '<% } else if (_.isArray(message.blockers) && !_.isEmpty(message.blockers) && !message.closeable) { %>' +
                        '<button type="button" class="send_message btn" data-msg-key="isBlocked"><%= t("lightbox_button_ok") %></button>' +
                        '<% } %>',
                    validation_box: '<p><%- text  %> (<span><%- field  %></span>) </p><div class="buttons">' +
                        '<button class="modal_close ok btn"><%- t("lightbox_button_ok") %></button></div>',
                    casino_confirmation: '<div class="content-wrap">' +
                        '<% if(confirmations){ _.each( confirmations , function( item ){ %>' +
                        '<h3 class="h3"><%= t(item.key)%></h3><div class="msg"><%= item.message %></div>' +
                        '<% }); }%></div><div class="actions"><p class="hint"><%- t("lightbox_casino_confirm_hint") %></p>' +
                        '<button class="positive modal_close btn"><%- t("lightbox_button_yes") %></button>' +
                        '<button class=" modal_close btn"><%- t("lightbox_button_no") %></button></div>',
/*CancelWDRequest*/ confirmation: '<div class="content-wrap"><div class="msg"><%- t("lightbox_confirm_msg") %></div></div>' +
                        '<div class="actions"><p class="hint"><%- t("lightbox_confirm_hint") %></p>' +
                        '<button class="ok modal_close btn"><%- t("lightbox_button_yes") %></button>' +
                        '<button class="no modal_close btn"><%- t("lightbox_button_no") %></button></div>',
                    confirm : '<div class="header"><% var h=message.header||"";%><%= t(h)%></div>'+
                        '<div class="msg"><% var args=message.args || {}; _.each(message.msgArr || [], function(v,i){%><%= t(v, args[i])%><%})%></div>' +
                        '<div class="buttons"><% if(message.confirmBtn.isVisible){%>' +
                        '<button class="ok modal_close_X btn"><%- t(message.confirmBtn.txt)%></button> ' +
                        '<%} if(message.cancelBtn.isVisible){%>' +
                        '<button class="on_cancel modal_close btn" ><%- t(message.cancelBtn.txt)%></button> ' +
                        '<%}%></div> <div id="confirmation_footer"></div>',
                    confirm_upo_removal: '<p class="bold"><%- t("lightbox_confirm_removal_message") %></p>' +
                        '<div id="pm_info"><span class="ico <%- upmType %>"></span><span><%- name %></span>' +
                        '<% if(cc_exp_year != ""){%><span><%- t("lightbox_exp_abbr")%> <span class="bold" ><%- cc_exp_month %>/<%- cc_exp_year %></span></span><%}%></div>' +
                        '<div class="buttons"><button class="no modal_close btn"><%- t("lightbox_button_cancel") %></button>' +
                        '<button class="ok btn"><%- t("lightbox_remove_button") %></button></div>',
                    'withdraw-canceled': '<div class="modal-icon success">&#xf05d;</div><div class="msg-wrap">' +
                        '<p> <%= t("lightbox_canceled_info", args )%> </p></div><button class="modal_close btn"><%- app.locale.lightbox_success.button %></button>',
                    unknown: '<ul><% _.each(message, function(item ){ %> ' +
                        '<li><%  _.each(item, function(i){ %> <span><%=  i %></span><% }); %></li><% }); %></ul>',
/*TODO REMOVE_ME */ paydotcom_dialog: '<div class="content-wrap"><div class="msg"><%= t("paydotcom_msg") %></div></div>' +
                        '<div class="actions"><button class="ok modal_close btn"><%- t("paydotcom_button_yes") %></button> ' +
                        '<button class="no modal_close btn"><%- t("paydotcom_button_no") %></button></div>',
                    pm_redirect_iframe: '<div class="pm_redirect_wrapper <%- pm_class %>">' +
                        '<iframe src="<%= url %>" width="100%" height="100%" scrolling="auto"/>' +
                        '</div>',
                    kyc: // '<a class="modal_close" href="#"></a><div class="underline"></div>' +
                        '<div class="modal-icon <%- details.trxStatus%>"></div>' +
                        '<%  var uploadUrl = (details.kycResponse && details.kycResponse.documentUploadUrl);' +
	                    'var kycApproved = (details.kycResponse && details.kycResponse.status.toLowerCase() === "approved");' +
                        'var account_status_str = (uploadUrl || !kycApproved )?"not_verified":"verified"; var ok_btn = "lightbox_button_ok", docv_class_name=""; %>' +
                        '<%if(details.kycResponse){%><p class="info"><%= t("lightbox_kyc_" + account_status_str) %>' +
                        '<% if(uploadUrl){ docv_class_name = "docv"; ok_btn = "lightbox_continue_button"; %><br/><%= t("lightbox_kyc_click_continue")%><%}%>' +
                        '</p><div class="buttons"><%if(uploadUrl){%><button class="on_cancel modal_close btn"><%- t("lightbox_button_cancel") %></button><%}%> ' +
                        '<button class="ok modal_close btn <%- docv_class_name%>"><%- t(ok_btn) %></button>' +
                        '</div>' +
                        '<%}%>',
                    wd_mvp_nuvei_card: '<div>' +
                        '<div class="mvp_nuvei_card_image"></div>' +
                        '<div class="mvp_nuvei_card_info"><%- t("mvp_nuvei_card_info_text")%></div>' +
                        '<div class="mvp_nuvei_card_order_button_wrapper"><button class="btn"><%= t("mvp_nuvei_card_order_card_btn_text")%></button></div>' +
                        '<div class="mvp_nuvei_card_enter_details_text"><%= t("mvp_nuvei_card_enter_details_text")%></div>' +
                    '</div>',
                    wd_nuvei_card_user_creation_successfull: '<div>' +
                        '<p><%= t("nvi_card_user_created_successfuly_message")%></p>'+
                        '<p><%= t("nvi_card_user_created_contact_support_message")%></p>' +
                        '<div class="buttons">' +
                            '<button class="btn modal_close ok"><%= t("lightbox_button_ok") %></button>' +
                        '</div>' +
                    '</div>'
                };
                var tpl;
                var $currTplElm = $(['#', templateName].join(''));
                if ($currTplElm.length) {
                    tpl = $currTplElm.text();
                } else {
                    tpl = msg_tpl_text[templateName] || msg_tpl_text['unknown'];
                }

                return _.template(tpl);
            },
            isUpo: function (id) {
                return !isNaN(parseInt(id));
            },
            isDeletable: function (id) {
                var storedUpoData = app.stores.user_payment_methods.get(id) || {};
                if (app.config.allowDeleteUPO && _.has(storedUpoData, 'attributes') && _.has(storedUpoData.attributes, "deletable")) {
                    return storedUpoData.attributes["deletable"];
                }
                return false;
            },
            isCardPM: function (data) {
                var ret = false;
                if (_.isString(data)) {
                    ret = app.config.cc_cards_db[data];
                } else if (_.has(data, 'paymentOptionName')) {
                    ret = app.config.cc_cards_db[data.paymentOptionName];
                } else if (_.has(data, 'attributes') && _.has(data.attributes, 'paymentOptionName')) {
                    ret = app.config.cc_cards_db[data.attributes.paymentOptionName];
                } else if (_.has(data, 'value')) {
                    ret = app.config.cc_cards_db[data.value];
                }
                return !!ret;
            },
            renderUpoMessage: function (data) {
                if (data && data.warnMessage) {
                    var skipUpoMessage = app._flag.skipUpoMessage[data.userPaymentOptionId] || {};
                    var msgId = "upo_warnMessage";
                    if (!skipUpoMessage[msgId]) {
                        var payload = {
                            uniqueId: app.lastSelectedMethodId,
                            msgArr: [data.warnMessage],
                            type: 'warning',
                            msgId: msgId
                        };
                        utils.showInlineMessage(payload);
                    }
                }
            },
            onInlineMessageClose: function (payload) {
                if (payload && payload.msgId === "upo_warnMessage") {
                    app._flag.skipUpoMessage[payload.uniqueId] || (app._flag.skipUpoMessage[payload.uniqueId] = {});
                    app._flag.skipUpoMessage[payload.uniqueId][payload.msgId] = 1;
                    utils.notifyCardUpdateMessageClosed(payload);
                }
            },
            addRemoveUpmButton: function (selector, selectedMethodId, selectedMethodType) {
                var $wrapper = $(selector || '#remove_upo_wrapper');
                if ($wrapper.length) {
                    $wrapper.empty();
                }
                if (app.util.isUpo(selectedMethodId)
                    && app.util.isDeletable(selectedMethodId)
                    && selectedMethodType) {
                    var $tplElm = $('#remove_upo_button');
                    var tplTxt = '<span class="removeUPM" data-value="<%-uniqueId%>" data-method="<%-methodName%>"><%- t("remove_upm_button_text")%></span>';
                    if ($tplElm.length) {
                        tplTxt = $tplElm.text();
                    }
                    var html = _.template(tplTxt)({
                        uniqueId: selectedMethodId,
                        methodName: selectedMethodType
                    });
                    if ($wrapper.length) {
                        $wrapper.html(html);
                    } else {
                        $('.payment_options_details').append($(html)); // $('.PMINFO').append($(html));
                    }
                }
            },
            handleSccLightbox: function (doProceed, additional_data) {
		        var proceed = true;
		        var scc = app.config.storeCard || {};
		        var shouldSowLightbox = (scc.isActive && scc.useLightbox && scc.flow !== 'DISABLE_FEATURE');
		        if (shouldSowLightbox && (app.lastSelectedMethodId === 'dc_card' || app.lastSelectedMethodId === 'cc_card')) {
			        proceed = false;
			        var payload = {
				        titleKey   : "confirmation",
				        msgArr     : ["save_pm_details_text"],
				        confirmBtn : {
					        isVisible : true,
					        txt       : (scc.flow == "SHOW_TEXT_ONLY" ? "lightbox_continue_button" : "lightbox_agree_button"),
				        },
				        cancelBtn  : {
					        isVisible : true,
					        txt       : (scc.flow == "SHOW_TEXT_ONLY" ? "lightbox_button_cancel" : "lightbox_disagree_button")
				        }
			        };
			        var onContinue = function (e) {
                        app.util.closeLightbox();
                        if (scc.flow == "SHOW_TEXT_ONLY") {
                            doProceed(additional_data);
                        } else {
                            doProceed($.extend(true, {}, additional_data, {allowSaveCardUpo: true}));
                        }
                    };
			        var onCancel = function (e) {
				        if (scc.flow !== "SHOW_TEXT_ONLY") {
                            doProceed(additional_data);
				        }
			        };
			        var tpl = app.util.getLightboxContentTemplate('confirm');

			        app.showModalCustomMessage(tpl, 'confirm scc', t("lightbox_confirm_title"), {message : payload}, onContinue, onCancel);
		        }
		        return proceed;
	        },
            handlePreWdLightboxes: function (doProceed, params) {
                var proceed = true;
                var isResubmit = (app.submittedMethod);
                if (!isResubmit) {
                    if (app.config.beneficiaryOwnerAmount != null && app.config.beneficiaryOwnerAmount < app.config.wd_amount) {
                        proceed = false;
                        _showPreWdConfirmationPopup(1);
                    } else if (app.config.doubleConfirmByPm[app.current_pm_name] || app.config.doubleConfirmByPm.ALL) {
                        proceed = false;
                        _showPreWdConfirmationPopup();
                    }
                }
                return proceed;

                /***************  handlePreWdLightboxes helpers Start  *************/
                function _showPreWdConfirmationPopup(beneficiaryOwnerChecks) {
                    app.util.closeLightbox();
                    var amount = app.config.wd_amount;
                    if (app.current_pm_feeObj) {
                        var feeObj = app.util.getFeeRenderingData(app.current_pm_feeObj, amount, app.lastSelectedCurrency);
                        if (feeObj && feeObj.raw && feeObj.raw.total_amount && feeObj.raw.total_amount > amount) {
                            amount = feeObj.raw.total_amount;
                        }
                    }
                    var payload = {
                        titleKey: "confirmation",
                        msgArr: beneficiaryOwnerChecks ? ["beneficiary_owner_confirm_text"] : ["double_confirmation_text"],
                        args: {0: [app.formatter.formatCurrency(amount, app.lastSelectedCurrency, null, true)]},
                        confirmBtn: {
                            isVisible: true,
                            txt: beneficiaryOwnerChecks ? "lightbox_button_yes" : "lightbox_continue_button",
                        },
                        cancelBtn: {
                            isVisible: true,
                            txt: "lightbox_button_cancel"
                        }
                    };
                    var onContinue = function (e) {
                        if (beneficiaryOwnerChecks && (app.config.doubleConfirmByPm[app.current_pm_name] || app.config.doubleConfirmByPm.ALL)) {
                            _showPreWdConfirmationPopup(); // recusion!!!
                        } else {
                            app.util.closeLightbox();
                            doProceed();
                        }
                    };
                    var onCancel = beneficiaryOwnerChecks ? function (e) {
                        app.util.closeLightbox();
                        doProceed({"cancelOrderForBeneficiaryOwner": true});
                    } : null;
                    var classes = beneficiaryOwnerChecks ? 'confirm beneficiary_owner_confirmation' : 'confirm pre_wd_confirmations';
                    var tpl = app.util.getLightboxContentTemplate('confirm');
                    app.showModalCustomMessage(tpl, classes, t("lightbox_confirm_title"), {message: payload}, onContinue, onCancel);
                }

                /***************  handlePreWdLightboxes helpers End  *************/
            },
            removeUPM: function (data) {
                var upmId = data.upmId || data.userPaymentOptionId;
                if (!app.util.isDeletable(data.upmId)) {
                    console.warn("deletable : FALSE");
                    return;
                }
                // console.log('remove-upm >>>', data);
                var storedUpoData = app._upoList[upmId] || {};
                var upmType = data.upmType || storedUpoData.paymentOptionName;
                var payload = {
                    upmType: upmType.toLowerCase(),
                    id: upmId,
                    name: (storedUpoData.name || ''),
                    cc_exp_month: '',
                    cc_exp_year: ''
                };
                if (app.util.isCardPM(storedUpoData)) {
                    payload.upmType = storedUpoData.card_type.toLowerCase();
                    payload.name = storedUpoData.name ? "*" + storedUpoData.name.replace(/[{()}]/g, '').substr(-4) : "*";
                    var upo_fields = storedUpoData.paymentDetails || {};
                    if (upo_fields.cc_exp_month && upo_fields.cc_exp_year) {
                        payload.cc_exp_month = upo_fields.cc_exp_month.value;
                        payload.cc_exp_year = upo_fields.cc_exp_year.value;
                    }
                }
	            payload.upmType += utils.getCustomImgClassNameSuffix(storedUpoData.metadata, upmId);
                var headerText = t('confirm_upo_removal');
                var tpl = app.util.getLightboxContentTemplate('confirm_upo_removal');
                pubsub.publish('app.event.removeUpoClicked', [{id: upmId, pmType: upmType}]);
                var isRequestSent = false;

                app.showModalCustomMessage(tpl,
                    'confirm_upo_removal',
                    headerText,
                    payload,
                    function () {
                        //console.log('========= OK Pressed ==========');
                        if (!isRequestSent) { /* prevent multiple "Yes" clicks */
                            isRequestSent = true;
                            $.blockUI();
                            pubsub.publish('app.event.removeUpoConfirm', [{upoId: upmId, action: 'remove', pmName: upmType}]);
                            $.ajax({
                                url: 'deleteUpo.do',
                                data: {
                                    upoId: data.upmId,
                                    ssid: app.config.ssid
                                },
                                success: function (response) {
                                    //console.log('========= confirm_upo_removal success ==========', response);
                                    if (response.status === "FAIL") {
                                        if (response.message === 'session_expired' || response.message === 'wd.error.session_expired') {
                                            app.showModalErrorMessage('wd.error.session_expired');
                                        } else {
                                            var msg = {message: response.message};
                                            var title = t("pm_removal_failed");
                                            app.showModalCustomMessage(app.util.getLightboxContentTemplate('error'), 'error', title, msg);
                                        }
                                    } else {
                                        app.util.closeLightbox();
                                        app.stores.user_payment_methods.fetch({reset: true});
                                    }
                                    $(".content_inside").unblock();
                                    $.unblockUI();
                                },
                                error: function () {
                                    //console.log('========= general_error ==========');
                                    app.showModalErrorMessage();
                                },
                                dataType: 'json'
                            });
                            //.always(function () {
                            //  $(".content_inside").unblock();
                            //	$.unblockUI();
                            //});
                        }
                    },
                    function () {
                        // console.log('========= Cancel Pressed ==========');
                        pubsub.publish('app.event.removeUpoCancel', [{upoId: upmId, action: 'cancel', pmName: upmType}]);
                    });

            },
            handleSubPages: function (useSubpages) {
                if (useSubpages) {
                    $('[data-page="1"], [data-page="2"], [data-page="3"]').hide();

                    // TODO: Check if it is safe to always show page 1
                    // if (app.config.preventPMAutoSelect) {
                    //     $('[data-page="1"]').show();
                    // }

                    Path.map(CONSTANTS.HASH.DETAILS + ":payment").to(function () {
                        var uniqueId = parseInt(this.params["payment"]) || this.params["payment"];
                        if (!app.lastSelectedMethodId || app.lastSelectedMethodId !== uniqueId) {
                            var idType = parseInt(this.params["payment"]) ? 'int' : 'string';
                            var isManual = app._flag.isReload ? false : undefined;
                            pubsub.publish('dr-select-pm', [{uniqueId: uniqueId, type: idType, manual: isManual}]);
                            app._flag.isReload = false;
                        }
                        $('[data-page="1"]').hide();
                        $('[data-page="2"]').show();
                        $('[data-page="3"]').hide();
                        window.scrollTo(0, 0);

                        pubsub.publish('subpage-select', [{'id': '2'}])
                    });
                    Path.map(CONSTANTS.HASH.PM + ":payment").to(function () {
                        var uniqueId = parseInt(this.params["payment"]) || this.params["payment"];
                        if (app.lastSelectedMethodId !== uniqueId) {
                            var idType = parseInt(this.params["payment"]) ? 'int' : 'string';
                            var isManual = app._flag.isReload ? false : undefined;
                            pubsub.publish('dr-select-pm', [{uniqueId: uniqueId, type: idType, manual: isManual}]);
                            app._flag.isReload = false;
                        }
                        $('[data-page="1"]').show();
                        $('[data-page="2"]').hide();
                        $('[data-page="3"]').hide();
                        window.scrollTo(0, 0);

                        pubsub.publish('subpage-select', [{'id': '1'}])
                    });
                    Path.map(CONSTANTS.HASH.WITHDRAWALS).to(function () {
                        $('[data-page="1"]').hide();
                        $('[data-page="2"]').hide();
                        $('[data-page="3"]').show();
                        window.scrollTo(0, 0);

                        pubsub.publish('subpage-select', [{'id': '3'}])
                    });

                    $('body').on("click", '[data-page="back"]', function (ev) {
                        if (app.config.useVirtualSubpageBackNav &&
                            (window.location.hash.startsWith(CONSTANTS.HASH.DETAILS) || window.location.hash.startsWith(CONSTANTS.HASH.WITHDRAWALS))
                        ) {
                            window.location.hash = CONSTANTS.HASH.PM + app.lastSelectedMethodId;
                        } else {
                            window.history.back();
                        }
                    });
                    $('body').on("click", '[data-page="23"]', function (ev) {
                        window.location.hash = CONSTANTS.HASH.WITHDRAWALS;
                    });
                    pubsub.subscribe('select-pm-attempt', function (data) {
                        if (data.reason === "incorrect_id") {
                            window.location.hash = CONSTANTS.HASH.PM + app.lastSelectedMethodId;
                        } else if (window.location.hash === (CONSTANTS.HASH.PM + data.uniqueId)) {
                            window.location.hash = CONSTANTS.HASH.DETAILS + data.uniqueId;
                        } else if (window.location.hash.length < 4) {
                            window.location.hash = CONSTANTS.HASH.PM + data.uniqueId;
                            window.location.hash = CONSTANTS.HASH.DETAILS + data.uniqueId;
                        }
                    });
                }
            },
            paydotcomOnSubmit: function (utmMedium) {
                var utm_medium = utmMedium || 'redirect';
                var utm_source = app.rpc.merchant_id && app.rpc.merchant_site_id ? app.rpc.merchant_id + '_' + app.rpc.merchant_site_id : '';
                var locale = app.rpc.merchantLocale || 'en_US';
                var arr = [];
                for (var i = 0; i < srvUserFields.length; i++) {
                    arr.push(srvUserFields[i].name + '=' + encodeURIComponent(srvUserFields[i].value));
                }
                var params = arr.join('&') +
                    '&currency=' + encodeURIComponent(app.rpc.wd_currency || '') +
                    '&source=cashier-withdrawal' +
                    '&merchant_site_id=' + encodeURIComponent(app.rpc.merchant_site_id || '') +
                    '&user_token_id=' + encodeURIComponent(app.rpc.user_token_id || '') +
                    '&referral=' + encodeURIComponent(app.rpc.merchant_site_id || '') +
                    '&utm_source=' + encodeURIComponent(utm_source) +
                    '&utm_medium=' + encodeURIComponent(utm_medium) +
                    '&utm_campaign=cashier-withdrawal';
                utils.paydotcom.submit({
                    params: params,
                    type: app.config.paydotcomType,
                    locale: locale,
                    country: app.config.country
                });
            },
            paydotcomOnSuccess: function () {
                app.stores.user_payment_methods.fetch({reset: true});
                console.log('success and refresh');
            },
            sendPostMessage: function (msg, url) {
                url = url || ('*');
                msg = JSON.stringify(msg);
                if (app._webViewSDK && app._webViewSDK.postMessage) {
                    app._webViewSDK.postMessage(msg);
                } else if (window.opener) {
                    window.opener.postMessage(msg, url);
                } else {
                    parent.postMessage(msg, url);
                }
            },
            performRedirect: function (data) {
                if (data) {
                    if (data.status === CONSTANTS.SRV_RESPONSE.STATUS_OK) {
                        app.util.sendPostMessage(CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS, app.config.parentUrl);
                    }
                    app.util.closePopUpWindow();
                    window.location.href = data.redirectURL;
                }
            },
            openPopUpWindow : function (data) {
                function apmPopupClosedCallback(wnd_name) {
                    if (wnd_name && app._popupWnd && app._popupWnd.name && app._popupWnd.name != wnd_name) {
                        // do nothing! (we already have a new popup)
                    } else if (!app._popupWnd || app._popupWnd['closed'] == undefined || app._popupWnd['closed'] == true) {
                        app._popupWnd = false;
                        $.unblockUI();
                    }
                }
	            function waitPopupClose(popupWnd, closeCallback) {
                    var name;
		            window.setTimeout(function () {
			            if (popupWnd == undefined || popupWnd['closed'] == undefined || popupWnd['closed'] == true) {
                            try {
                                name = popupWnd && popupWnd.name;
                            } catch (e) {/*console.log(e);*/}
				            closeCallback(name);
			            } else {
				            waitPopupClose(popupWnd, closeCallback);
			            }
		            }, 200);
	            }
                if (app.config.openPmInPopUpWnd[app._deviceType][app.current_pm_name]
                    && !app.util.shouldOpenInExternalBrowser(app.lastSelectedMethodId)
                ) {
		            var popupName = 'pppApmWindow_' + (new Date()).getTime();
                    var cfg = {
                        apmgw_eCheckSelect      : {w: 800, h: 700},
                        apmgw_eCheckSelect_DOB  : {w: 800, h: 700},
                        apmgw_Trustly_DI        : {w: 600, h: 600},
                        default                 : {w: 800, h: 600}
                    };
                    var w = (cfg[app.current_pm_name] || cfg.default).w;
                    var h = (cfg[app.current_pm_name] || cfg.default).h;
		            var left = (screen.width / 2) - (w / 2);
		            var top = (screen.height / 2) - (h / 2);
		            var popupWnd = window.open('/ppp/blank.html?ssid=' + app.config.ssid, popupName, // data.pmRedirectURL, popupName,
			            'height=' + h + ',width=' + w + ',top=' + top + ',left=' + left +
			            ',toolbar=yes,location=no,directories=no,status=no,menubar=no,linemenubar=no,scrollbars=yes,resizable=yes,modal=yes'
		            );
		            app._popupWnd = popupWnd;
		            waitPopupClose(popupWnd, apmPopupClosedCallback);
	            }
            },
            closePopUpWindow: function (pm, initiator) {
                pm = app.submittedMethod && app.submittedMethod.pmName || app.current_pm_name;
                if (app._popupWnd && app._popupWnd.close) {
                    app._popupWnd.close();
                    app._popupWnd = false;
                    pubsub.publish("popupWndClose", [{pmName: pm, initiator: initiator}]);
                }
            },
            shouldOpenInExternalBrowser: function (uniqueId) {
                var item = uniqueId && app.config.appReturnLink && (app.util.isUpo(uniqueId) ? app._upoList[uniqueId] : app._poList[uniqueId] && app._poList[uniqueId].attributes);
                return (item && item.openInExternalBrowser);
            },
	        handlePopUpPM : function (data) {
                if (app.util.shouldOpenInExternalBrowser(app.submittedMethod && app.submittedMethod.id)) {
                    var extLink = encodeURIComponent(data.pmRedirectURL);
                    app._preWdParamId = data && data.paramId;
                    if (app.config.nativeAppFlow === '1') {
                        app.util.sendPostMessage({action: "open_in_browser", url: extLink}, app.config.parentUrl);
                    } else {
                        $.unblockUI();
                        var url = '/ppp/forwarder.html?ssid=' + app.config.ssid;
                        url += '&nativeAppFlow=' + (app.config.nativeAppFlow || 0);
                        url += '&open_in_browser=true&link=' + extLink;
                        document.location.href = url;
                    }
                } else if (app.config.openPmInPopUpWnd[app._deviceType][app.current_pm_name] && app._popupWnd) {
			        app._popupWnd.location = data.pmRedirectURL;
			        try {
				        app._popupWnd.focus();
			        } catch (e) {
			        }
		        } else {
			        var title = '&nbsp;<span class="modal_close"></span>';
			        var pm_class = ('lbx_' + app.current_pm_name).toLowerCase();
			        var html = app.util.getLightboxContentTemplate('pm_redirect_iframe')({
				        url      : data.pmRedirectURL,
				        t        : t,
				        pm_class : pm_class
			        });
			        showModalMessage({message : title, details : html}, pm_class + " pm_redirect");
		        }
	        },
            triggerDocUpload: function (data) {
                if (data && data.documentUploadUrl) {
                    var title = '&nbsp;<span class="modal_close"></span>';
                    var className = ('lbx_doc_upload lbx_' + app.current_pm_name).toLowerCase();
                    var html = app.util.getLightboxContentTemplate('pm_redirect_iframe')({
                        url: data.documentUploadUrl,
                        t: t,
                        pm_class: className
                    });
                    showModalMessage({message: title, details: html}, className + " pm_redirect");
                }
            },
            handleErrorCode1082: function (response) {
                var proceed = true;
                var pmData = app._poList[response.paymentOptionName] || app._upoList[response.paymentOptionName];
                if (response.paymentOptionName != app.lastSelectedMethodId && pmData) {
                    var blockers = utils.isPMBlocked(pmData);
                    if (_.isEmpty(blockers)) {
                        var isUpo = app.util.isUpo(response.paymentOptionName);
                        var subscriptionType = isUpo ? 'post-upm-render' : 'post-pm-render';
                        var pubSubObj = pubsub.subscribe(subscriptionType, function (data) {
                            pubsub.unsubscribe(pubSubObj);
                            app.util.setAmountValue(response.amount, ['setValue', 'blur'], 'handleErrorCode1082');
                            var pmName = pmData.value || pmData.paymentOptionName;
                            var pmLabel = t(pmName);
                            var message = t('wd_try_fallback_method', [pmLabel]);
                            app.util.showFallbackMessage(message);
                            $.unblockUI();
                        });
                        var uniqueIdType = isUpo ? 'int' : 'string';
                        pubsub.publish('dr-select-pm', [{uniqueId: response.paymentOptionName, type: uniqueIdType}]);
                        proceed = false;
                    }
                }
                return proceed;
            },
            showFallbackMessage: function (message) {
                utils.renderBlockedPMReasons({blockers: {message1: message}});
            },
            handleTrxCompletePopups: function (tpl, type, headerText, payload, onConfirm, onCancel) {
                var onConfirmAction = onConfirm || function () {
                    app.util.sendPostMessage(type, app.config.parentUrl);
                };
                if (payload && payload.details && payload.details.kycResponse && payload.details.kycResponse.status) {
                    app.showModalCustomMessage(tpl, 'kyc ' + type, headerText, payload, onConfirm, onCancel);
                } else if (app.config.showTrxCompletePopups && app.config.messagesMode !== CONSTANTS.MESSAGES_MODE.NONE) {
                    if (type === CONSTANTS.MODAL_MESSAGE_TYPE.ERROR) {
                        app.showModalErrorMessage(tpl);
                    } else if (type === CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS && !app.config.directConfirm) {
                        app.showModalCustomMessage(tpl, type, headerText, payload, onConfirm, onCancel);
                    } else {
                        onConfirmAction();
                    }
                } else {
                    var srvMsg = payload && payload.message ? (_.isObject(payload.message) ? payload.errorCode : payload.message) : '';
                    if (type === CONSTANTS.MODAL_MESSAGE_TYPE.ERROR || type === CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS) {
                        app.util.showToastMessage(type, srvMsg);
                    }
                    onConfirmAction();
                }
            },
            showToastMessage : function (type, message) {
                if (!app.config.showTrxCompletePopups) {
                    var raw = {
                        amount      : app.config.wd_amount,
                        currencyIso : app.lastSelectedCurrency,
                        useIntl     : app.config.useIntlFormatter,
                    };
                    var payload = {
                        message : {
                            msgKey : (message || ("toast_trx_msg_" + type)),
                            params : [app.formatter.formatDecimal(app.config.wd_amount), app.formatter.getCurrencySymbol(app.lastSelectedCurrency)],
                            type   : type,
                            raw    : raw
                        }
                    };
                    utils.showToastMessage(payload);
                }
            },
            handleTrxCompleteStatus_FAIL: function (result) {
                var proceed = true;
                if (_.has(result, 'errorCode')) {
                    if (proceed && result.errorCode == '1082') {
                        app._flag.errorCode1082 = true;
                        proceed = app.util.handleErrorCode1082(result);
                    } else if (result.errorCode == 'CANCELLED_FROM_USER') {
                        app.util.closeLightbox();
                        proceed = false;
                    } else if (app.config.handleSrvResponseErrorCode) {
                        proceed = app.config.handleSrvResponseErrorCode(result);
                    }
                }
                if (proceed && _.has(result, 'confirmations')) {
                    $(".content_inside").unblock();
                    var tpl = app.util.getLightboxContentTemplate('casino_confirmation');
                    var payload = {confirmations: result['confirmations']};
                    var handler = function () {
                        app.rpc.wd_requestId = (result.wdRequest && result.wdRequest.wd_requestId) || (result.messageParams && result.messageParams.wdRequestId);
                        if (_.has(result, 'registeredUpo')) {
                            app.rpc.registeredUpo = result['registeredUpo'];
                        }
                        app.rpc.ptConfirmedUserActions = JSON.stringify(_.pluck(result['confirmations'], 'key'));
                        app.makeRequest(); // app.onWithdrawClicked();
                    };
                    app.showModalCustomMessage(tpl, 'casino_confirm', t("lightbox_casino_confirm_title"), payload, handler);
                }
                else if (proceed) {
                    $(".content_inside").unblock();
                    $.unblockUI();
                    app.util.handleTrxCompletePopups(result.message, CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
                    app.stores.user_payment_methods.fetch({reset: true});
                }
            },
            handleTrxCompleteStatus_OK: function (result) {
                var submittedMethod = app.submittedMethod || false;
                $(".content_inside").unblock();
                app.util.clearFormAmountState();
                app.submittedMethod = false;

                var tpl = app.tpls['tpl/successResultPanel.html'];
                var payload = {
                    amount: (result.wdRequest ? result.wdRequest.requestedAmount : result.messageParams ? result.messageParams.amount : '-1'),
                    currency: (result.wdRequest ? result.wdRequest.requestedCurrency : result.messageParams ? result.messageParams.currency : ''),
                    wdRequestParams: (result.wdRequest && result.wdRequest.params ? result.wdRequest.params : {}),
                    registeredUpo: result.registeredUpo,
                    submittedMethod: submittedMethod,
                    useIntl: !!app.config.useIntlFormatter
                    // , message: result.message  // ~ BACKLOG-1188
                };
                payload.formattedAmount = app.formatter.formatCurrency(payload.amount, payload.currency, null, true);
                var onConfirm = function () {
                    app.util.sendPostMessage(CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS, app.config.parentUrl);
                    app.stores.user_payment_methods.fetch({reset: true});
                };
                var onCancel = onConfirm;
                if (result && result.kycResponse) {
                    payload.details = {
                        trxStatus: CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS,
                        kycResponse: result.kycResponse
                    };
                    tpl = app.util.getLightboxContentTemplate('kyc');
                    if (result.kycResponse.documentUploadUrl) {
                        onConfirm = function () {
                            app.util.triggerDocUpload(result.kycResponse);
                            app.util.sendPostMessage(CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS, app.config.parentUrl);
                            app.stores.user_payment_methods.fetch({reset: true});
                        };
                    }
                }
                app.util.handleTrxCompletePopups(tpl, CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS, msg.successful_operation, payload, onConfirm, onCancel);
                app.selected_payment_id = result['registeredUpo'] || 0;
                // app.stores.user_payment_methods.fetch({reset: true});
                if (result.wdRequest) {
                    result['wdRequest'].creationDate = new Date(parseInt(result['wdRequest'].creationDate, 10));
                    result['wdRequest']['status'] = result['wdRequest']['status'].toLowerCase();
                    result['wdRequest']['params'] = result['wdRequest']['params'] || {};
                    result['wdRequest']['params']['upoId'] = app.selected_payment_id.toString();
                    window.app.stores.withdraw_requests.add(new models.withdraw_req_item(result['wdRequest']));
                } else {
                    window.app.stores.withdraw_requests.fetch({reset: true});
                }
            },
            handlePayWithCryptoConsent: function () {
                var pmSettings = app.config.pmSettings[app.CONSTANTS.PM_NAME.PAY_WITH_CRYPTO];
                   var provider = ((pmSettings && pmSettings.provider) || "").toLowerCase(),
                       titleKey = "pwc_terms_and_conditions_title",
                       termsKey = "coindirect_terms";

                   if (provider === "simplex") {
                       titleKey = "simplex_pwc_terms_and_conditions_title";
                       termsKey = "simplex_coindirect_terms";
                   }

                var payload = {
                    titleKey: titleKey,
                    msgArr: [termsKey],
                    confirmBtn: {
                        isVisible: true,
                        txt: "pwc_terms_and_conditions_btn_agree",
                    },
                    cancelBtn: {
                        isVisible: true,
                        txt: "pwc_terms_and_conditions_btn_disagree"
                    }
                };
                app.showModalCustomMessage(
                    app.util.getLightboxContentTemplate('confirm'),
                    'confirm lbx_pwc_terms',
                    t(payload.titleKey),
                    { message: payload },
                    app.util.closeLightbox,
                    function () {
                        app.bodyElm.addClass('wd_static_pm');
                    }
                );
            },
            modifyUpoCollection: function (upo) {
                var backboneModel = app.stores.user_payment_methods.get(upo.userPaymentOptionId);
                var registrationType = upo.registrationType || "ON_WITHDRAW";
                if (backboneModel) {
                    backboneModel.set("registrationType", registrationType);
                } else {
                    var newUpo = $.extend(true, {}, upo, {"registrationType": registrationType});
                    app.stores.user_payment_methods.add(newUpo)
                }
            },
            preserveUpoList: function (upmList) {
                app._upoList = {};
                app._userPmAvailableData = $.extend(true, [], upmList);
                _.each(upmList, function (upo) {
                    app._upoList[upo.userPaymentOptionId] = upo;
                });
                return app._upoList;
            },
            preservePoList: function (poList) {
                app._poList = {};
                _.each(poList, function (item) {
                    var key = item.type || item.value;
                    if (key) {
                        app._poList[key] = $.extend(true, {}, item);
                    }
                });
                return app._poList;
            },
            extendUpoListData: function (data) {
                app._upoList[data.userPaymentOptionId]['paymentDetails'] = $.extend(true, {}, data['paymentDetails']);
                app._upoList[data.userPaymentOptionId]['fee'] = $.extend(true, {}, data['fee']);
                app._upoList[data.userPaymentOptionId]['pmLimits'] = $.extend(true, {}, data['pmLimits']);
                return data;
            },
            handlePMPreSelection: function (upmList, pmList) {
                upmList || (upmList = []);
                pmList || (pmList = []);
                var validId;
                if ((upmList.length + pmList.length) === 0) {
                    app.showModalCustomMessage(
                        app.util.getLightboxContentTemplate('error_fatal'),
                        CONSTANTS.MODAL_MESSAGE_TYPE.ERROR,
                        msg.errors.no_payment_data,
                        {message: msg.no_payment_options}
                    );
                    app._flag.shouldPreselectSamePmAfterWdCancelation = false;
                    app.submittedMethod = false;
                    return;
                }
                if (app._flag.shouldPreselectSamePmAfterWdCancelation && _pmExist(app.lastSelectedMethodId)) {
                    validId = app.lastSelectedMethodId;
                } else if (app.submittedMethod && _pmExist(app.submittedMethod.id)) {
                    validId = app.submittedMethod.id;
                } else if (!app._flag.firstPreselectionDone && app.config.preselectPmType) {
                    validId = _findFirstIdByPmName(upmList, app.config.preselectPmType, "upm") || _findFirstIdByPmName(pmList, app.config.preselectPmType, "pm");
                }
                if (!validId) {
                    validId = (upmList[0] && upmList[0].userPaymentOptionId) || (pmList[0] && pmList[0].value);
                }
                app._flag.firstPreselectionDone = true;// preselect it only once - only first time
                app._flag.shouldPreselectSamePmAfterWdCancelation = false;
                app.submittedMethod = false;
                _selectPm(validId);

                /***************  handlePMPreSelection helpers Start  *************/
                function _findFirstIdByPmName(arr, pmName, type) {
                    var id;
                    if (pmName && arr) {
                        var item = _.find(arr, (type === "upm" ? {'paymentOptionName': pmName} : {'value': pmName}));
                        id = item && item[type === "upm" ? 'userPaymentOptionId' : 'value'];
                    }
                    return id;
                }

                function _pmExist(id) {
                    return !!(id && (app._upoList[id] || app._poList[id]));
                }

                function _selectPm(pmId) {
                    if (!pmId) {
                        return;
                    }
                    var idType = (isNaN(parseInt(pmId, 10)) ? 'string' : 'int');
                    if (app.config.useSubpages) {
                        app._flag.isReload = app.config.preventPMAutoSelect ? false : true;
                        app.lastSelectedMethodId = null;
                        if (app.config.preserveSubpageOnReload) {
                            var hash = window.location.hash;
                            if (!app.config.preventPMAutoSelect && !(hash && (hash.startsWith(CONSTANTS.HASH.PM) || hash.startsWith(CONSTANTS.HASH.DETAILS) || hash.startsWith(CONSTANTS.HASH.WITHDRAWALS)))) {
                                window.location.hash = CONSTANTS.HASH.PM + pmId;
                            }
                        } else if (!app.config.preventPMAutoSelect) {
                            window.location.hash = CONSTANTS.HASH.PM + pmId;
                        }
                        Path.listen();
                    } else if (!app.config.preventPMAutoSelect) {
                        pubsub.publish('dr-select-pm', [{uniqueId: pmId, type: idType, manual: false}]);
                    }
                }

                /***************  handlePMPreSelection helpers End  *************/
            },
            isStaticPm: function (id, type) {
                var isUpo = app.util.isUpo(id);
                var pmWithStaticUpo = {
                    /* ppp_XXX : 1 */
                };
                return (isUpo ? pmWithStaticUpo[type] : app.CONSTANTS.STATIC_PMS[id]);
            },
            onPMSelectedHandleBodyClasses: function (isPostRender, isSuspended) {
                var classes = {
                    toAdd: '',
                    toRemove: '',
                };
                if (!isPostRender) {
                    classes.toRemove += ' use_masked_amount';
                    classes[(isSuspended ? 'toAdd' : 'toRemove')] += ' wd_suspended';
                    app.bodyElm
                        .attr('data-last_selected_method_type', app.current_pm_name)
                        .attr('data-is_upo', app.util.isUpo(app.lastSelectedMethodId));
                }
                classes[(isPostRender ? 'toRemove' : 'toAdd')] += ' wd_changing';
                classes[(app.util.isStaticPm(app.lastSelectedMethodId, app.current_pm_name) ? 'toAdd' : 'toRemove')] += ' wd_static_pm';
                app.bodyElm.removeClass(classes.toRemove).addClass(classes.toAdd);
            },
            needWithdrawalAllowedCheck: function (paymentOptionId) {
                if (!app.config.ptRequestId) {
                    return false;
                }
                var isUPM = !isNaN(paymentOptionId);
                var shouldPerformCheck;
                var data;
                if (isUPM) {
                    data = app.stores.user_payment_methods.get(paymentOptionId);
                    shouldPerformCheck = data && data.get("checkWithdrawAllowed")
                } else {
                    data = app._poList[paymentOptionId];
                    shouldPerformCheck = data && data.attributes && data.attributes.checkWithdrawAllowed;
                }
                return shouldPerformCheck;
            },
            collectUpoData: function (methodFields) {
                var fieldsPairsUserPM = {};
                _.forIn(methodFields, function (item, key) {
                    if (_.isPlainObject(item) && !app._doNotSubmitFields[key]) {
                        fieldsPairsUserPM[key] = app.util.normalizeFieldValue(key, ($('select.' + key).val() || $('input.' + key).val() || methodFields[key].value));
                    }
                });
                return fieldsPairsUserPM;
            },
            collectPoData: function (methodFields) {
                var fieldPairs = {};
                _.forIn(methodFields, function (item, key) {
                    if (!app._doNotSubmitFields[key]) {
                        fieldPairs[key] = app.util.normalizeFieldValue(key, ($('input.' + key).val() || $('select.' + key).val() || $('input.' + key + '_readOnly').val()));
                    }
                });
                return fieldPairs;
            },
            normalizeFieldValue: function (fld, val) {
                if(fld && validationsMap[fld] && validationsMap[fld].normalizeSubmittedVal && val != undefined){
                    return validationsMap[fld].normalizeSubmittedVal(val);
                }
                return val;
            },
            onPreWdSuccess: function (response) {
                if (!response || app._processedWdRequest[response.withdrawalRequestId]) {
                    return;
                }
                if (response.withdrawalRequestId) {
                    app._processedWdRequest[response.withdrawalRequestId] = "OK";
                }
                app.currentMethodFields = {};           // clear State
                app.lastSelectedMethodId = response.upo.userPaymentOptionId;
                app.config.selected_payment_id = response.upo.userPaymentOptionId;
                app._methodRegistrationType = response.upo.registrationType;
                app.util.modifyUpoCollection(response.upo);
                app.util.closeLightbox();
                app.makeRequest();
            },
            getUserData: function () {
                var retObj = app.user || {};
                if (_.isEmpty(retObj)) {
                    _.each(window.srvUserFields, function (item) {
                        var key = item["name"];
                        if (key === 'first_name') {
                            key = "firstName";
                        } else if (key === 'last_name') {
                            key = "lastName";
                        }
                        retObj[key] = item["value"];
                    });
                }
                return retObj;
            },
            prePopulateFields: function (method_name, data) {
                var prePopulate = {
                    "apmgw_PaySafeCard": {
                        pairs: [["wd_pay_safe_first_name", "first_name"], ["wd_pay_safe_last_name", "last_name"], ["wd_pay_safe_birthdate", "dateOfBirth"]],
                        disablePrePopulatedFields: true
                    },
                    "apmgw_eCheckSelect_DOB": {
                        pairs: [["mazooma_dob", ["dateOfBirth"]], ["mazooma_state", ["state"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_AstropayPrePaid": {
                        pairs: [["wd_astro_pay_prepaid_beneficiary_name", ["first_name", "last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_2C2P_PayoutService": {
                        pairs: [["payout2c2p_beneficiaryName", ["first_name", "last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Interac_DI": {
                        pairs: [["interac_email", ["email"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Interac_eTransfer": {
                        pairs: [["interac_eTransfer_email", ["email"]],["interac_eTransfer_mobilePhone", ["phone1"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Interac_Combined": {
                        pairs: [["interac_Combined_email", ["email"]],["interac_Combined_mobilePhone", ["phone1"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_TouchnGo": {
                        pairs: [["tng_beneficiaryEmail", ["email"]]],
                        disablePrePopulatedFields: true
                    },
                    "apmgw_INTERAC_Instant": {
                        pairs: [["interac_instant_phone", ["phone1"]], ["interac_instant_email", ["email"]]],
                        disablePrePopulatedFields: false
                    },
                    "ppp_BankTransferSK": {
                        pairs: [["wd_bank_account_holder_name", ["first_name", "last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "ppp_ManualWT": {
                        pairs: [["manualwt_city", ["city"]], ["manualwt_zip", ["zip"]], ["manualwt_country", ["country"]], ["manualwt_state", ["state"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Africa_Payouts_MOBILEMONEY": {
                        pairs: [["mbMoney_email", ["email"]], ["mbMoney_phone", ["phone1"]], ["mbMoney_firstName", ["first_name"]], ["mbMoney_lastName", ["last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Africa_Payouts_BARTER": {
                        pairs: [["barter_email", ["email"]], ["barter_phone", ["phone1"]], ["barter_firstName", ["first_name"]], ["barter_lastName", ["last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Africa_Payouts_BANKTRANSFER": {
                        pairs: [["bTransfer_city", ["city"]], ["bTransfer_street", ["address1"]], ["bTransfer_email", ["email"]], ["bTransfer_phone", ["phone1"]], ["bTransfer_firstName", ["first_name"]], ["bTransfer_lastName", ["last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_AstroPay": {
                        pairs: [["astropaycard_accountId", ["phone1"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_Aircash": {
                        pairs: [["aircash_phone", ["phone1"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_NPP": {
                        pairs: [["npp_account_name", ["first_name", "last_name"]]],
                        disablePrePopulatedFields: false
                    },
                    "apmgw_PESPay": {
                        pairs: [["pes_email", ["email"]]],
                        disablePrePopulatedFields: true
                    },
                    "apmgw_PIX": {
                        pairs: [["pixEmail", ["email"]], ["pixPhone", ["phone1"]], ["pix_personal_id", ["personalId"]]],
                        disablePrePopulatedFields: false
                    }
                };
                if (data && data.paymentDetails && prePopulate[method_name] && window.srvUserFields) {
                    var srvUserFieldsObj = (function (arr, key1, key2) {
                        var retObj = {};
                        _.each(arr, function (item) {
                            retObj[item[key1]] = item[key2];
                        });
                        return retObj;
                    })(window.srvUserFields, "name", "value");
                    var pairs = prePopulate[method_name].pairs;
                    _.each(pairs, function (pair) {
                        if (data.paymentDetails[pair[0]] && !data.paymentDetails[pair[0]].value) {
                            var value;
                            if (_.isArray(pair[1])) {
                                value = _.reduce(pair[1], function (result, field, k) {
                                    if (srvUserFieldsObj[field]) {
                                        result.push(srvUserFieldsObj[field]);
                                    }
                                    return result
                                }, []).join(' ');
                            } else if (srvUserFieldsObj[pair[1]]) {
                                value = srvUserFieldsObj[pair[1]];
                            }
                            data.paymentDetails[pair[0]]['value'] = value || data.paymentDetails[pair[0]]['value'];
                            if (prePopulate[method_name].disablePrePopulatedFields && !_.isEmpty(data.paymentDetails[pair[0]]['value'])) {
                                data.paymentDetails[pair[0]]['visibilityMode'] = CONSTANTS.VISIBILITY_MODE.DISABLED;
                            }
                        }
                    });
                }
            },
            findOptionByValue : function (arr, v) {
                var ret ;
                if(arr && arr.length) {
                    var idx = _.findIndex(arr, function (o) {
                        return o.value === v;
                    });
                    ret = arr[idx];
                }
                return ret;
            },
            getCardPlaceholder: function (item) {
                return item.label;
            },
            getMonthsArr : function () {
                return [{'value' : '01', 'text' : '01'},
                        {'value' : '02', 'text' : '02'},
                        {'value' : '03', 'text' : '03'},
                        {'value' : '04', 'text' : '04'},
                        {'value' : '05', 'text' : '05'},
                        {'value' : '06', 'text' : '06'},
                        {'value' : '07', 'text' : '07'},
                        {'value' : '08', 'text' : '08'},
                        {'value' : '09', 'text' : '09'},
                        {'value' : '10', 'text' : '10'},
                        {'value' : '11', 'text' : '11'},
                        {'value' : '12', 'text' : '12'}
                ]
            },
            getYearsArr : function () {
                var arr = [];
                var startYear = (new Date()).getFullYear();
                var endYear = startYear + 10;
                for (var year = startYear; year < endYear; year++) {
                    var shortYear = (year).toString().substring(2);
                    arr.push({value : shortYear, text : year.toString()});
                }
                return arr;
            },
            isFutureDate : function (shortYear, month) {
                if (parseInt(month, 10) === 0) {
                    return false;
                }
                var fullYear = parseInt(shortYear, 10) + 2000;
                var expDate = new Date(fullYear, parseInt(month, 10), 1, 0, 0, 0);
                expDate.setMilliseconds(-1);
                return expDate.getTime() > _.now();
            },
            oneRowExpDate: function (target, wrapper, opt) {
                var $wrapper = $(wrapper);
                var $expDate = $(target);
                var expDateOnKeyup = false;
                opt = opt || {expMonthId : 'cc_exp_month', expYearId : 'cc_exp_year'};

                if ($expDate.attr('data-mask')) {
                   return;
                }
                $expDate.attr('data-mask', 'exp_date');
                $expDate.setMask('exp_date');
                $wrapper.off('blur keyup').on('blur keyup', target, function (e) {
                    var event = e.type;
                    var date = $(target).val().split('/');
                    $('#' + opt.expMonthId).val(date[0]);
                    $('#' + opt.expYearId).val(date[1]);
                    if (event === 'focusout' && !expDateOnKeyup) {
                        app.validateCustomField('cc_exp_year', $('#' + opt.expYearId).val(), true);
                        expDateOnKeyup = true;
                    } else if (event === 'keyup' && expDateOnKeyup) {
                        app.validateCustomField('cc_exp_year', $('#' + opt.expYearId).val(), true);
                    }
                });
                utils.oneRowExpDateHelper($expDate);
                $wrapper.one('change', '#' + opt.expMonthId + ', #' + opt.expYearId, function () {
                    var exp_month_val = $('#' + opt.expMonthId).val() || '';
                    var exp_year_val = $('#' + opt.expYearId).val() || '';
                    if (exp_month_val && exp_month_val != "0" && exp_year_val && exp_year_val != "0") {
                        $expDate.val(exp_month_val + '/' + exp_year_val);
                    }
                });
                $('#' + opt.expMonthId).trigger('change');
            },
            handleRelayEvents: function () {
                if (app.config.relayAnalyticsEvents) {
                    pubsub.subscribe('suggest-point-selected', function (data) {
                        app.util.sendPostMessage({
                            'action': 'suggested amount',
                            'label': 'suggested amount value ' + data['selectedValue'],
                            'selected_value' : data['selectedValue']
                        }, app.config.parentUrl);
                    });

                    pubsub.subscribe('app.event.cc_card_number_pasted', function () {
                        app.util.sendPostMessage({
                            "action":"cc_pasted",
                            "payload":{
                                "payment_method": app.current_pm_name
                            }
                        }, app.config.parentUrl);
                    });

                    pubsub.subscribe('app.event.wdCancelSuccess', function (data) {
                        if (data && data.wdRequest) {
                            app.util.sendPostMessage(utils.getCancelWdrPostMessageData("successfulCancelWithdrawal", data, app.stores.withdraw_requests.toJSON(), app._upoList), app.config.parentUrl);
                        }
                    });

                    pubsub.subscribe('app.event.wdSuccess', function (data, initiator) {
                        var sendOldPostMsg = initiator === "mainSubmit";
                        var currency;
                        var amount;
                        var wdRequestId = (data && data.wdRequest && data.wdRequest.wd_requestId) || (data && data.messageParams && data.messageParams.wdRequestId);

                        if (data && data.wdRequest) {
                            currency = data.wdRequest.requestedCurrency;
                            amount = data.wdRequest.requestedAmount;
                        } else if (data && data.wd_amount && data.wd_currency) {
                            amount = data.wd_amount;
                            currency = data.wd_currency;
                        } else if (data && data.messageParams && data.messageParams.amount && data.messageParams.currency) {
                            amount = data.messageParams.amount;
                            currency = data.messageParams.currency;
                        } else if (!app.config.wd_open_amount) {
                            amount = app.config.wd_amount;
                            currency = app.config.wd_currency;
                        }

                        var eventObject = {
                            action: "analytics",
                            payload: {
                                action: "withdrawal_request_created",
                                amount: amount,
                                currency: currency,
                                wdRequestId: wdRequestId || ''
                            }
                        };

                        app.util.sendPostMessage(eventObject, app.config.parentUrl);

                        // backward compatibility:
                        if (data && data.wdRequest && sendOldPostMsg) {
                            var obj = {
                                "payload" : "successfulWithdrawalRequest",
                                "amount" : data.wdRequest.requestedAmount,
                                "currency" : data.wdRequest.requestedCurrency
                            };
                            if (data.wdRequest.params && data.wdRequest.params.poName) {
                                obj['payment_method'] = data.wdRequest.params.poName;
                            }
                            if (data.registeredUpo) {
                                var upoData = app._upoList[data.registeredUpo];
                                if (upoData && upoData.hasOwnProperty('isLastUsedAccount')) {
                                    obj['method_status'] = upoData.isLastUsedAccount ? 'Active' : 'Inactive';
                                }
                                if (upoData && upoData.verificationStatus) {
                                    obj['verification_status'] =  upoData.verificationStatus;
                                }
                            }
                            app.util.sendPostMessage(obj, app.config.parentUrl);
                        }
                    });

                    pubsub.subscribe('app.event.wdFailure', function (result, data){
                        var confirmationShouldBeShown  = result && result.confirmations && result.confirmations.length;

                        if (data) {
                            var obj = {
                                "payload" : "failedWithdrawalRequest",
                                "amount" : data.wd_amount,
                                "currency" : data.wd_currency
                            };
                            if (data.payment_method) {
                                obj['payment_method'] = data.payment_method;
                            } else if (data.userPaymentOptionId && app._upoList[data.userPaymentOptionId]) {
                                obj['payment_method'] = app._upoList[data.userPaymentOptionId].paymentOptionName;
                                if (app._upoList[data.userPaymentOptionId].hasOwnProperty('isLastUsedAccount')) {
                                    obj['method_status'] = app._upoList[data.userPaymentOptionId].isLastUsedAccount ? 'Active' : 'Inactive';
                                }
                                if (app._upoList[data.userPaymentOptionId].verificationStatus) {
                                    obj['verification_status'] =  app._upoList[data.userPaymentOptionId].verificationStatus;
                                }
                            }
                            if(confirmationShouldBeShown) {
                                obj['additional_information']  = "wdStatusCanBeChangedAfterUserConfirmation";
                            }
                            app.util.sendPostMessage(obj, app.config.parentUrl);
                        }
                    });
                }
            },
            getMuchBetterPhoneCodes: function (codes) {
                return app.util.getFilteredPhoneCodes(codes, 'apmgw_MuchBetter');
            },
            getFilteredPhoneCodes: function (codes, pmName) {
                pmName || (pmName = app.current_pm_name);
                return utils.filterPhoneCodesByPm(codes, pmName);
            },
            prepareCompositePhoneForValidation: function () {
                var $suffix = $('#composite_phone_suffix');
                var phone = $suffix.val();
                var code = $("#country_phone_code").val();
                var $compositePhone = $('input[data-type="composite_phone_hidden"]');
                var fldName = $compositePhone.attr('id');
                if (!$suffix.attr('data-mask')) {
                    $suffix.attr('data-mask', 'num');
                    $suffix.numberMask({type: 'number', beforePoint: 15, afterPoint: 0});
                }
                var fldVal = phone ? (code + "-" + phone) : "";
                $compositePhone.val(fldVal).trigger("change");
                app.validateCustomField(fldName, fldVal, true);
            },
            paddLeftToLength    : function (str, total_len, pad_str) {
                if (typeof str == 'undefined') {
                    return str;
                }
                str = String(str);
                total_len = total_len >> 0;
                pad_str = String(typeof pad_str !== 'undefined' ? pad_str : ' ');
                if (str.length >= total_len) {
                    return str;
                } else {
                    var repeat = Math.ceil((total_len - str.length) / pad_str.length);
                    var padded = new Array(repeat + 1).join(pad_str) + str;
                    return padded.substr(-total_len);
                }
            },
            trimStart : function (string, char) {
                if (typeof string !== "string") {
                    return string;
                }
                var str = string.split('');
                while (str[0] === char) {
                    str.shift();
                }
                return str.join('');
            },
            handlePaddedFields : function (input, fld_name, val, opt) {
                var new_val = val;
                if (val.length && opt) {
                    var unpadded = app.util.trimStart(val, opt.pad_str[0]);
                    new_val = unpadded && app.util.paddLeftToLength(unpadded, opt.len, opt.pad_str) || unpadded;
                    $(input).val(new_val);
                }
                var isValid = app.validateCustomField(fld_name, new_val, true);
                return {
                    fld_name:fld_name,
                    value: new_val,
                    isValid: isValid
                };
            },
            onFieldBlur : function (isValidFld, fld_name, val, extraData) {
                if ((app.config.useAsyncCardRecognition || app.lastSelectedMethodId === 'bancontact_cc_card') && fld_name == "cc_card_number") {
                    if (isValidFld || (utils.useDualCardBrands() && utils.checks.isCardNumber(val, {}))) {
                        app.util.asyncCheck.cardDetails(val, app.util.onCardRecognitionComplete);
                    }
                }
            },
            onCardRecognitionComplete : function (r, val) {
                var newV = $("input.cc_card_number").val();
                if (r && r.isCardAllowed) {
                    // it is OK
                } else if (r && !r.isCardAllowed && r.errorMessage) {
                    if (newV === val) {
                        validateField("cc_card_number", val, true);
                    }
                }
                if (newV === val && utils.useDualCardBrands()) {
                    app.util.addDualBrandCardSelector(r, 'async_card_recognition');
                    validateField("cc_card_number", val, true);
                    app.recalcUserDetailsArea();
                }
                var isValid = app.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
            },
            addDualBrandCardSelector: function (cardInfo, initiator) {
                var $dualBrandRadioBtnWrapper =  $('#dualBrandRadioBtnWrapper');
                var $ccCardNumRow = $('.row.cc_card_number');
                var fakeCardInfo;
                var $cardNumber;
                if (utils.useDualCardBrands() && cardInfo && cardInfo.isDualBrand) {
                    var options = {
                        masterBrandSelected: false,
                        slaveBrandSelected: false,
                        masterBrandAllowed: cardInfo.isBrand1Allowed && app.lastSelectedMethodId !== "bancontact_cc_card",
                        slaveBrandAllowed: cardInfo.isBrand2Allowed && (app.lastSelectedMethodId !== "bancontact_cc_card" || cardInfo.cardBrand2 === 'bancontact')
                    };

                    if (options.masterBrandAllowed) {
                        if ((cardInfo.lastUsedBrand && cardInfo.cardBrand === cardInfo.lastUsedBrand) || !cardInfo.lastUsedBrand) {
                            options.masterBrandSelected = true;
                        }
                    }
                    if (options.slaveBrandAllowed) {
                        if ((cardInfo.lastUsedBrand && cardInfo.cardBrand2 === cardInfo.lastUsedBrand) || !options.masterBrandAllowed) {
                            options.slaveBrandSelected = true;
                        }
                    }

                    var dualBrandSelector =
                    '<div class="row dualBrandRadioBtnWrapper <% if (!options.masterBrandAllowed && !options.slaveBrandAllowed) {%>both_disabled<%}%>" id="dualBrandRadioBtnWrapper">' +
                        '<input type="radio" value="<%- cardInfo.cardBrand %>" name="selectedBrand" class="masterBrandRadioBtn" id="masterBrandRadioBtn" <%if (options.masterBrandSelected) {%> checked="checked" <%} if (!options.masterBrandAllowed) {%> disabled="disabled"<%}%> >' +
                        '<label for="masterBrandRadioBtn" class="dualBrandCardLogo <%- cardInfo.cardBrand %>" <%if (!options.masterBrandAllowed) {%> disabled="disabled" <%}%> ></label>' +
                        '<input type="radio" value="<%- cardInfo.cardBrand2 %>" name="selectedBrand" id="secondaryBrandRadioBtn" <%if (options.slaveBrandSelected) {%> checked="checked" <%} if (!options.slaveBrandAllowed) {%> disabled="disabled" <%}%> >' +
                        '<label for="secondaryBrandRadioBtn" class="dualBrandCardLogo <%- cardInfo.cardBrand2 %>" <%if (!options.slaveBrandAllowed) {%> disabled="disabled" <%}%>></label>' +
                    '</div>';

                    var hasProperDOM = ($('#masterBrandRadioBtn').val() === cardInfo.cardBrand && $('#secondaryBrandRadioBtn').val() === cardInfo.cardBrand2);
                    if (!hasProperDOM) {
                        $cardNumber = $ccCardNumRow.find('#cc_card_number');
                        $dualBrandRadioBtnWrapper.remove();
                        if ($ccCardNumRow.length) {
                            $ccCardNumRow.after(_.template(dualBrandSelector)({cardInfo: cardInfo, options: options}));
                        } else {
                            $('.payment_options_details').append(_.template(dualBrandSelector)({cardInfo: cardInfo, options: options}));
                        }
                        var selectedBrand = options.masterBrandSelected ? cardInfo.cardBrand : cardInfo.cardBrand2;
                        var server_class = options.masterBrandSelected ? (cardInfo.cardBrand + "_" + cardInfo.cardBrand2) : (cardInfo.cardBrand2 + "_" + cardInfo.cardBrand);
                        var isUpo = app.util.isUpo(app.lastSelectedMethodId);
                        fakeCardInfo = {
                            full_class      : server_class + "_dual",
                            server_class    : server_class,
                            master_brand    : cardInfo.cardBrand,
                            slave_brand     : cardInfo.cardBrand2,
                            is_dual_brand	: true
                        };
                        app._flag.requestedCardBrand = selectedBrand;
                        app.util.onCardDetected($cardNumber, selectedBrand, fakeCardInfo, 'brand_selection');
                        app.util.validateRoCardField('dualBrandRadioBtnCreated');
                        $('#dualBrandRadioBtnWrapper input[type=radio][name=selectedBrand]').change(function () {
                            fakeCardInfo.server_class = this.value === cardInfo.cardBrand ? (cardInfo.cardBrand + "_" + cardInfo.cardBrand2) : (cardInfo.cardBrand2 + "_" + cardInfo.cardBrand);
                            fakeCardInfo.full_class = fakeCardInfo.server_class + "_dual";
                            app._flag.requestedCardBrand = this.value;
                            app.util.onCardDetected($cardNumber, this.value, fakeCardInfo, 'brand_selection');
                            if (_g.validationFields.includes('cc_card_number')) {
                                validateField('cc_card_number', $cardNumber.val(), true);
                            }
                            app.util.validateRoCardField('dualBrandRadioBtnChange');
                            app.recalcUserDetailsArea();
                            pubsub.publish('app.event.changeDualBrandedCardBrand', [{selectedBrand: this.value, pmType: app.current_pm_name, uniqueId: app.lastSelectedMethodId, isUpo: isUpo}]);
                        });
                    }
                    return true;
                } else {
                    app._flag.requestedCardBrand = false;
                    $dualBrandRadioBtnWrapper.remove();
                    return false;
                }
            },
            validateRoCardField: function(trigger) {
                var cardNumberFld = app.util.isUpo(app.lastSelectedMethodId) && app.lastSelectedMethodData.paymentDetails && app.lastSelectedMethodData.paymentDetails.cc_card_number;
                var cardFieldVisibility = cardNumberFld && cardNumberFld.visibilityMode;
                if (cardFieldVisibility === "DISABLED" || cardFieldVisibility === "HIDDEN") {
                    var isValid = validateField("cc_card_number_upo_ro", "", true);
                    if (!isValid) {
                        app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, false, "upoCardCurrencyBlocker", app._validationResult.cc_card_number_upo_ro.message);
                        validationFieldsMutator.add('blocked_method');
                    } else {
                        app.util.removePmBlocker(app.lastSelectedMethodId, 'upoCardCurrencyBlocker');
                        var blockers = app._upoList[app.lastSelectedMethodId] && app._upoList[app.lastSelectedMethodId].blockers;
                        if (_.isEmpty(blockers)) {
                            validationFieldsMutator.remove('blocked_method');
                        }
                    }
                    if (trigger !== 'post-upm-render') {
                        utils.renderBlockedPMReasons(app._upoList[app.lastSelectedMethodId]);
                    }
                }
            },
            extendPmDataWithExtraData: function (data, extraData, pmUniqueId) {
                var def = new $.Deferred();
                if (extraData && extraData.uniqueId === app.lastSelectedMethodId && extraData.paymentDetails) {
                    data._extraData = extraData.paymentDetails;
                    /** Currently _maxAmount is not relevant for WD */
                    data._maxAmount = extraData.limits && extraData.limits.maxAmount && parseFloat(extraData.limits.maxAmount) || false;
                }
                if (pmUniqueId !== app.lastSelectedMethodId) {
                    def.reject('flowInterrupted');
                } else {
                    def.resolve(data);
                }
                return def.promise();
            },
            onProcessSelectedPmError: function (uniqueId, data) {
                return function (er) {
                    if (er && er.uniqueId === uniqueId && uniqueId === app.lastSelectedMethodId) {
                        /** ensure that we apply restrictions even if registration is required */
                        app.util.applyLimitsAndFees(data.pmLimits, data.fee);
                        if (er.command === "registerUser") {
                            return utils.registerUser(uniqueId, app.current_pm_name);
                        } else if (er.command === "displayErrorMessage" && er.message) {
                            app.util.clearDOM();
                            /** Disable Continue Btn: */
                            validationFieldsMutator.add('blocked_method');
                            app.showModalErrorMessage(er.message, app.locale.lightbox_title_request_failed, 'lbx_request_failed');
                        } else if (er.command === "redirect" && er.redirectUrl) {
                            app.util.showPmRedirectIframe(er.redirectUrl, er.paymentMethodName);
                        }
                        // else if (er != 'flowInterrupted') { console.log("SHOULDN'T be here!", er);}
                    }
                };
            },
            processSelectedPm: function (data, pmExtraData, payment_method) {
                return utils.confirmNoRegistrationNeeded(data, pmExtraData, payment_method)
                    .then(function (d1) {
                        return app.util.extendPmDataWithExtraData(data, pmExtraData, payment_method);
                    })
                    .then(function (d1) {
                        app.currentMethodFields = data._extraData || data.paymentDetails;
                        data.fee = app.util.updateFeeObj(data);
                        data.pmLimits = data.pmLimits || $.extend(true, {}, app.defaultLimits);
                        app.util.applyLimitsAndFees(data.pmLimits, data.fee);
                        $(app).trigger('withdraw.select_merchant_pm', [data]);
                        return data;
                    })
                    .fail(app.util.onProcessSelectedPmError(payment_method, data));
            },
            processSelectedUpm: function (data, pmExtraData, uniqueId) {
                return utils.confirmNoRegistrationNeeded(data, pmExtraData, uniqueId)
                    .then(function (d1) {
                        return app.util.extendPmDataWithExtraData(data, pmExtraData, uniqueId);
                    })
                    .then(function (d1) {
                        app.currentMethodFields = data._extraData || data.paymentDetails;
                        data.fee = app.util.updateFeeObj(data);
                        data.pmLimits = data.pmLimits || $.extend(true, {}, app.defaultLimits);

                        app.util.applyLimitsAndFees(data.pmLimits, data.fee);
                        $(app).trigger('withdraw.select_user_pms', [data]);
                        return data;
                    })
                    .fail(app.util.onProcessSelectedPmError(uniqueId, data));
            },
            onRegistrationComplete: function (pmExtraData, autoGeneratedRules) {
                $.unblockUI();
                app.util.removeBaseValidationRules(autoGeneratedRules);
                if (pmExtraData && pmExtraData.uniqueId === app.lastSelectedMethodId) {
                    if (pmExtraData.status === "OK" && pmExtraData.paymentDetails) {
                        // render new extraDetails
                        delete app._customWdBtnHandler;
                        var data = app.lastSelectedMethodData || {};

                        if (pmExtraData.paymentMethodName === app.lastSelectedMethodId) { // PM
                            return app.util.processSelectedPm(data, pmExtraData, pmExtraData.uniqueId);
                        } else { // UPO
                            return app.util.processSelectedUpm(data, pmExtraData, pmExtraData.uniqueId);
                        }

                    } else if (pmExtraData.status === "FAIL" /*&& pmExtraData.message*/) {
                        return app.showModalErrorMessage(pmExtraData.message);
                    } else if (pmExtraData.status === "OK" && pmExtraData.command === "redirect" && pmExtraData.redirectUrl) {
                        app.util.showPmRedirectIframe(pmExtraData.redirectUrl, pmExtraData.paymentMethodName);
                        return app.util.rejectedPromise(pmExtraData);
                    }
                }
                return app.util.rejectedPromise('flowInterrupted');
            },
            showPmRedirectIframe: function (redirectUrl, pmName) {
                if (redirectUrl) {
                    var title = t("pm_redirect_iframe_title") + ' <span class="modal_close">&#215;</span>';
                    var pm_class = ('lbx_' + pmName).toLowerCase();
                    var html = app.util.getLightboxContentTemplate('pm_redirect_iframe')({
                        url: redirectUrl,
                        pm_class: pm_class
                    });
                    showModalMessage({message: title, details: html}, pm_class + " pm_redirect");
                }
            },
            createBaseValidationRules: function (data) {
                var ret = {};
                _.each(data, function (item) {
                    if (item && item.name
                        && !validationsMap[item.name]
                        && (item.inputType || '').toUpperCase() !== "BUTTON"
                        && (item.visibilityMode == "REQUIRED" || item.visibilityMode == "OPTIONAL")
                    ) {
                        validationsMap[item.name] = {checks: utils.generateFieldValidationRules(item)};
                        ret[item.name] = "autoGeneratedRulesAdded";
                    }
                });
                app._autoGeneratedValidationRules = $.extend(true, {}, app._autoGeneratedValidationRules, ret);
                return ret;
            },
            removeBaseValidationRules: function (data) {
                _.each(data, function (v, k) {
                    if (v && v === "autoGeneratedRulesAdded") {
                        delete validationsMap[k];
                    }
                });
            },
            validateEvery: function (fld_arr, showResult) {
                var isValid = true;
                _.each(fld_arr, function (fldName) {
                    if (fldName && _.isString(fldName)) {
                        var $input = $('#' + fldName);
                        var alt_selectors = ['input.' + fldName, '.' + fldName + ' select', 'select.' + fldName];
                        _.each(alt_selectors, function (selector) {
                            if (!$input.length) {
                                $input = $(selector);
                            }
                        });
                        isValid = validateField(fldName, $input.val(), showResult) && isValid;
                    }
                });
                return isValid;
            },
            getOnRegisterClickHandler: function (pmName, fields, autoGeneratedRules, submitUrl) {
                var fld_arr = Object.keys(fields || {});
                return function _onContinue(e) {
                    if (app.util.validateEvery(fld_arr, true)) {
                        var url = submitUrl || "/ppp/registerUser.do";
                        var dataToSend = {userDetails: utils.collectRegistrationData(fields)};
                        dataToSend.ssid = app.config.ssid;
                        dataToSend.msid = app.config.merchant_site_id;
                        dataToSend.workflowType = CONSTANTS.WORKFLOW_TYPE_WD;
                        dataToSend.paymentMethod = pmName;
                        dataToSend.uniqueId = app.lastSelectedMethodId;
                        if(app.currentMethodFields.globalpay_accountId){
                            dataToSend.userDetails.globalpay_accountId = app.currentMethodFields.globalpay_accountId.value;
                        }
                        app.util.closeLightbox();
                        $.blockUI();

                        $.ajax({
                            type: "POST",
                            url: utils.addQueryStringParams(url, {"ssid": app.config.ssid}),
                            data: JSON.stringify(dataToSend),
                            contentType: 'application/json',
                            dataType: 'json',
                            timeout: 10000
                        }).done(function (_pmExtraData) {
                            var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                            return app.util.onRegistrationComplete(pmExtraData, autoGeneratedRules);
                        }).fail(function (er) {
                            $.unblockUI();
                            app.showModalErrorMessage('wd.error.session_expired');
                        });
                    }
                };
            },
            getOnCancelRegisterClickHandler: function (pmName, autoGeneratedRules, initiator) {
                function _doNothing(e) {
                    /** Do Nothing */
                }
                function _onCancel(e) {
                    app.util.removeBaseValidationRules(autoGeneratedRules);
                }

                return initiator === 'add_bank_account' ? _onCancel : _doNothing;
            },
            onAddAccountClicked : function (btn) {
                var submitUrl = $(btn).data('action') || "/ppp/registerUser.do";
                utils.getFieldsForAddingBankAccount(app.current_pm_name, app.lastSelectedMethodId).then(
                    function (data) {
                        var payload = utils.getAddAccountScreenPayload(data);
                        var lbxClasses = 'confirm registration';
                        var initiator = 'add_bank_account';
                        app.util.showModalScreenWithFields(data, payload, lbxClasses, submitUrl, initiator);
                    });
            },
            showModalScreenWithFields : function (data, payload, lbxClasses, submitUrl, initiator) {
                var fldNamesArr, autoGeneratedRules, _onContinue, _onCancel;
                var pmName = data && data.paymentMethodName;
                if (pmName !== app.current_pm_name) {
                    return;
                }
                fldNamesArr = _.keys(data && data.fields);
                if(!fldNamesArr.length){
                    console.log("ERROR! There is no data on how to register with the current PM!");
                    return;
                }
                autoGeneratedRules = app.util.createBaseValidationRules(data.fields);

                lbxClasses = (lbxClasses || '') + (' lbx_' + pmName).toLowerCase();
                _onContinue = app.util.getOnRegisterClickHandler(pmName, data.fields, autoGeneratedRules, submitUrl);
                _onCancel = app.util.getOnCancelRegisterClickHandler(pmName, autoGeneratedRules, initiator);

                var tpl = app.util.getLightboxContentTemplate('confirm');
                var title = t(payload.titleKey || 'registration_title');
                app.showModalCustomMessage(tpl, lbxClasses, title, {message: payload}, _onContinue, _onCancel);
                app.applycSelectPlugin();

                $('#lightbox.registration .details').on('change', 'input, select', function (e) {
                    validateField(this.id, this.value, true);
                });
            },

            showRegistrationScreen: function (data) {
                var pmName = app.current_pm_name;
                if (_.isEmpty(data) || pmName !== data.paymentMethodName) {
                    return;
                }
                /**  Prevent submit before Enrollment is done */
                app._customWdBtnHandler = function () {
                    app.util.showRegistrationScreen(data);
                };

                app.util.clearDOM();
                app.currentMethodFields = $.extend(true, {}, data.fields);
                app.current_pm_feeObj = $.extend(true, {}, (data.fee || {}));
                if (app.config.pmHintConfig
                    && (app.config.pmHintConfig.showPMHint || app.config.pmHintConfig.alwaysShownHints.indexOf(app.current_pm_name) > -1)) {
                    app.util.showPaymentMethodHint(app.current_pm_name, app.config.pmHintConfig.containerSelector);
                }
                var userName = (app.user.firstName || '') + " " + (app.user.lastName || '');
                var payload = utils.getRegistrationScreenPayload(data, userName);
                var lbxClasses = 'confirm registration';
                var submitUrl = "/ppp/registerUser.do";
                var initiator = "register_user";
                app.util.showModalScreenWithFields(data, payload, lbxClasses, submitUrl, initiator);
                app.util.onPMSelectedHandleBodyClasses(true);
                pubsub.publish('app.event.registrationScreenShown', [data, {isWD: true}]);
            },
            showRegisterNuveiCardScreen: function() {
                var nviFields = window.enrollmentData.nuvei_card && window.enrollmentData.nuvei_card.fields;
                if (nviFields &&
                    nviFields.firstName && nviFields.firstName.value &&
                    nviFields.lastName && nviFields.lastName.value &&
                    nviFields.email && nviFields.email.value &&
                    nviFields.phone1 && nviFields.phone1.value
                ) {
                    var payload = utils.getRegistrationScreenPayload(window.enrollmentData.nuvei_card, '');
                    var tpl = app.util.getLightboxContentTemplate('confirm');
                    var onContinue = app.util.registerNuveiCardUser;

                    app.showModalCustomMessage(tpl, 'lbx_nuvei_card registration confirm', t('nvi_registration_popup_header_text'), {message: payload}, onContinue, null);

                    $('#lightbox.lbx_nuvei_card .details').on('change', 'input', function (e) {
                        app.validateCustomField(this.id, this.value, true);
                    });
                } else {
                    window.open("https://wallet.tribepayments.com/en/login", '_blank').focus();
                }
            },
            registerNuveiCardUser: function (e) {
                var $nuveiCardLbx = $('#lightbox.lbx_nuvei_card');
                var password = $nuveiCardLbx.find('#nuveiCardPassword').val();
                if (app.validateCustomField('nuveiCardPassword', password, true)) {
                    var data_to_send = {
                        "first_name": $nuveiCardLbx.find('#firstName').val(),
                        "last_name": $nuveiCardLbx.find('#lastName').val(),
                        "email": $nuveiCardLbx.find('#email').val(),
                        "phone1": $nuveiCardLbx.find('#phone1').val(),
                        "nuveiCardPassword": password
                    };
                    $nuveiCardLbx.find('.ok.btn').attr('disabled', true);
                    $.ajax({
                        type		: "POST",
                        url			: "/ppp/withdrawal/registerNuveiCardUser.do?ssid=" + app.config.ssid,
                        contentType	: "application/json",
                        dataType	: "JSON",
                        data		: JSON.stringify(data_to_send),
                    }).success(function (data) {
                        if (data.status === "OK") {
                            var succeseModalOnConfirm = function () {
                                $('.btn_register_nuvei_card_user.row')
                                    .addClass('hidden')
                                    .find('#btn_register_nuvei_card_user')
                                    .attr('disabled', true);
                            };

                            app.showModalCustomMessage(app.util.getLightboxContentTemplate('wd_nuvei_card_user_creation_successfull'), 'success', app.locale.lightbox_success.title, null, succeseModalOnConfirm);
                        } else {
                            app.showModalErrorMessage('nvi_card_user_create_fail_message');
                        }
                    }).fail(function () {
                        app.showModalErrorMessage('nvi_card_user_create_fail_message');
                    });
                }
            },
            getPmExtraDetails: function (pmName, params, data) {
                if (pmName === app.lastSelectedMethodId) {
                    var isWD = true;
                    var extra_data_cfg = CONSTANTS.PM_EXTRA_DATA_URL[pmName] || {};
                    var url = extra_data_cfg.url;
                    params = params || extra_data_cfg.params || {};
                    params.uniqueId = pmName;

                    if (pmName === CONSTANTS.PM_NAME.PLAY_PLUS && app.config.pmSettings[CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance) {
                        params.checkBalance = "true";
                    }

                    data = data || app.lastSelectedMethodData;

                    return utils.getPmExtraDetails(pmName, url, isWD, params)
                        .then(function (_pmExtraData) {
                            var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                            return app.util.processSelectedPm(data, pmExtraData, pmName);
                        });
                }
            },
            getUpmExtraDetails: function (uniqueId, params, data) {
                if (uniqueId === app.lastSelectedMethodId) {
                    data = data || app.lastSelectedMethodData;
                    var isWD = true;
                    var pmName = app.current_pm_name;
                    var extra_data_cfg = CONSTANTS.PM_EXTRA_DATA_URL[pmName] || {};
                    var url = ((data && data['treatItLikePm'] && extra_data_cfg) || {}).url;
                    params = params || extra_data_cfg.params || {};
                    params.uniqueId = uniqueId;

                    if (pmName === CONSTANTS.PM_NAME.PLAY_PLUS && app.config.pmSettings[CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance) {
                        params.checkBalance = "true";
                    }

                    return utils.getPmExtraDetails(pmName, url, isWD, params)
                        .then(function (_pmExtraData) {
                            var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                            return app.util.processSelectedUpm(data, pmExtraData, uniqueId);
                        });
                }
            },
            doSomePmSpecificTask : function (pmName) {
                if(pmName === app.lastSelectedMethodId ){
                    if(pmName === CONSTANTS.PM_NAME.PAY_WITH_MY_BANK){
                        var cfg = app.config.pmSettings[pmName];
                        utils.pwmb.init(cfg);
                        utils.pwmb.renderWidget('.payment_options_details');
                        app._customWdBtnHandler = app.util.pwmbOnWdClickHandler;
                    } else if (dynamicFields.isEnabled(pmName, "pm")) {
                        dynamicFields.init(pmName);
                    }
                }
            },
            doSomeUpmSpecificTask : function (data) {
                if(CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.current_pm_name){
                    return app.util.checkForPwmbUpoToken(data);
                } else if (dynamicFields.isEnabled(app.current_pm_name, "upm")) {
                    dynamicFields.init(app.current_pm_name);
                }
                return data;
            },
            checkForPwmbUpoToken : function (data) {
                if (CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.current_pm_name) {
                    var upoPwmbToken = data && data.paymentDetails && data.paymentDetails.pwmb_token && data.paymentDetails.pwmb_token.value;
                    var upoPwmbPaymentProviderId = data && data.paymentDetails && data.paymentDetails.pwmb_providerId && data.paymentDetails.pwmb_providerId.value;
                    if (!upoPwmbToken) {
                        var cfg = app.config.pmSettings[CONSTANTS.PM_NAME.PAY_WITH_MY_BANK];
                        if (upoPwmbPaymentProviderId && cfg) {
                            cfg = $.extend(true, {PayWithMyBankOptions: {}}, cfg);
                            // cfg.PayWithMyBankOptions.hideCloseButton = false;
                            cfg.PayWithMyBankOptions.hideSelectBankBack = true;
                            cfg.paymentProviderId = upoPwmbPaymentProviderId;
                        }
                        if (cfg) {
                            utils.pwmb.init(cfg);
                            data._onContinueTreatItLikePm = app.lastSelectedMethodType;
                            app._customWdBtnHandler = app.util.pwmbOnWdClickHandler;
                        }
                    }
                }
                return data;
            },
            onPwmbAuthorizationSuccessDoSubmit: function (data) {
                if (CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.current_pm_name
                    && data
                    && data.trxStatus !== 'CANCELLED'
                    && data.uniqueId
                    && data.uniqueId.toString() === (app.lastSelectedMethodId || '').toString()
                    && data.details) {
                    app.makeRequest(data.details);
                    pubsub.publish('app.event.WithdrawClicked', []);
                }
            },
            pwmbOnWdClickHandler : function () {
                if(app.validateInput()) {
                    utils.pwmb.renderLbx();
                }
            },
            rejectedPromise : function (error) {
                return (new $.Deferred()).reject(error).promise();
            },
            clearDOM : function () {
                $('.cSelect[data-id="amount_select"]').remove();
                $('[data-role="pm_hint"]').remove();
                $('[data-role="inline_info_msg"]').remove();
                $('.PMINFO, .payment_options_details').empty();
                $('#remove_upo_wrapper').empty();
                app.util.handleFee({});
                app.suggestPointsPlugin && app.suggestPointsPlugin.setData([]);
                var $amount_validation = $('#amount_validation');
                $amount_validation.empty().removeClass('invalid_field, valid_field');
                $amount_validation.closest('.row').removeClass('invalid, valid');
                var isValid = app.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
            },
            removePmBlocker: function (pmId, blockerKey) {
                if (pmId && blockerKey) {
                    var data = app[(app.util.isUpo(pmId) ? '_upoList' : '_poList')][pmId];
                    if (data && !_.isEmpty(data.blockers) && data.blockers[blockerKey]) {
                        delete data.blockers[blockerKey];
                    }
                    if (pmId === app.lastSelectedMethodId && !_.isEmpty(app.lastSelectedMethodData.blockers) && app.lastSelectedMethodData.blockers[blockerKey]) {
                        delete app.lastSelectedMethodData.blockers[blockerKey];
                    }
                }
            },
            addSuspendedPmBlocker: function (pmId, hasCustomHandling, blockerKey, blockerMsg) {
                if (pmId && !hasCustomHandling) {
                    var data = app[(app.util.isUpo(pmId) ? '_upoList' : '_poList')][pmId];
                    if (data && _.isEmpty(data.blockers)) {
                        data.blockers = utils.createSuspendedPmBlocker(blockerKey, blockerMsg);
                    }
                    if (pmId === app.lastSelectedMethodId && _.isEmpty(app.lastSelectedMethodData.blockers)) {
                        app.lastSelectedMethodData.blockers = utils.createSuspendedPmBlocker(blockerKey, blockerMsg);
                    }
                }
            },
            updateFieldsForValidation: function (paymentDetails, isBlocked) {
                app._isOptionalField = {};
                _g.validationFields = _g.defaultValidationFields.concat(_.filter(_.keys(paymentDetails), function (fldName) {
                    var needsValidation = (
                        (paymentDetails[fldName].inputType || '').toUpperCase() !== "BUTTON"
                        && (paymentDetails[fldName].visibilityMode === CONSTANTS.VISIBILITY_MODE.REQUIRED || paymentDetails[fldName].visibilityMode === CONSTANTS.VISIBILITY_MODE.OPTIONAL)
                    );
                    if (needsValidation && paymentDetails[fldName].visibilityMode ===  CONSTANTS.VISIBILITY_MODE.OPTIONAL) {
                        app._isOptionalField[fldName] = 1;
                    }
                    return needsValidation;
                }));
                if (isBlocked) {
                    validationFieldsMutator.add('blocked_method');
                }
                return _g.validationFields;
            },
            cardNumberPostRender: function ($element) {
                if(!$element || $element.attr('disabled')){
                    return;
                }
                $element.setMask('cc');
                $('.PMINFO').addClass(checkCardType($element.val()) + 'Logo');
                var alreadyBlockedMethod = 0;
                $element.keyup(function () {
                    var inputCardElm = $(this);
                    var oldClasses = inputCardElm.attr('class');
                    var cardInfo = _checkCardType(this.value);
                    var detectedType = cardInfo.server_class;
                    app.util.onCardDetected($element, detectedType, cardInfo, 'card_fld_change');
                    var pmData = app._poList[detectedType];
                    if (!_.isEmpty(pmData) && !_.isEmpty(pmData.blockers)) {
                        if (!alreadyBlockedMethod) {
                            validationFieldsMutator.add('blocked_method');
                            alreadyBlockedMethod = true;
                        }
                    } else {
                        validationFieldsMutator.remove('blocked_method');
                        alreadyBlockedMethod = false;
                    }
                    if (oldClasses != inputCardElm.attr('class')) {
                        utils.renderBlockedPMReasons(pmData);
                        recalcUserDetailsArea();
                    }
                });
                $element.on('paste', function () {
                    pubsub.publish('app.event.cc_card_number_pasted', []);
                });
            },
            onCardDetected: function ($cc_elm, detectedType, cardInfo, initiator) {
                var new_css_class = detectedType + 'Logo';
                $cc_elm && $cc_elm.removeClass(app.CONSTANTS.CARD_LOGO_CLASSES).addClass(new_css_class);
                $('.PMINFO').removeClass(app.CONSTANTS.CARD_LOGO_CLASSES).addClass(new_css_class);
                app.lastCardDetected = detectedType;
                app.util.handleCardHolderNameVisibility(app.lastCardDetected);
            },
            handleCardHolderNameVisibility: function (lastCardDetected) {
                app.bodyElm.removeClass("disable_cc_name_on_card");
                if (app.util.isUpo(app.lastSelectedMethodId) && app.currentMethodFields['cc_name_on_card']) {
                    var $nameOnCard = $('#cc_name_on_card');
                    var isNameOnCardEditable = app.currentMethodFields['cc_name_on_card'].type !== "DISABLED" && app.currentMethodFields['cc_name_on_card'].type !== "HIDDEN";
                    
                    if (isNameOnCardEditable && $nameOnCard.length && !app.currentMethodFields['cc_name_on_card'].value) {
                        if (app.config.disableCardholderNameForCardBrands[lastCardDetected]) {
                            app.bodyElm.addClass("disable_cc_name_on_card");
                            validationFieldsMutator.remove('cc_name_on_card', app.currentMethodFields['cc_name_on_card'].type === "OPTIONAL");
                            $nameOnCard.val('');
                        } else {
                            validationFieldsMutator.add('cc_name_on_card', app.currentMethodFields['cc_name_on_card'].type === "OPTIONAL");
                        }
                    }
                }
            },
            onWsMessage: function (eventObj) {
                if (eventObj  && eventObj.details && eventObj.trxStatus && eventObj.eventType === "websocket"){
                    var wdRequestId = eventObj.details.withdrawalRequestId;
                    var pmName = eventObj.details.upo && eventObj.details.upo.paymentOptionName;
                    if (wdRequestId && pmName === "apmgw_eCheckSelect"
                        && app.submittedMethod && app.submittedMethod.pmName === pmName
                        && eventObj.eventName === "safecharge.wd_transaction.complete"
                        && !app._processedWdRequest[wdRequestId]
                    ) {
                        eventObj.details.isWs = true;
                        pubsub.publish('safecharge.wd_transaction.complete', [eventObj.details]);
                    }
                }
            },
            wdUpoMutator: function (item) {
                return item;
            },
            normalizeOrderSplitData: function (wdOrdersArr) {
                return _.map(wdOrdersArr, function (item) {
                    var feeObj = item[CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES] || {};
                    feeObj = app.util.getFeeRenderingData(feeObj, item.amount, item.currency);
                    var issuer = '';
                    var shortPmClass = item.poName || '';
                    if (app.config.cc_cards_db[item.poName]) {
                        issuer = item.card_type;
                        shortPmClass = item.card_type;
                    }
                    if (item.poName == "visa_checkout") {
                        issuer = item.card_type;
                    }
                    var pmClass = 'wd_smallpms_' + shortPmClass.toLowerCase();
                    shortPmClass += utils.getCustomImgClassNameSuffix(item.metadata, item.upoId);
                    return {
                        amount       : item.amount,
                        currency     : item.currency,
                        pmClass      : pmClass,
                        status       : item.status,
                        upoName      : item.upoName,
                        upoId        : item.upoId,
                        poName       : item.poName,
                        shortPmClass : shortPmClass,
                        issuer       : issuer,
                        fee          : feeObj,
                        useIntl      : app.config.useIntlFormatter,
                        formattedAmount : app.formatter.formatCurrency(item.amount, item.currency, null, true)
                    }
                });
            },
            getLogger: function () {
                var _log = {}, _logLevel = 0;

                function log(data, logLevel) {
                    if (logLevel === 0 || _logLevel >= logLevel)
                        _log[Date.now().toString()] = JSON.stringify(data);
                }

                return {
                    log: function (data) {
                        log(data, 0); // log always
                    },
                    log_1: function (data) {
                        log(data, 1);
                    },
                    log_2: function (data) {
                        log(data, 2); // log only when _logLevel >= 2
                    },
                    showLog: function () {
                        var ret = {};
                        _.each(Object.keys(_log), function (x) {
                            if (_log.hasOwnProperty(x)) {
                                try {
                                    ret[x] = JSON.parse(_log[x]);
                                } catch (e) {
                                    console.log('invalid json');
                                }
                            }
                        });
                        return ret;
                    },
                    setLogLevel: function (level) {
                        return _logLevel = level;
                    }
                };
            }
        },
        applycSelectPlugin :function () {
            var elm = $('select[data-plugin="cSelect"]');
            if (elm.length) {
                elm.cSelect();
            }
        },
        resetMainFlags: function () {
            this._flag.errorCode1082 = false;
            this._flag.withdrawalAllowed = false;
        },
        validateSingleField: function (evt) {
            var fieldName = _.intersection(_g.validationFields, _.values(evt.currentTarget.classList))[0];
            return validateField(fieldName, evt.currentTarget.value, true);
        },
        showValidationStatus: function () {
            return showValidationStatus(_g.validationFields);
        },
        validateCustomField: function (fieldName, value, showResult) {
            return validateField(fieldName, value, showResult);
        },
        _showFieldsForValidation: function () {
            return $.extend([], _g.validationFields);
        },
        tpls: {},
        stores: {},
        rpc: (function (methods) {
            var methodsHash = {};
            _.forEach(methods, function (method) {
                methodsHash[method.name] = function () {
                    var self = this;
                    var url = method.url;
                    var req_params = method.req.slice();
                    if (isStaticPage()) { // mock some data and work offline
                        url = 'data/' + method.url + '.json';
                        if (method.name === 'getMerchantPaymentMethods') {
                            url = staticPrefix + 'data/' + (self.ptRequestId ? 'pt_' : '') + method.url + '.json';
                        }
                        if (method.name === 'retrieveUserPMSDetails') {
                            url = staticPrefix + 'data/pmss/' + (self.ptRequestId ? 'pt/' : '') + self.userPaymentOptionId + '.json?' + _.now();
                        }
                        if (method.name === 'retrieveMerchantPMSDetails') {
                            url = staticPrefix + 'data/mpmss/' + (self.ptRequestId ? 'pt/' : '') + self.payment_method + '.json?' + _.now();
                        }
                        if (method.url === 'cancel.do') {
                            url = staticPrefix + 'static/' + (self.ptRequestId ? 'pt_' : '') + method.url;
                        }
                    }
                    if (self.ptRequestId) {
                        req_params.push('ptRequestId');
                        url = isStaticPage() ? url : 'withdrawal/' + url;
                    }
                    console.log('Retrieving ', url);
                    return $.ajax({
                        url: url,
                        dataType: "json",
                        data: _.zipObject(req_params, _.map(req_params, function (paramKey) {
                            return self[paramKey];
                        }))
                    });
                }
            });
            return methodsHash;
        })([
            {
                name: 'cancelWithdrawRequest',
                url: 'cancel.do',
                req: ['ssid', 'wdRequestIdToCancel', 'user_token_id']
            },
            {
                name: 'getMerchantPaymentMethods',
                url: 'getMerchantSitesPaymentMethods.do',
                req: ['ssid', 'country', 'user_token_id', 'merchant_site_id', 'wd_amount', 'isRebillingHidden', 'wd_currency', 'merchantLocale']
            },
            {
                name: 'retrieveUserPMSDetails',
                url: 'selectUserPaymentMethod.do',
                req: ['ssid', 'userPaymentOptionId', 'merchant_site_id', 'merchantLocale', 'user_token_id']
            },
            {
                name: 'retrieveMerchantPMSDetails',
                url: 'selectMerchantPaymentMethod.do',
                req: ['ssid', 'payment_method', 'merchant_site_id', 'merchantLocale', 'user_token_id']
            }
        ]),
        preparePMViewData: function (data) {
            _g.pmFields = data;
            app.currentMethodFields = data;

            var inputFields = [];
            var inputFieldsObj = {};
            _.forIn(data, function (item, key) {
                if (_.isObject(item)) {
                    var newItem = _.omit(_.omit(item, 'inputType'), 'ftlTypeName');
                    newItem.name = key;
                    newItem.value = newItem.value || '';
                    newItem.inputType = (item.inputType || 'text').toLowerCase();
                    inputFields.push(newItem);
                }
            });
            inputFields.sort(function (item1, item2) {
                return item1.uiOrder - item2.uiOrder;
            });
            _.each(inputFields, function (inputObj) {
                if (inputObj.name && validationsMap[inputObj.name] && validationsMap[inputObj.name].renderMutator) {
                    inputObj = validationsMap[inputObj.name].renderMutator(inputObj);
                }
                if (inputObj.name === 'cc_exp_year' || inputObj.name === 'cc_exp_month') {
                    if (!_.has(inputFieldsObj, 'expiration_period')) {
                        inputFieldsObj['expiration_period'] = [];
                    }
                    inputFieldsObj['expiration_period'].push(inputObj);
                } else {
                    inputFieldsObj[inputObj.name] = inputObj;
                }
            });

            return inputFieldsObj;
        },
        prepareCardUserPMGeneralViewData: function(data) {
            var fieldsObj = app.preparePMViewData(data);
            if (fieldsObj['expiration_period'] && fieldsObj['expiration_period'].length === 2) {
                var d = {};
                d[fieldsObj['expiration_period'][0].name] = fieldsObj['expiration_period'][0].value;
                d[fieldsObj['expiration_period'][1].name] = fieldsObj['expiration_period'][1].value;
                fieldsObj['cc_exp_date'] = {
                    "value": d.cc_exp_month + " / " + d.cc_exp_year,
                    "label": "expires",
                    "visibilityMode": "DISABLED",
                    "inputType": "text",
                    "name": "cc_exp_date",
                    "uiOrder": 10
                };
                delete fieldsObj['expiration_period'];
            }
            if (fieldsObj["cc_card_number"]) {
                fieldsObj["cc_card_number"].value = "* " + (fieldsObj["cc_card_number"].value).slice(-4);
            }
            return fieldsObj;
        },
        handleUpmDetails: function (data) {
            var self = this;
            var fields = data._extraData || data['paymentDetails'];
            var cardSource = (fields.cc_cardSource && fields.cc_cardSource.value);
            if (_shouldRenderCardInUserPMSGeneralView(cardSource)) {
                // the field "cc_cardSource" is not for rendering,
                // so we will keep the value from it to the label (just in case)
                fields.cc_cardSource.label = fields.cc_cardSource.value;
                fields.cc_cardSource.value = ""; // means: "Do Not render this field" in userPMSGeneralView
            } else {
                delete fields.cc_cardSource;
            }
            var payload = _shouldRenderCardInUserPMSGeneralView(cardSource) ? app.prepareCardUserPMGeneralViewData(fields) : app.preparePMViewData(fields);
            var paymentOptionName = this.stores.user_payment_methods._byId[data.userPaymentOptionId].get('paymentOptionName');
            var showExpiredMessage = this.checkPMForExpiredCC(data);
            var $pminfo = $(".payment_options_details"); // ~= $(".PMINFO.payment_options_details");
            var pmsDetailsElm = $('.pms_details'); // default WD page
            var isEditable = false;
            _.forIn(data['paymentDetails'], function (item) {
                if (_.isObject(item)) {
                    if (item['visibilityMode'] === CONSTANTS.VISIBILITY_MODE.REQUIRED || item['visibilityMode'] === CONSTANTS.VISIBILITY_MODE.OPTIONAL) {
                        isEditable = true;
                    }
                }
            });

            app.util.extendUpoListData(data);
            pmsDetailsElm.hide();
            $pminfo.html('');
            $('[data-role="inline_info_msg"]').remove();
            $('[data-role="pm_hint"]').remove();

            if (data._extraData || CONSTANTS.USE_EXTRA_DETAILS_VIEW_PER_PM[paymentOptionName]) {
                app.util.createBaseValidationRules(payload);
                $pminfo.html(utils.getExtraDetailsHtml(payload));
                app.applycSelectPlugin();
                _onUpmRenderDone();
            } else if (paymentOptionName === "visa_checkout") {
                var upoData = app._upoList[app.lastSelectedMethodId] || {};
                payload.card_type = (upoData.card_type || paymentOptionName);
                payload.logoUrl = (payload.cardArtsUrl.value || cssCreator.resourcePrefix + "solid-white/visa_checkout.svg");
                payload.last_4_digits = "";
                var regExCardPattern = /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/;
                if (regExCardPattern.test(upoData.name)) {
                    payload.last_4_digits = ((upoData.name).match(regExCardPattern)[1] || (upoData.name).match(regExCardPattern)[2] || (upoData.name).match(regExCardPattern)[3]);
                }
                $.extend(true, data, {normalizedData: payload, paymentDetails: {visa_checkout_cc_cvv2: payload.visa_checkout_cc_cvv2}});
                this.vcoPMView.setElement($('.payment_options_details'));
                this.vcoPMView.render(data).then(_onUpmRenderDone);
            } else if (CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === paymentOptionName) {
                var logoUrl = app.config.pmSettings.apmgw_Online_Banking && app.config.pmSettings.apmgw_Online_Banking.logoUrl;
                var bankID = fields.pwmb_providerId && fields.pwmb_providerId.value;
                payload.logoUrl = (logoUrl && bankID ? t(logoUrl, [bankID]) : "https://paywithmybank.com/start/assets/institutions/defaults/icon/default_green.png");
                $.extend(true, data, {normalizedData: payload});
                this.vcoPMView.setElement($('.payment_options_details'));
                this.vcoPMView.render(data).then(_onUpmRenderDone);
            } else if (isEditable) {
                this.userPMSEditable.setElement($('.payment_options_details'));
                this.userPMSEditable.render({fields: payload}).then(_onUpmRenderDone);
            } else if (app.config.cc_cards_db[paymentOptionName] && !_shouldRenderCardInUserPMSGeneralView(cardSource)) {
                fields.card_type = this.stores.user_payment_methods._byId[data.userPaymentOptionId].get("card_type");
                this.userCreditCardPMView.setElement($('.payment_options_details'));
                this.userCreditCardPMView.render(fields).then(_onUpmRenderDone);
            } else if (paymentOptionName === CONSTANTS.PM_NAME.FBT || paymentOptionName === CONSTANTS.PM_NAME.FFBT || paymentOptionName === CONSTANTS.PM_NAME.CITADEL) {
                this.fbtPMView.setElement($('.payment_options_details'));
                this.fbtPMView.render(data).then(_onUpmRenderDone);
            } else {
                this.userPMSGeneralView.setElement($('.payment_options_details'));
                this.userPMSGeneralView.render({paymentDetails: payload}).then(_onUpmRenderDone);
            }

            /***************  handleUpmDetails helpers Start  *************/
            function _shouldRenderCardInUserPMSGeneralView(cardSource) {
                // cardSource: "NOT_CARD" | "REGULAR_CARD" | "GOOGLE_PAY_PAN" | "GOOGLE_PAY_DPAN" | "APPLE_PAY" | "BANCONTACT"
                return (cardSource === "GOOGLE_PAY_PAN" || cardSource === "GOOGLE_PAY_DPAN" || cardSource === "APPLE_PAY" || cardSource === "BANCONTACT");
            }

            function _onUpmRenderDone() {
                _.forIn(fields, function (item, key) {
                    var currentElm = $('input.' + key);
                    var alt_selectors = ['.' + key + ' select', 'select.' + key];
                    _.each(alt_selectors, function (selector) {
                        if (!currentElm.length) {
                            currentElm = $(selector);
                        }
                    });
                    if (currentElm.length && validationsMap[key] && validationsMap[key].postRender) {
                        validationsMap[key].postRender.call(self, currentElm);
                    }
                });
                var isValid = self.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
                pmsDetailsElm.show('slide');
                if (showExpiredMessage) {
                    onValidationResult(null, false, ['cc_exp_month', 'cc_exp_year'], msg.validation.invalid_expiration_date, 'invalid_expiration_date');
                }
                app.util.addRemoveUpmButton(null, data.userPaymentOptionId, app.current_pm_name);
                if (app.config.pmHintConfig
                    && (app.config.pmHintConfig.showPMHint || app.config.pmHintConfig.alwaysShownHints.indexOf(app.current_pm_name) > -1)
                    && (app.config.pmHintConfig.pmOnlyHints.indexOf(app.current_pm_name) === -1)) {
                    app.util.showPaymentMethodHint(app.current_pm_name, app.config.pmHintConfig.containerSelector); /* '.PMINFO' | '.payment_options_details' */
                }
                app.util.doSomeUpmSpecificTask(data);
                app.util.onPMSelectedHandleBodyClasses(true);
                recalcUserDetailsArea();
                pubsub.publish('post-upm-render', [{userPaymentOptionId: data.userPaymentOptionId, pmName: paymentOptionName}]);
            }
            /***************  handleUpmDetails helpers End  *************/
        },
        handlePmDetails: function (fields, extraData) {
            var self = this;
            var data = (extraData || fields);
            var payload = this.preparePMViewData(data);
            var $pminfo = $('.payment_options_details');
            $('[data-role="inline_info_msg"]').remove();
            $('[data-role="pm_hint"]').remove();
            if (extraData || CONSTANTS.USE_EXTRA_DETAILS_VIEW_PER_PM[app.lastSelectedMethodId]) {
                app.util.createBaseValidationRules(extraData || payload);
                $pminfo.html(utils.getExtraDetailsHtml(extraData || payload));
                app.applycSelectPlugin();
                onPmRenderDone();
            } else {
                this.userPMSEditable.setElement($pminfo);
                this.userPMSEditable.render({fields: payload}).then(onPmRenderDone);
            }

            function onPmRenderDone() {
                _.forIn(data, function (item, key) {
                    var currentElm = $('input.' + key);
                    var alt_selectors = ['.' + key + ' select', 'select.' + key];
                    _.each(alt_selectors, function (selector) {
                        if (!currentElm.length) {
                            currentElm = $(selector);
                        }
                    });
                    if (currentElm.length && validationsMap[key] && validationsMap[key].postRender) {
                        validationsMap[key].postRender.call(self, currentElm);
                    }
                });
                $('.pms_details').hide('slide').show('slide'); // Default [WD] Theme

                app.util.addRemoveUpmButton(null, app.lastSelectedMethodId, app.current_pm_name);
                if (app.config.pmHintConfig
                    && (app.config.pmHintConfig.showPMHint || app.config.pmHintConfig.alwaysShownHints.indexOf(app.current_pm_name) > -1)) {
                    app.util.showPaymentMethodHint(app.current_pm_name, app.config.pmHintConfig.containerSelector);
                }

                app.util.doSomePmSpecificTask(app.lastSelectedMethodId);
                app.util.onPMSelectedHandleBodyClasses(true);
                recalcUserDetailsArea();
                pubsub.publish('post-pm-render', [data]);
            }
        },
        renderWithdrawalList: function () {
            pubsub.publish('withdraws-available', [app.stores.withdraw_requests.toJSON()]);
        },
        showModalErrorMessage: function (message, title, sub_css_class) {
            sub_css_class || (sub_css_class = '');
            var tpl;
            if (!message) {
                message = msg.errors.general;
                title = msg.errors.general_title;
                tpl = app.util.getLightboxContentTemplate('error_fatal');
                sub_css_class = 'error_fatal';
            } else if (message === 'wd.error.session_expired') {
                tpl = app.util.getLightboxContentTemplate('error_session_expired');
                sub_css_class = 'error_session_expired';
            }
            var payload = {message: message};
            this.showModalCustomMessage(
                (tpl || app.util.getLightboxContentTemplate('error')),
                CONSTANTS.MODAL_MESSAGE_TYPE.ERROR + ' ' + sub_css_class,
                (title || msg.lightbox_failed_title),
                payload
            );
            pubsub.publish('lightbox.opened', [{type: 'error', sub_type: sub_css_class}]);
        },
        showModalCustomMessage: function (tpl, type, headerText, payload, onConfirm, onCancel) {
            payload = payload || {};
            var lightBoxElm = $("#lightbox");
            $('.modalOverlay').fadeIn();

            lightBoxElm.removeClass().addClass(type);
            $('.lightbox-header h2', lightBoxElm).html(headerText);
            $('.lightbox-content', lightBoxElm).html(tpl(payload));

            $('.content_inside').unblock();
            $.unblockUI();
            app.modalLink.trigger('click');

            $('.ok, .positive, .done', lightBoxElm).on('click', function () {
                (onConfirm || function () {
                })();
            });
            $('.on_cancel, .no', lightBoxElm).on('click', function () {
                (onCancel || function () {
                })();
            });
            pubsub.publish('lightbox.opened', [{type: type}]);
        },
        openedInIFrame: function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }(),
        checkWithdrawalAllowed: function (pmName) {
            var self = this;
            var checkWithdrawalAllowedURL = this.util.getWithdrawalAllowedUrl(pmName);

            $.getJSON(checkWithdrawalAllowedURL, function (data) {
                var result = data || {};
                if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_OK) {
                    self._flag.withdrawalAllowed = true; // continue
                    app.makeRequest(); // app.onWithdrawClicked();
                    return true;
                } else if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_FAIL && _.has(result, 'confirmations')) {
                    var payload = {confirmations: result['confirmations']};
                    var blockOverlay = $(".content_inside");
                    blockOverlay.unblock();
                    var tpl = app.util.getLightboxContentTemplate('casino_confirmation');
                    var onConfirm = function () {
                        var wdRequest = result.wdRequest || {};
                        self.rpc.wd_requestId = wdRequest.wd_requestId;
                        if (_.has(result, 'registeredUpo')) {
                            self.rpc.registeredUpo = result['registeredUpo'];
                        }
                        self.rpc.ptConfirmedUserActions = JSON.stringify(_.pluck(result['confirmations'], 'key'));
                        self._flag.withdrawalAllowed = true;
                        app.makeRequest(); // app.onWithdrawClicked();
                    };
                    self.showModalCustomMessage(
                        tpl,
                        CONSTANTS.MODAL_MESSAGE_TYPE.CASINO_CONFIRM,
                        t("lightbox_casino_confirm_title"),
                        payload,
                        onConfirm
                    );
                    return false;
                } else if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_FAIL) {
                    self._flag.withdrawalAllowed = false;
                    self.showModalErrorMessage(result.message);
                    return false;
                }
            });
        },
        init: function (config) {
            utils.showVersionOnAltVTwice();
            msg = app.locale;
            app.pluginOpts = app.pluginOpts || {};
	        app._deviceType = utils.getUserAgentInfo().isMobile ? CONSTANTS.DEVICE_TYPE.MOBILE : CONSTANTS.DEVICE_TYPE.DESKTOP;
            app._logger = app.util.getLogger();
            app._currentPMLimits = {};
            app._isOptionalField = {};
            app._validationResult = {};
            app._poList = {};
            app._upoList = {};
            app._doNotSubmitFields = {};
            app._processedWdRequest = {};
            app._preWdParamId = false;
            app.lastCardDetected = 'none';

            config.userPaymentOptionId = (config.userPaymentOptionId === 'null') ? null : config.userPaymentOptionId;
            config.selected_method = (config.selected_method === 'null') ? null : config.selected_method;
            config.cardSupportedCurrencies = utils.remapCardSupportedCurrencies(config.cardSupportedCurrencies);
            this.config = config;

            app.formatter = app.util.getFormatter(config.useIntlFormatter);
            app._webViewSDK = (window.NuveiCashierHelper || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.NuveiCashierHelper);
            app.util.asyncCheck = utils.getCardAsyncChecker(config.country, config.ssid, config.merchant_site_id, "/ppp/checkWithdrawalCardDetails");
            app.user = app.util.getUserData();
            _.templateSettings.imports = {t : t, c : app.formatter};
            app._t = t;
            app.bodyElm = $('body');
            var self = this;
            app.util.injectDefaultCss();
            app.util.loadMainLayout();
            app.util.applySuggestPointsPlugin();
            if (app.config.layout && app.config.layout === '1') {
                app.config.paydotcomPopup = false;
            }
            $('div[data-pms-type="dropdown"]').PMSelect(app.util.normalizePluginOpts(app.pluginOpts.PMSelect));
            $('div[data-pms-type="vertical"]').PMSelectV(app.util.normalizePluginOpts(app.pluginOpts.PMSelectV));
            $('div[data-pms-type="horizontal"]').PMSelectH(app.util.normalizePluginOpts(app.pluginOpts.PMSelectH));
            $('div[data-pms-type="accordion"]').PMSelectAccordion(app.util.normalizePluginOpts(app.pluginOpts.PMSelectAccordion));
            $('div[data-pms-type="table"]').PMSelectTable(app.util.normalizePluginOpts(app.pluginOpts.PMSelectTable));
            var $plugin_type_withdrawals = $('div[data-plugin-type="withdrawals"]');
            if ($plugin_type_withdrawals.length) {
                var wd_list_opt = $.extend(true, {}, app.pluginOpts.PMWithdrawList);
                wd_list_opt.useIntl = app.config.useIntlFormatter;
                if (app.config.useIntlFormatter && !wd_list_opt.currencyFormatter) {
                    wd_list_opt.currencyFormatter = function (currency, value) {
                        return app.formatter.formatCurrency(value, currency, null, true);
                    }
                }
                $plugin_type_withdrawals.PMWithdrawList(app.util.normalizePluginOpts(wd_list_opt));
            }
            var $grid = $('div[data-pms-type="grid"]');
            if ($grid.length) {
                $grid.PMSelectGrid(app.util.normalizePluginOpts(app.pluginOpts.PMSelectGrid));
            }

            app.modalLink = $('<a href="#' + 'lightbox"></a>');
            app.modalLink.sModal({
                closeButton: ".modal_close",
                onClose: app.onNotificationEnd
            });

            app.defaultLimits = {
                'currencyIso': config.wd_currency,
                'minValue': config.wd_min_amount,
                'maxValue': config.wd_max_amount,
                'defaultAmount': config.wd_amount
            };
            app.lastSelectedCurrency = config.wd_currency;

            utils.handlePassiveEvents();

            /** <fix iScroll Vertical behaviour START> */
            $('[data-plugin="scrollable"].scrollable .scroll-container').on('keyup', utils.onTabPressFixIScroll);
            $('[data-plugin="scrollable"].scrollable').on('scroll', function (e) {
                $(this).scrollTop(0);
            });
            /** <fix iScroll Vertical behaviour END/> */

            $('.btn_cancel').on('click', function () {
                console.log('cancel', config.parentUrl);
                sendPostMessage('cancel', config.parentUrl || '');
            });

            // <REMOVE_ME> after muchbetter template fix in WD themes [USE: Composite Phone]
	        var prepareMuchBetterForValidation = function(){
		        var suffix = $('#muchBetter_mobilePhone_suffix');
		        var val = suffix.val();
		        var counryCode = $("#muchbetter_country_code").val();
		        if(!suffix.attr('data-mask')){
			        suffix.attr('data-mask', 'num');
			        suffix.numberMask({type : 'number', beforePoint : 15, afterPoint : 0});
		        }
		        var newVal = '';
		        if (counryCode && val) {
                    newVal = counryCode + "-" + val;
		        }
                $('input#muchBetter_mobilePhone').val(newVal).trigger("change");
		        app.validateCustomField('muchBetter_mobilePhone',newVal,true);
	        };
	        $(document).on("change", "#muchbetter_country_code", function(){
		        prepareMuchBetterForValidation();
	        });
	        $(document).on("keyup change", "#muchBetter_mobilePhone_suffix", function(){
		        prepareMuchBetterForValidation();
            });
            // </REMOVE_ME> after muchbetter template fix in WD themes

            // default_template Composite Phone Handling
	        $(document).on("change", "#country_phone_code", app.util.prepareCompositePhoneForValidation);
	        $(document).on("keyup change", "#composite_phone_suffix", app.util.prepareCompositePhoneForValidation);

	        $(document).on("blur", "#wd_iban", function() {$(this).val($(this).val().toUpperCase())});

            if(app.config.storeCard && app.config.storeCard.isActive) {
                $(document).on('click', '.scc .open-terms', utils.showStoreCardTerms);
            }

            //TODO: check this (~= app.lastSelectedAmount)
            $(document).on('blur', '.amount', function () {
                app.config.wd_amount = $(this).val();
            });
            $(document).on('click', '.send_message', utils.sendPostMessageFromAttr);
            $(document).on('change keyup setValue', 'input.amount', function (ev) {
                var amount = $(this).val();
                if (app.suggestPointsPlugin) {
                    app.suggestPointsPlugin.setValue(parseFloat(amount));
                }
                pubsub.publish('app.event.AmountChange', [amount, ev.type]);
            });

            if (app.config.wd_open_amount) {
                app.util.maskedItemAmountPlugin = utils.MaskedAmount.init(true);
            }

            if (!config.ptRequestId) {
                app.util.setAmountValue(config.wd_amount, ['setValue', 'change'], 'init');
            }

            jQuery.ajaxSetup({
                cache: false,
                error: function (xhr, statusText, err) {
                    delete app.rpc.wd_requestId;
                    //app.locale.errors.general
                    $('body').removeClass('overflowed');
                    $('.modalOverlay').fadeOut();
                    var blockOverlay = $(".content_inside");
                    blockOverlay.block();
                    $('a.modal_close').off('click');
                    $('input').attr('disabled', false);
                    $('button.withdraw').attr('disabled', true); // false
                    blockOverlay.unblock();
                    self.showModalErrorMessage();
                },
                dataFilter: function (data, type) {
                    delete app.rpc.wd_requestId;
                    if (type === 'json') {
                        if (data.length === 0) return [{}]; // TODO fix me!
                        if (data.substring(0, 5) == "<html") {
                            var _msg = $('<div>').html(data).find('p');
                            self.showModalCustomMessage(
                                app.util.getLightboxContentTemplate('error_fatal_html'),
                                CONSTANTS.MODAL_MESSAGE_TYPE.ERROR,
                                '',
                                {message: _msg.html()}
                            );
                            return false;
                        }
                        var result = JSON.parse(data) || {};
                        if (result.redirectURL) {
                            app.util.performRedirect(result);
                            return false;
                        }
                        if (result.pmRedirectURL) {
                            app.util.handlePopUpPM(result);
                            return false;
                        }
                        if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_FAIL && result.message === 'wd.error.session_expired') {
                            self.showModalErrorMessage(result.message);
                            app.util.closePopUpWindow();
                            return false;
                        }
                        if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_FAIL
                            && result.errorCode !== 1082
                            && this.url !== 'submit.do'
                            && this.url !== '/ppp/registerPreWithdrawUpo.do'
                            && this.url !== 'withdrawal/submit.do'
                            && (this.url.indexOf('/ppp/withdrawal/checkWithdrawalAllowed.do') !== 0 && this.url.indexOf('/static/withdrawal/checkWithdrawalAllowedDo') !== 0)) { //this.url.indexOf('/ppp/withdrawal/checkWithdrawalAllowed.do') !== 0) {
                            if (result.message) {
                                if (app.config.messagesMode !== CONSTANTS.MESSAGES_MODE.NONE) {
                                    self.showModalErrorMessage(result.message);
                                    return data;
                                }
                            } else {
                                // alert('System error! Please contact support.');
                            }
                            return;
                        }
                    }
                    return data;
                }
            });
            /**
             *
             * @param Backbone Collection
             */
            var onUserPaymentMethodsAvailable = function (backboneList) {
                var customPMFilter = _.isFunction(app.config.customPMFilter) ? app.config.customPMFilter : _.identity;
                var upmList = backboneList.toJSON().map(function (upm) {
                    if (upm.paymentOptionName === CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
                        upm = utils.pwmb.formatSrvData(upm, upm.name);
                    }
                    return upm;
                });
                upmList = customPMFilter(upmList || [], 'upm');
                app.util.preserveUpoList(upmList);
                pubsub.publish('user-pm-available', [upmList]);
                if (app.config.hideMerchantPM) {
                    app.util.handlePMPreSelection(upmList, []);
                } else {
                    var onMerchantDataAvailable = function (data) {
                        var pmList = data.poList || [];
                        pmList = customPMFilter(pmList, 'pm');
                        app.util.preservePoList(pmList);
                        pubsub.publish('pm-available', [pmList]);
                        app.util.handlePMPreSelection(upmList, pmList);
                    };

                    if (config.alternatePoList) {
                        var fakeData = {
                            "message": "wd.info.successful_complete",
                            "status": "OK",
                            "poList": config.alternatePoList
                        };
                        onMerchantDataAvailable(fakeData);
                    } else {
                        self.rpc['getMerchantPaymentMethods']().then(onMerchantDataAvailable);
                    }
                }
            };

            $.blockUI.defaults.css = {
                padding: 0,
                margin: 0,
                width: '30%',
                top: '40%',
                left: '35%',
                textAlign: 'center',
                color: '#000',
                cursor: 'wait'
            };
            $.blockUI.defaults.message = '<div class="block_ui_wait"></div>';
            $.blockUI.defaults = $.extend(true, $.blockUI.defaults, app.pluginOpts.blockUI);
            $.blockUI.defaults.onUnblock = function () { //console.log('STOPPING....');
                if (app.spinner) {
                    app.spinner.stop();
                }
                $('.content_inside').unblock();
            };
            $.blockUI.defaults = $.extend(true, $.blockUI.defaults, app.pluginOpts.blockUI);

            var UserPaymentMethods = Backbone.Collection.extend({
                model: models.user_payment_method,
                url: function () {
                    if (config.ptRequestId) {

                        return isStaticPage() ? staticPrefix + 'data/pt_getUsersPaymentMethods.do.json?ssid=' + config.ssid : 'withdrawal/getUsersPaymentMethods.do?ssid=' + config.ssid +
                            '&merchant_site_id=' + config.merchant_site_id +
                            '&merchantLocale=' + config.merchantLocale +
                            '&wd_currency=' + config.wd_currency +
                            '&wd_amount=' + ($('.amount').val() || config.wd_amount) + //config.wd_amount +
                            '&country=' + config.country +
                            '&user_token_id=' + encodeURIComponent(config.user_token_id) +
                            '&ptRequestId=' + config.ptRequestId;
                    }
                    return isStaticPage() ? staticPrefix + 'data/getUsersPaymentMethods.do.json?ssid=' + config.ssid : 'getUsersPaymentMethods.do?ssid=' + config.ssid +
                        '&merchant_site_id=' + config.merchant_site_id +
                        '&merchantLocale=' + config.merchantLocale +
                        '&wd_currency=' + config.wd_currency +
                        '&wd_amount=' + config.wd_amount +
                        '&country=' + config.country +
                        '&user_token_id=' + encodeURIComponent(config.user_token_id);
                },
                parse: function (response) {
                    var checkExpiryDate = function (yyyymmdd) {
                        var year = parseInt(yyyymmdd.substring(0, 4), 10);
                        var month = parseInt(yyyymmdd.substring(4, 6), 10) - 1;
                        var day = parseInt(yyyymmdd.substring(6, 8), 10);
                        return (new Date()) > (new Date(year, month, day))
                    };
                    var data = _.map(response["upoList"], function (item) {
                        if (!item.blockers && item.expiryDate && item.paymentOptionName === 'visa_checkout' && checkExpiryDate(item.expiryDate)) {
                            item.blockers = {
                                accountVerificationStatusBlocker: app.locale.visa_checkout_expired
                            }
                        }
                        return app.util.wdUpoMutator(item);
                    });
                    return _.filter(data, function (userPM) {
                        return !_.isNull(userPM.name);
                    });
                },
                comparator: function (modelA, modelB) {
                    var val1 = parseInt(modelA.get('uiOrder'));
                    var val2 = parseInt(modelB.get('uiOrder'));
                    if (val1 > val2) return 1;
                    if (val2 > val1) return -1;
                    return 0;
                }
            });
            var WithdrawalRequests = Backbone.Collection.extend({
                model: models.withdraw_req_item,
                url: function () {
                    if (config.ptRequestId) {
                        return isStaticPage() ? staticPrefix + 'static/pt_getUserWithdrawRequests.do?ssid=' + config.ssid : 'withdrawal/getUserWithdrawRequests.do?ssid=' + config.ssid +
                            '&merchant_site_id=' + config.merchant_site_id +
                            '&merchantLocale=' + config.merchantLocale +
                            '&user_token_id=' + encodeURIComponent(config.user_token_id) +
                            '&offset=0&limit=100000&ts=' + _.now() +
                            '&ptRequestId=' + config.ptRequestId;
                    }
                    return 'getUserWithdrawRequests.do?ssid=' + config.ssid +
                        '&merchant_site_id=' + config.merchant_site_id +
                        '&merchantLocale=' + config.merchantLocale +
                        '&user_token_id=' + encodeURIComponent(config.user_token_id) +
                        '&offset=0&limit=100000&ts=' + _.now();
                },
                parse: function (response) {
                    return _.map(response["withdrawalRequests"], function (wds, index) {
                        wds['creationDate'] = new Date(parseInt(wds['creationDate'], 10));
                        wds['status'] = wds['status'].toLowerCase();
                        var item = (wds.orders && wds.orders.length) ? wds.orders[0] : wds.params;
                        if (item && item.poName === CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
                            utils.pwmb.formatSrvData(item, item.upoName);   /** modify item */
                        }
                        return wds;
                    });
                },
                comparator: function (chapterA, chapterB) {
                    var date1 = chapterA.get('creationDate').getTime();
                    var date2 = chapterB.get('creationDate').getTime();
                    if (date1 > date2) return -1;
                    if (date2 > date1) return 1;
                    return 0;
                }
            });

            this.rpc.ssid = config.ssid;
            this.rpc.merchant_id = config.merchant_id;
            this.rpc.wd_currency = config.wd_currency;
            this.rpc.merchant_site_id = config.merchant_site_id;
            this.rpc.merchantLocale = config.merchantLocale;
            this.rpc.user_token_id = config.user_token_id;
            this.rpc.country = config.country;
            this.rpc.isRebillingHidden = false;
            this.rpc.wd_amount = $("input.amount").val() || 0; //$(".amount:text").val() || 0;
            this.rpc.ptRequestId = config.ptRequestId;

            // if(layout != 0){
            // Init withdraw requests list
            this.stores.withdraw_requests = new WithdrawalRequests;
            this.stores.withdraw_requests.on('reset add', this.renderWithdrawalList, this);
            this.stores.withdraw_requests.fetch({reset: true});
            // }
            // if(layout != 1) {
            // PAYMENT METHODS
            this.stores.user_payment_methods = new UserPaymentMethods;
            this.stores.user_payment_methods.on('reset', onUserPaymentMethodsAvailable, this);
            this.stores.user_payment_methods.fetch({reset: true});
            // }

            var rpcScope = this.rpc;

            var onPMSelected = function (evtData) {
                this.value = evtData.uniqueId;
                $('button.withdraw').attr('disabled', true);
                $('.pm-placeholder').val(this.value);
                $('#store_card_wrapper').empty();
                $('.PMINFO').removeClass(CONSTANTS.CARD_LOGO_CLASSES);

                app.util.updateFieldsForValidation({});
                app.util.removeBaseValidationRules(app._autoGeneratedValidationRules);
                app._validationResult = {};
                app._doNotSubmitFields = {};
                app._preWdParamId = false;
                app._flag.requestedCardBrand = false;
                delete app._customWdBtnHandler;
                delete app._autoGeneratedValidationRules;

                var rawData = evtData.rawData || {};
                var suggestedAmounts = rawData.suggestedAmounts || [];
                var pricePoints = rawData.pricePoints || [];
                var pm_limits = rawData.amountLimits || rawData.limits || {}; // PT: rawData.amountLimits; Regular: rawData.limits
                var isMerchantPMS = _.isNaN(parseInt(this.value));
                app.lastSelectedMethodId = evtData.uniqueId;
                app.current_pm_name = rawData.value || rawData.paymentOptionName; // pm_name;
                app.currentMethodFields = {};
                config.selected_payment_id = this.value;
                app.lastCardDetected = app.util.isUpo(app.lastSelectedMethodId) && app.util.isCardPM(app._upoList[app.lastSelectedMethodId]) ? app._upoList[app.lastSelectedMethodId].lastUsedBrand || app._upoList[app.lastSelectedMethodId].card_type || 'none' : 'none';
                
                var pmData = isMerchantPMS ? app._poList[app.lastSelectedMethodId] : app._upoList[app.lastSelectedMethodId];
                var isSuspended = pmData && (pmData.poStatus || pmData.attributes && pmData.attributes.poStatus) === "SUSPENDED";
                app.util.onPMSelectedHandleBodyClasses(false, isSuspended);
                if (this.value === '') {
                    return;
                }

                app.PTlastSelectedMethodType = rawData.type || app.lastSelectedMethodId;
                app._methodRegistrationType = rawData.attributes && rawData.attributes.registrationType;
                var proceed = true;
                if (app.config.customOnPMSelectedHandler) {
                    proceed = app.config.customOnPMSelectedHandler(app.current_pm_name, app.lastSelectedMethodId, evtData);
                }
                if (!proceed) {
                    return;
                }
                if (app.config.useSubpages) {
                    if (app._flag.isReload) {
                        app._flag.isReload = false;
                    } else {
                        var hash = window.location.hash;
                        window.location.hash = CONSTANTS.HASH.PM + app.lastSelectedMethodId;
                        if (hash !== window.location.hash) {
                            window.location.hash = CONSTANTS.HASH.DETAILS + app.lastSelectedMethodId;
                        }
                    }
                }

                if (isMerchantPMS) {
                    rpcScope.payment_method = this.value;
                    delete rpcScope.userPaymentOptionId;
                    rpcScope['retrieveMerchantPMSDetails']().then(function (data) {
                        if (!data) {
                            var limits = app.util.updatePMLimits(pm_limits, app.current_pm_name, app.lastSelectedCurrency, suggestedAmounts, pricePoints);
                            app.util.applyLimitsAndFees(limits, {});
                            return;
                        }
                        if (rpcScope.payment_method === CONSTANTS.PM_NAME.CITADEL) {
                            data.paymentDetails = app.util.filterCitadelFields(data.paymentDetails, app.config.country);
                        }
                        if (!app.config.ptRequestId) {
                            pm_limits = data['limits'];
                        }
                        data.pmLimits = app.util.updatePMLimits(pm_limits, app.current_pm_name, app.lastSelectedCurrency, suggestedAmounts, pricePoints);
                        data.pmPosition = evtData.pmPosition;
                        app.lastSelectedMethodData = data;
                        app.util.getPmExtraDetails(rpcScope.payment_method, null, data);
                    });
                }
                else { // UserPM
                    rpcScope.userPaymentOptionId = this.value;
                    app._methodRegistrationType = rawData.registrationType;
                    var ccCardDetails = /\((\d{4})\)|\d\*{4}(\d{4})/;
                    rpcScope['retrieveUserPMSDetails']().then(function (data) {
                        if (!data) {
                            var limits = app.util.updatePMLimits(pm_limits, app.current_pm_name, app.lastSelectedCurrency, suggestedAmounts, pricePoints);
                            app.util.applyLimitsAndFees(limits, {});
                            return;
                        }
                        if (app.config.ptRequestId && !data.paymentDetails) {
                            data.paymentDetails = $.extend(true, {}, data);
                        }

                        data.userPaymentOptionId = rpcScope.userPaymentOptionId;
                        if (data.paymentDetails && data.paymentDetails.cc_card_number) {
                            var cardNumObj = data.paymentDetails.cc_card_number;
                            if (cardNumObj.visibilityMode === CONSTANTS.VISIBILITY_MODE.DISABLED) {
                                var viewName = cardNumObj.value;
                                if (ccCardDetails.test(viewName)) {
                                    viewName = viewName[0] + "*** **** **** " + (viewName.match(ccCardDetails)[1] || viewName.match(ccCardDetails)[2]);
                                }
                                cardNumObj.value = viewName;
                            }
                        }
                        if (app.current_pm_name === CONSTANTS.PM_NAME.CITADEL) {
                            data.paymentDetails = app.util.filterCitadelFields(data.paymentDetails, app.config.country);
                            data.paymentDetails = app.util.changeVisibilityMode(data.paymentDetails, CONSTANTS.VISIBILITY_MODE.DISABLED);
                        }
                        if (!app.config.ptRequestId) {
                            pm_limits = data['limits'];
                        }
                        data.pmLimits = app.util.updatePMLimits(pm_limits, app.current_pm_name, app.lastSelectedCurrency, suggestedAmounts, pricePoints);
                        data.pmPosition = evtData.pmPosition;
                        app.lastSelectedMethodData = data;
                        app.util.getUpmExtraDetails(data.userPaymentOptionId, null, data);
                    });
                }
            };
            pubsub.subscribe('select-pm', onPMSelected);

            app.util.handleSubPages(app.config.useSubpages);

            if (app.config.useAnalytics) {
                app.analytics.init(app.config.analyticsConfig);
            }

            app.util.handleRelayEvents();

            pubsub.subscribe('remove-upm', app.util.removeUPM);
            pubsub.subscribe('inlineMessage.closed', app.util.onInlineMessageClose);
            pubsub.subscribe('app.event.wd_performRedirect', app.util.performRedirect);

            // It is published from PMWithdrawList.js (It is a view that represent a table view with all withdraws)
            pubsub.subscribe('withdraw-cancel', function (data) {
                var me = this;
                var payload  = { message: app.util.prepareCancelWdrLbxData(data)};
                var tpl = app.util.getLightboxContentTemplate('confirmation');
                var onConfirm = function () {
                    pubsub.publish('withdraw-cancel-start', [{buttonId: data.id}]);
                    me.rpc.wdRequestIdToCancel = data.id;
                    me.rpc['cancelWithdrawRequest']().done(function (_data) {
                        if (_data
                            && _data.status === CONSTANTS.SRV_RESPONSE.STATUS_OK
                            && _data.wdRequest
                            && (app.config.messagesMode !== CONSTANTS.MESSAGES_MODE.NONE)
                        ) {
                            pubsub.publish('app.event.wdCancelSuccess', [_data]);
                            var tmpl = app.util.getLightboxContentTemplate('withdraw-canceled');
                            var d = new Date(parseInt(_data.wdRequest.creationDate));
                            var dateAsString = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                            var args = [_data.wdRequest.requestedAmount, _data.wdRequest.requestedCurrency, dateAsString];
                            if (app.config.useIntlFormatter) {
                                args[0] = app.formatter.formatCurrency(args[0], args[1], null, true);
                                args[1] = '';
                            }
                            me.showModalCustomMessage(tmpl, 'success wd_canceled', t("lightbox_confirm_title"), {
                                args: args,
                                date: d,
                                amount: _data.wdRequest.requestedAmount,
                                currency: _data.wdRequest.requestedCurrency,
                                t: t
                            });
                            me.stores.withdraw_requests.fetch({reset: true});
                            if(app.config.useSyncWithImsAfterAction) {
                                me.stores.user_payment_methods.fetch({reset: true});
                                app._flag.shouldPreselectSamePmAfterWdCancelation = true;
                            }
                        }
                    });
                };
                if (app.config.skipCancelReqConfirmation) {
                    onConfirm();
                } else {
                    this.showModalCustomMessage(tpl, 'confirm', t("lightbox_confirm_title"), payload, onConfirm);
                }
            }, this);

            if (app.config.allowDeleteUPO) {
                $(document).on('click', (app.config.removeUpoSelector || '.removeUPM'), function () {
                    var $this = $(this);
                    var data = {
                        upmType: $this.data('method'),
                        upmId: $this.data('value')
                    };
                    app.util.removeUPM(data);
                });
            }

            // TODO: Extend Config with themeConfig
	        if(app.config.storeCard && app.config.storeCard.isActive && app.config.storeCard.merchantAdditionalInfoURL && !app.config.storeCard.useLightbox) {
	        	var cfgValue = app.config.themeConfig && app.config.themeConfig.openTermsInCustomLightbox;
	        	var shouldOpenTermsInCustomLightbox = typeof cfgValue === 'string' ? cfgValue === "true" : cfgValue;

	        	if(shouldOpenTermsInCustomLightbox) {
	        		app.config.storeCard.openTermsInCustomLightbox = true;
	        		app.config.storeCard.merchantAdditionalInfoURL = utils.addQueryStringParams(app.config.storeCard.merchantAdditionalInfoURL, {"hideCloseBtn": true});
	        		$(document).on('click', '#lightbox.lbx_scc_popup ~ .modalOverlay, #lightbox .scc_popup_footer-btn', function() {
	        			$('#lightbox .modal_close').click();
	        		});
	        	}
	        }

            var PMSView = Backbone.View.extend({
                initialize: function (config) {
                    this.template = config.template;
                },
                render: function (data) {
                    var that = this;
                    $.extend(data, {t: t});
                    if (_.has(data, 'cc_name_on_card')) {
                        data['cc_name_on_card'].label = self.locale['cc_name_on_card'];
                        data['cc_card_number'].label = self.locale['cc_card_number'];
                        data['expires'] = self.locale['expires'];
                        data['cc_cvv2'] = self.locale['cc_cvv2'];
                    }
                    var templateFullName = "tpl/" + this.template + ".html";
                    console.log('--->', templateFullName);

                    var tplElement = $('#' + this.template);
                    if (tplElement.length) {
                        app.tpls[templateFullName] = _.template(tplElement.html());
                    }

                    if (app.tpls[templateFullName]) {
                        return $.when(that.$el.html(app.tpls[templateFullName](data)));
                    }

                    return $.get(templateFullName, function (templateStr) {
                        app.tpls[templateFullName] = _.template(templateStr);
                        that.$el.html(app.tpls[templateFullName](data));
                    });
                }
            });
            var paymentPlaceholderElm = $(".payment_options_details");
            this.userCreditCardPMView = new PMSView({
                el: paymentPlaceholderElm,
                template: 'userCreditCardPMView'
            });
            this.userPMSGeneralView = new PMSView({
                el: paymentPlaceholderElm,
                template: 'userPMSGeneralView'
            });

            this.userPMSEditable = new PMSView({
                el: paymentPlaceholderElm,
                template: 'userPMSEditable'
            });

            this.envoyPMView = new PMSView({
                el: paymentPlaceholderElm,
                template: 'envoyPMView'
            });
            this.vcoPMView = new PMSView({
                el: paymentPlaceholderElm,
                template: 'vcoPMView'
            });
            this.fbtPMView = new PMSView({
                el: paymentPlaceholderElm,
                template: 'fbtPMView'
            });
            var resultAreaElm = $('.section_content.result.step2');
            this.withdrawSuccessResultView = new PMSView({
                el: resultAreaElm,
                template: 'successResultPanel'
            });
            this.withdrawSuccessResultView.render({
                currency: 'NDC',
                amount: '-1',
                useIntl: !!app.config.useIntlFormatter,
                submittedMethod: false,
                formattedAmount: '-1 NDC'
            });
            this.withdrawFailureResultView = new PMSView({
                el: resultAreaElm,
                template: 'failureResultPanel'
            });

            app.util.applyFixedAmountRestrictions();

            testForRequiredElements();
        },
        init_websocket_client: function () {
            // Currently USED ONLY for apmgw_eCheckSelect
            if (app.config && app.config.ws_server) {
                var socket = null;
                try {
                    socket = new WebSocket(app.config.ws_server + "/ws");
                } catch (e) {
                    console.log(e);
                }
                socket.onopen = function (e) {
                    socket.send(JSON.stringify({ssid: app.config.ssid}));
                };
                socket.onmessage = function (event) {
                    app._hasWs = true;
                    var eventObj = null;
                    try {
                        eventObj = JSON.parse(event.data)
                    } catch (e) {
                        console.log('Invalid object received', event.data);
                    }
                    if (eventObj  && eventObj.details && eventObj.trxStatus) {
                        app.util.onWsMessage(eventObj);
                    }
                    console.log(eventObj)
                };
                socket.onclose = function (event) {
                    if (event.wasClean) {
                        console.log('[close] Connection closed cleanly, code=', event.code, 'reason=', event.reason);
                    } else {
                        console.log('[close] Connection died', event.code);
                    }
                    app._hasWs = false;
                };
                socket.onerror = function (error) {
                    console.log('[error]', error);
                    app._hasWs = false;
                };
                window.addEventListener("beforeunload", function (event) {
                    socket.close(1000, "Normal Closure");
                    app._hasWs = false;
                });
            }
        },
        makeRequest: function (additional_data) {
            // var self = app;// this;
            var paymentOptionId = app.config.selected_payment_id;
            var isUPM = !isNaN(paymentOptionId);
            var data = {
                ssid             : app.rpc.ssid,
                wd_amount        : $('input.amount').val(),
                wd_currency      : app.rpc.wd_currency,
                country          : app.rpc.country,
                merchantLocale   : app.rpc.merchantLocale,
                merchant_site_id : app.rpc.merchant_site_id,
                merchant_id      : app.rpc.merchant_id,
                user_token_id    : app.rpc.user_token_id
            };
            if(additional_data && _.isObject(additional_data)){
                data = $.extend(data, additional_data);
            }
            if (app._flag.requestedCardBrand) {
                data.selectedBrand = app._flag.requestedCardBrand;
            }
            if (app.util.needWithdrawalAllowedCheck(paymentOptionId) && !app._flag.withdrawalAllowed) {
                app.checkWithdrawalAllowed(app.current_pm_name);
                return;
            }

            $('.content_inside').block();
            if (paymentOptionId === "apmgw_eCheckSelect" && !app._hasWs && app.config.bankCaptureWebSocketEnabled) {
                app.init_websocket_client();
            }
            if (isUPM) { // SUBMITTING User PM
                data.userPaymentOptionId = paymentOptionId;
                var upo_model = app.stores.user_payment_methods.get(paymentOptionId);
                app._methodRegistrationType = upo_model && upo_model.get("registrationType");
                $.extend(data, app.util.collectUpoData(app.currentMethodFields));
            } else {    // SUBMITTING MERCHANT PM
                data.payment_method = paymentOptionId;
                $.extend(data, app.util.collectPoData(app.currentMethodFields));
            }

            app.submittedMethod = {id: app.lastSelectedMethodId, isUpo: isUPM, pmName: app.current_pm_name};

            var submitUrl = (app.config.ptRequestId) ? 'withdrawal/submit.do' : 'submit.do';
            if (app.config['use_withdraw_split']) {
                submitUrl = 'getSuggestions.do';
            }
            if (CONSTANTS.METHOD_REGISTRATION_TYPE.PRE_WITHDRAW === app._methodRegistrationType) {
                submitUrl = "/ppp/registerPreWithdrawUpo.do";
                if (isUPM) {
                    data.payment_method = app.current_pm_name;
                }
            }
            if (app.rpc.ptRequestId && submitUrl != "/ppp/registerPreWithdrawUpo.do") {
                data.ptRequestId = app.rpc.ptRequestId;
                data.ptConfirmedUserActions = app.rpc.ptConfirmedUserActions;
                data.wd_requestId = app.rpc.wd_requestId;
            }

            if (submitUrl.endsWith('registerPreWithdrawUpo.do')
                && app.config.openPmInPopUpWnd[app._deviceType][app.current_pm_name]
                && !app.util.shouldOpenInExternalBrowser(paymentOptionId)
            ) {
                app.util.openPopUpWindow();
            }

            $.post(submitUrl, data, function (result) {
                app.resetMainFlags();
                if (!result) {
                    return;
                }
                if (app._popupWnd && !result.pmRedirectURL) {
                    app.util.closePopUpWindow();
                }
                $.extend(result, {t: t});
                $('.content_inside .withdraw, #continueButton').blur();

                if (result.status === CONSTANTS.SRV_RESPONSE.STATUS_FAIL) {
                    delete app.rpc.ptConfirmedUserActions;     // clear_State
                    pubsub.publish('app.event.wdFailure', [result, data]);
                    app.util.handleTrxCompleteStatus_FAIL(result);
                } else { // status !== 'FAIL'
                    if (CONSTANTS.METHOD_REGISTRATION_TYPE.PRE_WITHDRAW === app._methodRegistrationType &&
                        result.upo &&
                        result.upo.userPaymentOptionId
                    ) {
                        app.util.onPreWdSuccess(result);
                        return;
                    } else if (result.withdrawalRequestId && app._processedWdRequest[result.withdrawalRequestId]) {
                        return;
                    }
                    delete app.rpc.ptConfirmedUserActions;     // clear_State
                    if (app.config['use_withdraw_split']) {
                        var splitTplElm = $('#orderSplit');
                        if (splitTplElm.length) {
                            app.tpls['tpl/orderSplit.html'] = _.template(splitTplElm.html());
                        }
                        var splitTpl = app.tpls['tpl/orderSplit.html'];

                        result.wdOrders = app.util.normalizeOrderSplitData(result.wdOrders);
                        var wdOrdersHtml = splitTpl(result);

                        var onAcceptOrderSplit = function (doNotShowBlocker) {
                            $('#lightbox').hide();
                            if (doNotShowBlocker) {
                                $('body').removeClass('overflowed');
                                $('.modalOverlay').fadeOut();
                                $(".content_inside").block();
                                $('a.modal_close').off('click');
                            }
                            $.post('confirmSuggestions.do', data, function (confirmationResult) {
                                if (confirmationResult.status === CONSTANTS.SRV_RESPONSE.STATUS_OK) {
                                    pubsub.publish('app.event.wdSuccess', [confirmationResult, "confirmSuggestions"]);
                                    if (app.config.directConfirm) { // RANK_v1:
                                        sendPostMessage('done', app.config.parentUrl || '');
                                        app.util.setAmountValue("", ['setValue'], 'directConfirm_confirmSuggestions');
                                    } else {
                                        app.util.handleTrxCompleteStatus_OK(confirmationResult);
                                    }
                                } else {
                                    /** status is "FAIL" when "cancelOrderForBeneficiaryOwner" is true **/
                                    app.submittedMethod = false;
                                }
                            }, 'json');
                        };

                        if (_.has(result, 'skipSplitScreen') && result.skipSplitScreen) {
                            onAcceptOrderSplit(true);
                            return;
                        }
                        var onCancelOrderSplit = function () {
                            $('body').removeClass('overflowed');
                            $('.modalOverlay').fadeOut();
                            $(".content_inside").block();
                            $('a.modal_close').off('click');
                            app.resetMainFlags();
                            app.stores.user_payment_methods.fetch({reset: true});
                            $.post('discardSuggestions.do', data, function () {
                                app.util.closeLightbox();
                                $('input').attr('disabled', false);
                                var isValid = app.validateInput();
                                $('button.withdraw').attr('disabled', !isValid);
                            }, 'json');
                        };

                        $('.content_inside').unblock();
                        showModalMessage({
                            message: msg.wd_request_will_be_send_to,
                            details: wdOrdersHtml
                        }, 'order_split');

                        $('a.modal_close, button.action-cancel').click(onCancelOrderSplit);
                        $('.action-proceed').off('click').on('click', onAcceptOrderSplit);
                    }
                    else { // do NOT use_withdraw_split
                        pubsub.publish('app.event.wdSuccess', [result, "mainSubmit"]);
                        if (app.config.directConfirm) { // RANK:
                            sendPostMessage('done', app.config.parentUrl || '');
                            app.util.setAmountValue("", ['setValue'], 'directConfirm_mainSubmit');
                        } else {
                            app.util.handleTrxCompleteStatus_OK(result);
                        }
                    }
                }
            }, 'json');
        },
        validateInput: function () {
            return continuousValidation();
        },

        checkPMForExpiredCC: function (data) {
            if (_.has(data, 'paymentDetails') && app.current_pm_name !== "visa_checkout") {
                if (_.has(data.paymentDetails, 'cc_exp_month') && _.has(data.paymentDetails, 'cc_exp_year')) {
                    if (!isValidDate(data.paymentDetails.cc_exp_year.value, data.paymentDetails.cc_exp_month.value)) {
                        data.paymentDetails.cc_exp_year.visibilityMode = CONSTANTS.VISIBILITY_MODE.REQUIRED;
                        data.paymentDetails.cc_exp_month.visibilityMode = CONSTANTS.VISIBILITY_MODE.REQUIRED;
                        return true;
                    }
                }
            }
            return false;
        },
        onWithdrawClicked: function () {
            // inject doubleConfirmationPopup & beneficiaryOwnerPopup
            var proceed = app.util.handlePreWdLightboxes(app.tryToMakeRequest);
            if(proceed){
                app.tryToMakeRequest();
            }
        },
        tryToMakeRequest: function (additional_data) {
            var asyncCheckCompleted = app.util.asyncCheck.isComplete();
            if (app._customWdBtnHandler && _.isFunction(app._customWdBtnHandler)) {
                app._customWdBtnHandler();
            } else if (asyncCheckCompleted && app.validateInput()) {
                var proceed = app.util.handleSccLightbox(app.makeRequest, additional_data);
                if (proceed) {
                    app.makeRequest(additional_data);
                }
                pubsub.publish('app.event.WithdrawClicked', []);
            } else if (!asyncCheckCompleted) {
                app.util.asyncCheck.onComplete(function (r, val) {
                    var newV = $("input.cc_card_number").val();
                    if (newV === val && !$('button.withdraw').attr('disabled')) {
                        app.tryToMakeRequest(additional_data);
                    }
                }, "hashKey_withdrawal");
            }
        },
        onNotificationEnd : function () {
            var $lbx =$('#lightbox');
            var classList = $lbx[0] && $lbx[0].classList || [];
            var type = classList[0] || '';
            var sub_type = classList[1] || '';
            $lbx.find('.lightbox-content').empty();
            pubsub.publish('lightbox.closed', [{type: type, sub_type: sub_type, isWs: false, feRef: false}]);
        },
        run: function (config) {
            this.init(config);
            utils.getPhoneCodes();
            onValidationResult = app.onValidationResult || onValidationResult;
            validationsMap = app.validationsMap || {};
            _.each(config.validations, function (item, key) {
                validationsMap[key] = item;
            });

            $(this).on('withdraw.select_merchant_pm', _.bind(function (evt, data) {

                // >>> HACK_Start >>> [BACKLOG-2041] support for paysafecard "apmgw_PaySafeCard" && PBI_12773 "apmgw_AstropayPrePaid" >
                app.util.prePopulateFields(app.lastSelectedMethodId, data);
                // <<< HACK_End <<< [BACKLOG-2041] && PBI_12773

                var fields = !_.isEmpty(data._extraData) ? data._extraData : data.paymentDetails;
                var pmData = app._poList[app.lastSelectedMethodId];
                var hasBlockers = !_.isEmpty(utils.isPMBlocked(pmData));
                var isSuspended = (pmData && pmData.attributes && pmData.attributes.poStatus === 'SUSPENDED');
                if (isSuspended && !hasBlockers) {
                    pmData.blockers = utils.createSuspendedPmBlocker();
                    hasBlockers = true;
                }
                app.util.updateFieldsForValidation(fields, hasBlockers);
                this.handlePmDetails(data.paymentDetails, data._extraData);
                var isValid = this.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
            }, this));

            $(this).on('withdraw.select_user_pms', _.bind(function (evt, data) {

                // >>> HACK_Start >>> [PBI_12773 "apmgw_AstropayPrePaid" UPO >
                if ("apmgw_AstropayPrePaid" === app.current_pm_name || "apmgw_AstroPay" === app.current_pm_name) {
                    app.util.prePopulateFields(app.current_pm_name, data);
                }
                // <<< HACK_End <<< PBI_12773
                // >>> HACK_Start >>>[PBI-9097] VisaCheckOut UPO >
                if ("visa_checkout" === app.current_pm_name && data.paymentDetails['cardArtsUrl']) {
                    data.paymentDetails['cardArtsUrl']['visibilityMode'] = CONSTANTS.VISIBILITY_MODE.DISABLED;
                }
                // <<< HACK_End <<< [PBI-9097] VisaCheckOut
                var fields = !_.isEmpty(data._extraData) ? data._extraData : data.paymentDetails;
                var upmData = app._upoList[app.lastSelectedMethodId];
                var hasBlockers = !_.isEmpty(utils.isPMBlocked(upmData));
                var isSuspended = (upmData && upmData.poStatus === 'SUSPENDED');
                if (isSuspended && !hasBlockers) {
                    upmData.blockers = utils.createSuspendedPmBlocker();
                    hasBlockers = true;
                }
                app.util.updateFieldsForValidation(fields, hasBlockers);
                this.handleUpmDetails(data);
                var isDualBrandButtosRenderd = app.util.addDualBrandCardSelector(data, 'render_upm');
                if (!isDualBrandButtosRenderd) {
                    app.util.handleCardHolderNameVisibility(app.lastCardDetected);
                }
                app.recalcUserDetailsArea();
                var isValid = this.validateInput();
                $('button.withdraw').attr('disabled', !isValid);
            }, this));

            $('#continueButton_wrapper .disabled_button_hoverer').on('click', _.bind(function (evt) {
                if ($('#continueButton').attr('disabled')) {
                    this.showValidationStatus();
                }
            }, this));
            $('.content_inside').delegate('input, select', 'keyup change', _.bind(function (evt) {
                var isValid = this.validateInput(evt);
                app.util.handleFee(app.current_pm_feeObj);
                $('button.withdraw').attr('disabled', !isValid);
            }, this));
            $('.content_inside').delegate('input, select', 'blur', _.bind(function (evt) {
                var input = evt.currentTarget || {};
                var fld_name = _.intersection(_g.validationFields, _.values(input.classList))[0];
                var isValidFld = true;
                if (input.nodeName === "INPUT" && fld_name && CONSTANTS.PADDED_FIELDS[fld_name]) {
                    isValidFld = app.util.handlePaddedFields(input, fld_name, evt.currentTarget.value,  CONSTANTS.PADDED_FIELDS[fld_name]).isValid;
                } else {
                    isValidFld = this.validateSingleField(evt);
                }
                app.util.onFieldBlur(isValidFld, fld_name, evt.currentTarget.value, '');
                var isValid = this.validateInput(evt);
                $('button.withdraw').attr('disabled', !isValid);
            }, this));
            $('.content_inside').on('change', 'input[type="checkbox"]', function (e) {
                app.validateSingleField(e);
            });
            $('.content_inside').on('click', 'button.withdraw, input.withdraw', app.onWithdrawClicked);

            if (config.paydotcomPopup) {
                pubsub.subscribe('user-pm-available', function (data) {
                    if (data) {
                        _.each(data, function (i) {
                            if (i.card_type == 'paydotcom') {
                                utils.paydotcom.hasPaydotcomUpo = true;
                            }
                        });
                    }
                    else {
                        utils.paydotcom.hasPaydotcomUpo = false;
                    }
                    if (!utils.paydotcom.hasPaydotcomUpo && !app._flag.paydotcom) {
                        utils.paydotcom.init(app.locale['paydotcom_url'], app.locale['paydotcom_msg'], app.locale['paydotcom_title']);
                        app._flag.paydotcom = 1;
                    }
                });
            }

            if (!_.isEmpty(config.ptWarnings)) {
                var ptWarnings = config.ptWarnings;
                var type = ptWarnings.type.toLowerCase();
                var title = (app.locale && app.locale[ptWarnings.titleKey]) || ptWarnings.titleKey;
                var tpl = app.util.getLightboxContentTemplate(type);
                app.showModalCustomMessage(tpl, type, title, {message: config.ptWarnings});
            }

            pubsub.subscribe('safecharge.PWMB.authorization.ready', app.util.onPwmbAuthorizationSuccessDoSubmit);
            pubsub.subscribe('safecharge.wd_transaction.complete', function (data) {
                app.util.closePopUpWindow();
                if (data && data.status === CONSTANTS.SRV_RESPONSE.STATUS_OK) {
                    if (CONSTANTS.METHOD_REGISTRATION_TYPE.PRE_WITHDRAW === app._methodRegistrationType &&
                        data.upo &&
                        data.upo.userPaymentOptionId
                    ) {
                        app.util.onPreWdSuccess(data);
                        return;
                    } else if (data.withdrawalRequestId && app._processedWdRequest[data.withdrawalRequestId]) {
                        return;
                    }
                    pubsub.publish('app.event.wdSuccess', [data, "trxComplete"]);
                    app.util.closeLightbox();
                    if (app.config.directConfirm) { // RANK:
                        sendPostMessage('done', app.config.parentUrl || '');
                        app.util.setAmountValue("", ['setValue'], 'directConfirm_trxComplete');
                    } else {
                        app.util.handleTrxCompleteStatus_OK(data);
                    }
                } else {
                    if (data.withdrawalRequestId) {
                        if (app._processedWdRequest[data.withdrawalRequestId]) {
                            return;
                        }
                        app._processedWdRequest[data.withdrawalRequestId] = 'FAIL';
                    }
                    pubsub.publish('app.event.wdFailure', [data]);
                    app.util.handleTrxCompleteStatus_FAIL(data);
                }
            });

            app.util.postMessageListener();

            pubsub.subscribe('post-pm-render', function (data) {
                var pmData = app._poList[app.PTlastSelectedMethodType];
                utils.renderBlockedPMReasons(pmData);

                if(app.lastSelectedMethodId === app.CONSTANTS.PM_NAME.MVP_NUVEI_CARD) {
                    var tpl = app.util.getLightboxContentTemplate('wd_mvp_nuvei_card');
			        app.showModalCustomMessage(tpl, 'wd_mvp_nuvei_card', '<h2>'+ t("mvp_nuvei_card_modal_title") + '</h2><span class="modal_close"></span>');
                    app.bodyElm.one('click', '#lightbox a.enter_card_detail', function() {
                        $('#lightbox .modal_close').trigger('click');
                        pubsub.publish('dr-select-pm', [{uniqueId: 'cc_card', type: 'string'}]);
                    });
                    return;
                } else if (app.lastSelectedMethodId === app.CONSTANTS.PM_NAME.PAY_WITH_CRYPTO) {
                    app.util.handlePayWithCryptoConsent();
                    return;
                }
                utils.storeCardCredentialsHandler(app.config.storeCard, app.current_pm_name);
                app.applycSelectPlugin();
                recalcUserDetailsArea();
            });
            pubsub.subscribe('post-upm-render', function (data) {
                var pmData = app._upoList[app.lastSelectedMethodId];
                app.util.renderUpoMessage(pmData);
                app.util.validateRoCardField('post-upm-render');
                utils.renderBlockedPMReasons(pmData);

                if (pmData.paymentOptionName === app.CONSTANTS.PM_NAME.PAY_WITH_CRYPTO) {
                    app.util.handlePayWithCryptoConsent();
                    return;
                }
                app.applycSelectPlugin();
	            recalcUserDetailsArea();
            });
            pubsub.subscribe('app.event.pmwithdrawlist.postRender', function (data) {
                recalcUserDetailsArea();
            });
        }
    };

    app.analytics = (function ($, pubsub, _) {
        var NA = {};
        NA.CONST = {
            MULTIPLIERS: [1, 10, 100, 1000, 10000, 100000],
            EXTRA_MULTIPLIER: 10,
            EPSILON: 0.000001, /** Floating-point error correction */
            FAKE_ENV: "localhost",
            STATUS: {
                NOT_LOADED: 0,
                LOAD_IN_PROGRESS: 1,
                LOAD_SUCCESS: 2
            },
            EVENT_NAME: {
                AMOUNT_TYPED: 'User Typed Withdrawal Amount',
			    AMOUNT_SUGGESTED: 'Withdrawal Suggested Amount',
                CHANGE_PM: 'Change Withdrawal Payment Method',
                PAGE_LOAD: 'Load withdrawal page',
                // SUBMIT_FAILURE: 'Withdrawal Request Failure',
                SUBMIT_SUCCESS: 'Withdrawal request submitted',
                // TRX_DECLINED: 'Declined Transaction',
                CANCEL_PENDING_WD: 'Cancel Pending Withdrawal',
                UPO_REMOVAL_CLICKED: 'Withdrawal UPO Removal Clicked',
                UPO_REMOVAL_CHOSEN: 'Withdrawal UPO Removal Chosen',
			    CHANGE_BRAND: 'User Change Brand Withdrawal',
			    POST_WDR_POPUP: 'User click on post withdrawal pop up'
            }
        };
        NA._g = {
            flag: {
                dataReadySentOnce: false
            },
            last: {
                changed_amount: false,
                keyup_amount: false,
                setValue_amount: false,
                sent_amount: false,
                sent_currency: false,
                submit_info: {},
                select_pm_info: {},
                pa_choice_info: {},
                trx_complete_info: {},
                card_detected: null
            },
            iframe: false,
            isReady: 0,
            evtQueue: [],
            iframeStatus: NA.CONST.STATUS.NOT_LOADED,
            ifameOrigin: document.location.origin
        };
        NA.cfg = {
            env: "production",
            url: "/cdn/v1/amplitude.html",
            default_url: "https://cdn-int.safecharge.com/safecharge_resources/v1/amplitude.html",
            ratesToUSD: {
                "USD": 1
            }
        };
        NA._logError = function (str) {
            if (str) {
                var msg = 'Analytics ERROR! => ' + str;
                app._logger.log(msg);
                console.error(msg);
                return true;
            }
        };

        NA._convertAmount = function _convertAmount(amount, rate, precision) {
            var multiplier, converted_amount = amount;
            if (amount) {
                precision = _.isNumber(precision) && precision >= 0 && precision < 5 ? precision : 2;
                rate = parseFloat(rate);
                rate = (rate === 0) ? 0 : (rate || 1);
                multiplier = NA.CONST.MULTIPLIERS[precision];
                converted_amount = Math.round(parseInt(amount * (rate * (multiplier * NA.CONST.EXTRA_MULTIPLIER)) + NA.CONST.EPSILON) / NA.CONST.EXTRA_MULTIPLIER) / multiplier;
            }
            return converted_amount;
        };
        NA._calcAmountInUSD = function (amount, currency) {
            return NA._convertAmount(amount, NA.cfg.ratesToUSD[currency || app.lastSelectedCurrency], 2);
        };
        NA._loadIframe = function () {
            var deferred = new $.Deferred();
            if (NA._g.iframe) {
                deferred.resolve(NA._g.iframe);
            } else {
                $(window).on('load', function () {
                    var myOrigin =  document.location.origin;
                    var baseUrl = (NA.cfg.env === "production" || NA.cfg.env === "integration") ? app.config.templateResourcesPath + NA.cfg.url : NA.cfg.default_url;
                    var src = (NA.cfg.env === NA.CONST.FAKE_ENV) ? "about:blank" : baseUrl + "?origin=" + encodeURIComponent(myOrigin);
                    NA._g.ifameOrigin = (function () {var a = document.createElement("a");a.href = baseUrl;return a.origin;})();
                    if (document.getElementById('amp_iframe')) {
                        $('#amp_iframe').attr('src', src);
                    } else {
                        $(document.head).append('<iframe id="amp_iframe" src="' + src + '"></iframe>');
                    }
                    NA._g.iframe = document.getElementById('amp_iframe');
                    deferred.resolve(NA._g.iframe);
                });
            }
            return deferred.promise();
        };
        NA._logEvent = function (data) {
            if (data) {
                NA._g.evtQueue.push(data);
                NA._execNext();
            }
        };
        NA._execNext = function () {
            if (NA._g.iframe && NA._g.isReady && NA._g.evtQueue[0]) {
                var ev = NA._g.evtQueue.shift();
                if (NA.cfg.env === NA.CONST.FAKE_ENV) {
                    console.log("EVENT >>", ev.event_type, ">> \n" + JSON.stringify(ev));
                } else {
                    NA._g.iframe.contentWindow.postMessage(JSON.stringify(ev), NA._g.ifameOrigin);
                }
                NA._execNext();
            }
        };
        NA._onMessage = function (event) {
            var origin = event.originalEvent.origin;
            var data = event.originalEvent.data;
            if (origin === NA._g.ifameOrigin && data === 'AMP Ready') {
                NA._onIframeReady();
            }
        };
        NA._onIframeReady = function () {
            NA._g.isReady = true;
            NA._g.iframeStatus = NA.CONST.STATUS.LOAD_SUCCESS;
            NA._execNext();
        };
        NA._addEvtHeaders = function (event) {
            if (event) {
                event.channel = "amplitude";
                event.user_id = (NA.cfg.msid + '.' + NA.cfg.userId);
                event.timestamp = (new Date()).getTime();
                event.session_id = app.config.ssid;
            }
            return event;
        };
        NA._addUserInfo = function (event) {
            event || (event = {});
            event.user_properties = {
                site_id: NA.cfg.msid,
                country: app.config.wd_country,
                client_id: NA.cfg.clientId,
                environment: NA.cfg.env,
                merchant_id: NA.cfg.mid,
                merchant_name: NA.cfg.merchantName,
                merchant_site: NA.cfg.siteName,
                is_pt_merchant: !!app.config.ptRequestId,
                multi_client_id: NA.cfg.multiClientId,
                user_session_id: app.config.ssid
            };
            return event;
        };
        NA._addPmInfo = function (event_props, pmName, isUpo, position) {
            position || (position = {});
            event_props || (event_props = {});
            event_props.pm = pmName;
            event_props.is_upo = isUpo;
            event_props.absolute_position = position.absolute;
            event_props.relative_position = position.relative;
            return event_props;
        };
        NA._extractPmNames = function (pmArr, type) {
            var key = type === 'pm' ? 'value' : 'paymentOptionName';
            var ret = _.reduce(pmArr, function (result, item) {
                result.push(item[key]);
                return result;
            }, [])
            return ret;
        };

        NA._getPageLoadData = function (upm, pm) {
            var pendingWdReqList = NA._getPendingWdPmNameList();
            var event_props = {
                wd_payment_methods          : NA._extractPmNames(pm, 'pm'),
                wd_upos                     : NA._extractPmNames(upm, 'upm'),
                language                    : app.config.merchantLocale,
                wd_first_pm                 : (pm && pm[0] && pm[0].value || "None"),
                wd_first_upo                : (upm && upm[0] && upm[0].paymentOptionName || "None"),
                wd_allow_open_amount        : !!app.config.wd_open_amount,
                show_pending_wd             : app.config.layout || '2',
                wd_allow_suggested_amounts  : NA.cfg.allowSuggestedAmounts,
                wd_allow_non_deposit_pm     : NA.cfg.allowNonDepositedPM,
                wd_allow_partial_approval   : NA.cfg.allowPartialApproval,
                allow_net_deposit           : NA.cfg.useNetDeposit,
                net_deposit_split_screen    : NA.cfg.netDepositSplitScreen,
                wd_mode                     : NA.cfg.wdMode,
                pending_wd_requests         : pendingWdReqList,
                number_pending_wd_requests  : pendingWdReqList.length,
                allow_dual_brand            : app.config.useDualCardBrands,
                made_successful_deposit     : NA.cfg.made_successful_deposit
            };

            return event_props;
        };

        NA._sendEventWithAmount = function (event_type, amount, currency, event_props, includeUserInfo) {
            currency || (currency = app.lastSelectedCurrency);
            event_props || (event_props = {});
            event_props.wd_amount = amount;
            event_props.wd_currency = currency;
            event_props.wd_amount_usd = NA._calcAmountInUSD(amount, currency);
            event_props.$price = event_props.wd_amount_usd;
            var evt = {
                event_type: event_type,
                event_properties: event_props
            };
            NA._logEvent(NA._addEvtHeaders(includeUserInfo ? NA._addUserInfo(evt) : evt));
            NA._g.last.sent_amount = amount;
            NA._g.last.sent_currency = currency;
            return event_props;
        };

        NA._getPendingWdPmNameList = function() {
            var pendingWdReqList = [];
            _.forEach(app.stores.withdraw_requests.toJSON(), function(wdReq) {
                if (wdReq.status.toUpperCase() === "PENDING" && wdReq.params && wdReq.params.poName) {
                    pendingWdReqList.push(wdReq.params.poName);
                }
                else if (wdReq.status.toUpperCase() === "PENDING" && wdReq.orders && wdReq.orders.length) {
                    // if there is no params in wdReq we need to take the poName from the first orders item
                    pendingWdReqList.push(wdReq.orders[0].poName);
                }
            });
            return pendingWdReqList;
        };

        NA._getSubmitData = function() {
            var event_props = {
                wd_absolute_position: app.lastSelectedMethodData.pmPosition && app.lastSelectedMethodData.pmPosition.absolute,
                card_brand: app.lastCardDetected === 'none' ? 'None' : app.lastCardDetected
            };

            if (app.util.isUpo(app.lastSelectedMethodId)) {
                event_props.wd_pm = app.current_pm_name;
                event_props.wd_pm_type = app._upoList[app.lastSelectedMethodId].apmGwType || 'None';
                event_props.is_wd_upo = true;
                event_props.upo_id = app.lastSelectedMethodId.toString();
            }
            else {
                event_props.wd_pm = app.lastSelectedMethodId;
                event_props.wd_pm_type = app._poList[app.lastSelectedMethodId].apmGwType || 'None';
                event_props.is_wd_upo = false;
                event_props.upo_id = 'None';
            }

            return event_props;
        };

        NA._sendCancelPendingWdData = function(reqId) {
            var pendingWdObj = findPendingWd(reqId);
            var position = pendingWdObj.position;
            var pendingWd = pendingWdObj.request;
            var event_props = {
                wd_request_id: pendingWd.id,
                wd_pm: pendingWd.attributes.params && pendingWd.attributes.params.poName,
                card_brand: (pendingWd.attributes.params && pendingWd.attributes.params.card_type) || 'None',
                wd_absolute_position: position
            };

            if (app.config.ptRequestId) {
                event_props.upo_id = pendingWd.attributes.orders.length && pendingWd.attributes.orders[0].upoId ? pendingWd.attributes.orders[0].upoId : '';
            }
            else {
                event_props.upo_id = pendingWd.attributes.upo_id
            }

            var amount = pendingWd.attributes.requestedAmount;
            event_props.wd_amount = amount;
            event_props.wd_currency = pendingWd.attributes.requestedCurrency;
            event_props.wd_amount_usd = NA._calcAmountInUSD(amount, pendingWd.attributes.requestedCurrency);
            event_props.$price = event_props.wd_amount_usd;
            var evt = {
                event_type: NA.CONST.EVENT_NAME.CANCEL_PENDING_WD,
                event_properties: event_props
            };

            NA._logEvent(NA._addEvtHeaders(evt));

            function findPendingWd(reqId) {
                for (var i = 0; i < app.stores.withdraw_requests.models.length; i++) {
                    if (app.stores.withdraw_requests.models[i].id == reqId) {
                        return {request: app.stores.withdraw_requests.models[i], position: i + 1};
                    }
                }
            }
        }

        NA._sendUpoRemovalChoice = function(data) {
            var event_props = {};
            event_props.upo_id = data.upoId;
            event_props.wd_pm = data.pmName;
            event_props.wd_absolute_position = NA._g.last.select_pm_info.upo_id === data.upoId.toString() ? NA._g.last.select_pm_info.wd_absolute_position : "1";
            event_props.selected_action = data.action;
            NA._sendEventWithAmount(NA.CONST.EVENT_NAME.UPO_REMOVAL_CHOSEN, app.config.wd_amount, null, event_props, true);
        };

        NA._registerPubsubEvents = function () {
            // Page Load
            var pms = [];
            var isPmAvailable = false;
            var isWdAvailable = false;

            pubsub.subscribe('user-pm-available', function(upm) {
                if (app.config.hideMerchantPM) {
                    isPmAvailable = true;
                    sendPageLoadEventIfDataIsReady();
                }
            });

            pubsub.subscribe('pm-available', function(pm) {
                isPmAvailable = true;
                pms = pm;
                sendPageLoadEventIfDataIsReady();
            });

            pubsub.subscribe('withdraws-available', function(wdRequests) {
                isWdAvailable = true;
                sendPageLoadEventIfDataIsReady();
            });

            function sendPageLoadEventIfDataIsReady() {
                if (!NA._g.flag.dataReadySentOnce && isPmAvailable && isWdAvailable) {
                    NA._sendEventWithAmount(NA.CONST.EVENT_NAME.PAGE_LOAD, app.config.wd_amount, app.config.wd_currency, NA._getPageLoadData(app._userPmAvailableData, pms), true);
                    NA._g.flag.dataReadySentOnce = true;
                }
            }
            // Page Load END

            pubsub.subscribe('app.event.WithdrawClicked', function(data) {
                NA._sendEventWithAmount(NA.CONST.EVENT_NAME.SUBMIT_SUCCESS, app.config.wd_amount, app.config.wd_currency, NA._getSubmitData(), false);
            });

            pubsub.subscribe('withdraw-cancel', function(req) {
                NA._sendCancelPendingWdData(req.id);
            });

            pubsub.subscribe('select-pm', function (data, arg2, arg3, manual) {
                if (_.isUndefined(manual) || manual) {
                    var event_props = {};
                    var isUpo = app.util.isUpo(data.uniqueId);
                    event_props.wd_absolute_position = data.pmPosition && data.pmPosition.absolute,
                    event_props.is_wd_upo = isUpo;
                    event_props.wd_pm = isUpo ? data.name : data.uniqueId;
                    event_props.wd_pm_type = (isUpo ? (app._upoList[data.uniqueId] && app._upoList[data.uniqueId].apmGwType) : (app._poList[data.uniqueId] && app._poList[data.uniqueId].apmGwType)) || "None";
                    event_props.upo_id = isUpo ? data.uniqueId.toString() : 'None';
                    NA._g.last.select_pm_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.CHANGE_PM, app.config.wd_amount, app.config.wd_currency, event_props, true);
                }
            });

            if (app.config.useSubpages && !app.config.preventPMAutoSelect) {
                // This if for the initial method that is preselected on page load
                pubsub.subscribe('select-pm-attempt', function (data) {
                    if (data && data.reason === "already_selected") {
                        var lastSentPmId = NA._g.last.select_pm_info.is_wd_upo ? NA._g.last.select_pm_info.upo_id : NA._g.last.select_pm_info.wd_pm;
                        if (!lastSentPmId || data.uniqueId != lastSentPmId) {
                            var event_props = {};
                            var isUpo = app.util.isUpo(data.uniqueId);
                            event_props.wd_absolute_position = "1",
                            event_props.is_wd_upo = isUpo;
                            event_props.wd_pm = isUpo ? app._upoList[data.uniqueId].paymentOptionName : data.uniqueId.toString();
                            event_props.wd_pm_type = (isUpo ? (app._upoList[data.uniqueId] && app._upoList[data.uniqueId].apmGwType) : (app._poList[data.uniqueId] && app._poList[data.uniqueId].apmGwType)) || "None";
                            event_props.upo_id = isUpo ? data.uniqueId.toString() : 'None';
                            NA._g.last.select_pm_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.CHANGE_PM, app.config.wd_amount, app.config.wd_currency, event_props, true);
                        }
                    }
                });
            }
            pubsub.subscribe('app.event.changeDualBrandedCardBrand', function(data) {
                var event_props = {
                    selected_brand: data.selectedBrand,
                    payment_method: data.pmType,
                    upo_id: (data.isUpo ? data.uniqueId : null),
                    is_upo: data.isUpo
                };
                NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.CHANGE_BRAND, event_properties: event_props}));
            });
            pubsub.subscribe('suggest-point-selected', function (data) {
                var event_props = {};
                NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_SUGGESTED, data['selectedValue'], null, event_props, true);
                NA._g.last.keyup_amount = false;
                NA._g.last.changed_amount = data['selectedValue'];
            });

            pubsub.subscribe('app.event.AmountChange', function (amount, ev_type) {
                if (ev_type === "setValue") {
                    if (NA._g.last.keyup_amount) {
                        NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_TYPED, NA._g.last.keyup_amount, null, {}, true);
                    }
                    NA._g.last.setValue_amount = amount;
                    NA._g.last.keyup_amount = false;
                } else if (ev_type === "change") {
                    var isFakeChangeEvt = (NA._g.last.setValue_amount && NA._g.last.setValue_amount == amount);
                    if (!isFakeChangeEvt && (amount || amount === 0)) {
                        NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_TYPED, amount, null, {}, true);
                        NA._g.last.setValue_amount = false;
                        NA._g.last.keyup_amount = false;
                        NA._g.last.changed_amount = amount;
                    }
                } else if (ev_type === 'keyup' || ev_type === 'maskedAmountUserInput') {
                    NA._g.last.setValue_amount = false;
                    NA._g.last.keyup_amount = amount;
                }
            });

            pubsub.subscribe('app.event.removeUpoClicked', function(data) {
                var event_props = {};
                event_props.upo_id = data.id.toString();
                event_props.wd_pm = data.pmType;
                event_props.wd_absolute_position = NA._g.last.select_pm_info.upo_id === event_props.upo_id ? NA._g.last.select_pm_info.wd_absolute_position : "1";
                NA._sendEventWithAmount(NA.CONST.EVENT_NAME.UPO_REMOVAL_CLICKED, app.config.wd_amount, null, event_props, true);
            });

            pubsub.subscribe('app.event.removeUpoConfirm', function(data) {
                NA._sendUpoRemovalChoice(data);
            });

            pubsub.subscribe('app.event.removeUpoCancel', function(data) {
                NA._sendUpoRemovalChoice(data);
            });

            pubsub.subscribe('lightbox.closed', function(data) {
                if (data.type === 'error' || data.type === 'success') {
                    NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.POST_WDR_POPUP, event_properties: {
                        popup_type: data.type
                    }}));
                }
            });
        };
        NA._hasInitError = function (config) {
            var errorMsg;
            if (NA._g.iframe || NA._g.iframeStatus) {
                errorMsg = 'Second Init!';
            } else if (!config) {
                errorMsg = 'Missing configuration!';
            } else if (!window.postMessage) {
                errorMsg = 'window.postMessage is undefined!!!';
            }
            return errorMsg && NA._logError(errorMsg);
        };

        NA.init = function _init(config) {
            if (NA._hasInitError(config)) {
                return;
            }
            NA._g.iframeStatus = NA.CONST.STATUS.LOAD_IN_PROGRESS;
            NA.cfg = $.extend(true, NA.cfg, config);
            $(window).on('message', NA._onMessage);
            NA._registerPubsubEvents();
            NA._loadIframe().then(function () {
                (NA.cfg.env === NA.CONST.FAKE_ENV && setTimeout(function () {
                    console.log("ANALYTICS_FAKE_ENV READY");
                    NA._onIframeReady();
                }, 1000));
                app._logger.log('Analytics INIT! => iframe created');
            });
        };

        return {
            init: NA.init,
            calcAmountInUSD: NA._calcAmountInUSD,
            updateUSDExchangeRates: NA.updateExchangeRates,
            sendEvent: function (event_type, event_properties) {
                if (app.config.useAnalytics && NA._g.iframeStatus && event_type && event_properties) {
                    NA._logEvent(NA._addEvtHeaders({event_type: event_type, event_properties: event_properties}));
                    return true;
                }
            }
        };
    })(jQuery, pubsub, _);

    var recalcUserDetailsArea = function () {
        var scrollable = {};
        scrollable.elm = $('[data-plugin="scrollable"]');

        var getHeightOfReduceElms = function (ids) {
            var totalHeight = 0;
            if (ids === '') {
                return totalHeight;
            }
            var reduceIds = ids.split(' ');
            _.each(reduceIds, function (elmId) {
                var elm = $('#' + elmId);
                if (elm.length === 1) {
                    var opt = (elm.css('display') !== "table-row");
                    /* Fix Firefox behaviour */
                    totalHeight += parseInt(elm.outerHeight(opt) || 0);
                }
            });
            return totalHeight;
        };
        scrollable.otherFixedHeight = parseInt(scrollable.elm.attr('data-reduce_height') || 0);
        scrollable.otherFixedHeight += getHeightOfReduceElms(scrollable.elm.attr('data-reduce_by_id') || '');
        var detailsHeight = viewportSize.getHeight() - scrollable.otherFixedHeight;
        var childContHeight = $('[data-plugin="scrollable"] > div').outerHeight(true);
        if (!scrollable.elm.attr('data-height_floatable') || (childContHeight > detailsHeight)) {
            scrollable.elm.css('height', detailsHeight + 'px');
        } else {
            scrollable.elm.css('height', childContHeight + 'px');
        }
        if (childContHeight > detailsHeight) {
            if (scrollable.elm.length && !app.scroller) {
	            var scrollOpt = $.extend(true,{} , {
		            scrollX               : false,
		            scrollY               : true,
		            mouseWheel            : true,
		            scrollbars            : true,
		            interactiveScrollbars : true,
		            shrinkScrollbars      : 'scale'
	            }, app && app.pluginOpts && app.pluginOpts.Scrollable || {});
                app.scroller = new IScroll('[data-plugin="scrollable"]', scrollOpt);
            }
        } else {
            if (app.scroller && app.scroller.destroy) {
                app.scroller.scrollTo(0, 0, 0);
                app.scroller.destroy();
                delete app.scroller;
            }
        }

        if (app.scroller && app.scroller.refresh) {
            app.scroller.refresh();
        }
    };

    app.recalcUserDetailsArea = recalcUserDetailsArea;

    app.util.showPaymentMethodHint = function (pmName, pmHintContainer) {
        var cfg = app.config.pmHintConfig;
        var pmHint = app.locale.pm_hint[pmName] || "";
        var isUpo = app.util.isUpo(app.lastSelectedMethodId);

        if (isUpo && app.locale.pm_hint.hasOwnProperty("upm_" + pmName)) {
            pmHint = app.locale.pm_hint["upm_" + pmName] || "";
        }

        $('[data-role="pm_hint"]').remove();
        if (pmHint && cfg) {
            var tpl = '<div class="pm-hint"><%= hint%></div>';
            var custom_tpl = $('#pm_hint_template');
            pmHintContainer = pmHintContainer ? $(pmHintContainer) : $('.PMINFO').parent();
            if (custom_tpl.length) {
                tpl = custom_tpl.text();
            }
            var $html = $(_.template(tpl)({hint: pmHint})).attr('data-role', 'pm_hint');
            if ('ALL' === cfg.topRenderExeption[0] || cfg.topRenderExeption.indexOf(pmName) > -1) {
                pmHintContainer.prepend($html);
            } else {
                pmHintContainer.append($html);
            }
            recalcUserDetailsArea();
        }
    };

    var dynamicFields = (function() {
        function init(pmName) {
            var config = (app.config.pmSettings[pmName] || {}).dynamicFields || {};
            var fieldName = config.dropdown;

            if (fieldName) {
                $("#" + fieldName)
                    .off("change", updateMethodFields)
                    .on("change", updateMethodFields);

                updateMethodFields.call($("#" + fieldName).get(0));
            }
        }

        function isEnabled(pmName, pmType) {
            var settings = app.config.pmSettings[pmName];

            if (settings && settings.dynamicFields && settings.dynamicFields[pmType + "Enabled"]) {
                return true;
            }

            return false;
        }

        function showFields(fieldNames) {
            var $fieldsToShow = $();
    
            fieldNames = fieldNames || [];
    
            fieldNames.forEach(function(fieldId) {
                app._doNotSubmitFields[fieldId] = false;
                $fieldsToShow = $fieldsToShow.add("#" + fieldId);
            });
    
            $fieldsToShow
                .closest(".row")
                .removeClass("hidden");
        }
    
        function hideFields(fieldNames) {
            var $fieldsToHide = $();
    
            fieldNames = fieldNames || [];
    
            fieldNames.forEach(function(fieldId) {
                app._doNotSubmitFields[fieldId] = true;
                $fieldsToHide = $fieldsToHide.add("#" + fieldId);
            });
    
            $fieldsToHide
                .closest(".row")
                .addClass("hidden");
        }

        function updateMethodFields() {
            var $dropdown = $(this);
            handleRequiredFields(app.current_pm_name, $dropdown.val(), $dropdown.attr("id"));
    
            var isValid = app.validateInput();
            recalcUserDetailsArea();
            $('button.withdraw').attr('disabled', !isValid);
        }
    
        function handleRequiredFields(pmName, value, dropdownFieldId) {
            var availableFields = Object.keys(app.currentMethodFields),
                requiredFields = [],
                fieldsToHide = [],
                fieldsToShow = [],
                alwaysVisibleFields = [],
                dropDownOptions = (app.currentMethodFields[dropdownFieldId] || {}).dropDownOptions;
    
            if (!dropDownOptions) {
                return;
            }

            requiredFields = (app.util.findOptionByValue(dropDownOptions, value) || {}).requiredFields || [];

            if (app.config.pmSettings[pmName] && app.config.pmSettings[pmName].dynamicFields) {
                alwaysVisibleFields = app.config.pmSettings[pmName].dynamicFields.alwaysVisibleFields
                requiredFields = requiredFields.concat(alwaysVisibleFields);
            }

            requiredFields = requiredFields.concat([dropdownFieldId]);
    
            for (var i = 0; i < availableFields.length; i++) {
                if (app.currentMethodFields[availableFields[i]].visibilityMode !== CONSTANTS.VISIBILITY_MODE.HIDDEN) {
                    if (requiredFields.indexOf(availableFields[i]) < 0) {
                        fieldsToHide.push(availableFields[i]);
                    } else {
                        fieldsToShow.push(availableFields[i]);
                    }
                }
            }
    
            hideFields(fieldsToHide);
            showFields(fieldsToShow);

            pubsub.publish("app.event.dynamicFieldsChanged", [fieldsToHide, fieldsToShow]);
        }

        return {
            init: init,
            isEnabled: isEnabled,
            showFields: showFields,
            hideFields: hideFields
        };
    })();

    recalcUserDetailsArea();
    $(window).resize(recalcUserDetailsArea);

})(window);